import React, { useRef } from "react";
import { useInView } from "framer-motion";

import "./svgFile.css";

const CoreNetworkSVG = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  return (
    <section ref={ref}>
      {isInView ? (
        <div style={{
          opacity: isInView ? 1 : 0,
          transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        }}>
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1280 670"
            style={{ enableBackground: "new 0 0 1280 670" }}
            xmlSpace="preserve"
          >
            <polygon
              className="st0 city-background"
              points="905.2,364.6 893.9,364.6 893.9,379 879.2,379 879.2,311.3 874,311.3 866.5,303.7 856.8,303.7 
849.1,311.4 844.4,311.4 844.4,379 827,379 827,400.8 813.8,400.8 813.8,339.9 807.6,339.9 807.6,350 804.7,350 804.7,361.3 
801.6,361.3 801.6,400.8 796.9,400.8 796.9,350.3 792.9,350.3 792.9,277.6 781.2,277.6 781.2,273.9 767.9,273.9 767.9,277.6 
764.5,277.6 764.5,350.3 759.8,350.3 759.8,375.4 743,375.4 743,395.4 728.2,395.4 728.2,363 705.5,363 705.5,268.7 700.9,268.7 
700.9,264.7 673.7,264.7 655,279.5 655,343.2 637.6,343.2 632.6,348.2 632.6,354.1 635,354.1 635,389.3 627,389.3 627,378.9 
610.2,378.9 610.2,288.6 579.3,288.6 570.5,297.4 570.5,307.9 574.7,307.9 574.7,370.4 560.5,370.4 560.5,351.8 525.3,351.8 
525.3,370 486.5,370 486.5,311.4 479.9,311.4 470.5,301.9 458.2,301.9 448.5,311.6 442.6,311.6 442.6,370 440.9,370 440.9,397.4 
436.5,397.4 436.5,357 428.6,357 428.6,369.8 425,369.8 425,384 421,384 421,397.4 402.9,397.4 402.9,362.9 362.1,362.9 
360.6,362.9 360.6,413.7 610.2,413.7 673.7,413.7 712,413.7 905.2,413.7 "
            />
            <g>
              <rect x="0" y="413.7" class="st1" width="1293.4" height="19.4" />
              <g>
                {/* <image style={{"overflow":"visible"}} width="1440" height="96" xlinkHref="4B46F7F68BA86F73.png"  transform="matrix(1 0 0 1 -80 369)">
  </image> */}
              </g>
              <path
                className="st2 blue-slide"
                d="M1318.6,421.3H858.5v-10.1c0-1.2-1-2.2-2.2-2.2s-2.2,1-2.2,2.2v10.1H554.6v-10.1c0-1.2-1-2.2-2.2-2.2
          c-1.2,0-2.2,1-2.2,2.2v10.1h-182v-10.1c0-1.2-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2v10.1H-37.6c-1.2,0-2.2,1-2.2,2.2s1,2.2,2.2,2.2
          h1356.3c1.2,0,2.2-1,2.2-2.2S1319.8,421.3,1318.6,421.3z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M772.4,266.9c-0.6-0.6-0.9-1.3-0.9-2.2c0-0.9,0.3-1.6,0.9-2.2c-0.1-0.1-0.1-0.1-0.2-0.2
  c-1.4,1.3-1.3,3.6,0,4.8C772.3,267,772.4,266.9,772.4,266.9z"
              />
              <path
                class="st0"
                d="M777,266.9c0.1,0.1,0.1,0.1,0.2,0.2c1.4-1.3,1.3-3.5,0-4.8c-0.1,0.1-0.1,0.1-0.2,0.2c0.6,0.6,0.9,1.3,0.9,2.2
  C777.9,265.5,777.6,266.3,777,266.9z"
              />
              <path
                class="st0"
                d="M772.8,266.5c0.1-0.1,0.1-0.1,0.2-0.2c-0.4-0.5-0.7-1-0.7-1.6c0-0.6,0.2-1.2,0.7-1.6c-0.1-0.1-0.1-0.1-0.2-0.2
  C771.8,263.8,771.8,265.5,772.8,266.5z"
              />
              <path
                class="st0"
                d="M776.4,266.3c0.1,0.1,0.1,0.1,0.2,0.2c1.1-1,1-2.8,0-3.6c-0.1,0.1-0.1,0.1-0.2,0.2
  C777.3,263.9,777.3,265.4,776.4,266.3z"
              />
              <path
                class="st0"
                d="M776,265.9c0.8-0.7,0.7-2,0-2.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.3,0.5,0.7,0.5,1.1c0,0.4-0.2,0.8-0.5,1.1
  C775.9,265.8,776,265.9,776,265.9z"
              />
              <path
                class="st0"
                d="M773.4,265.9c0.1-0.1,0.1-0.1,0.2-0.2c-0.6-0.7-0.6-1.5,0-2.2c-0.1-0.1-0.1-0.1-0.2-0.2
  C772.6,264.1,772.7,265.3,773.4,265.9z"
              />
              <path
                class="st0"
                d="M777.7,273.6l-2.3-8.6c0.1-0.1,0.2-0.3,0.2-0.5c0-0.5-0.4-0.8-0.9-0.8c-0.5,0-0.9,0.4-0.9,0.8
  c0,0.2,0.1,0.3,0.2,0.5l-0.9,3.2c0,0,0,0,0,0c0,0,0,0,0,0l-0.6,2.3c0,0,0,0,0,0c0,0,0,0,0,0l-0.8,3.1H770v0.4h9.4v-0.4H777.7z
   M774.7,265.3c0.1,0,0.3,0,0.4-0.1l0.2,0.6h-1.1l0.2-0.6C774.4,265.3,774.6,265.3,774.7,265.3z M775.7,267.6l-0.7-0.8l0.4-0.4
  L775.7,267.6z M773.3,270.3l1.4-0.9l1.4,0.9H773.3z M775.9,270.7l-1.2,0.6l-1.2-0.6H775.9z M776.6,270.7l0.4,1.6l-1.9-0.9
  L776.6,270.7z M775,269.1l0.9-0.6l0.4,1.5L775,269.1z M773.8,268l0.9-1l0.9,1H773.8z M775.5,268.4l-0.8,0.5l-0.8-0.5H775.5z
   M774.7,266.5l-0.3-0.4h0.7L774.7,266.5z M774,266.3l0.4,0.4l-0.7,0.8L774,266.3z M773.4,268.5l0.9,0.6L773,270L773.4,268.5z
   M772.8,270.7l1.4,0.7l-1.9,0.9L772.8,270.7z M772.9,272.5l1.8-0.9l1.8,0.9l-1.8,0L772.9,272.5z M774.7,264c0.3,0,0.5,0.2,0.5,0.5
  s-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5S774.4,264,774.7,264z M772.3,272.9l2.4,0l2.4,0l0.2,0.7h-5.3L772.3,272.9z"
              />
            </g>
            <text
              transform="matrix(1 0 0 1 546.9155 248.811)"
              className="st1 st3 st4"
            >
              {/* core network */}
              <tspan class="letter1">C</tspan>
              <tspan class="letter2">o</tspan>
              <tspan class="letter3">r</tspan>
              <tspan class="letter4">e</tspan>
              &nbsp;
              <tspan class="letter5">N</tspan>
              <tspan class="letter6">e</tspan>
              <tspan class="letter7">t</tspan>
              <tspan class="letter8">w</tspan>
              <tspan class="letter9">o</tspan>
              <tspan class="letter10">r</tspan>
              <tspan class="letter11">k</tspan>
            </text>
            <text
              transform="matrix(1 0 0 1 250.3086 38.4517)"
              className="cn-text-top"
            >
              <tspan x="0" y="0" class="st1 st5 st6">
                {/* macro cell towers */}
                <tspan class="letter1">M</tspan>
                <tspan class="letter2">a</tspan>
                <tspan class="letter3">c</tspan>
                <tspan class="letter4">r</tspan>
                <tspan class="letter5">o</tspan>
              </tspan>
              <tspan x="-22.6" y="16.5" class="st1 st5 st6">
                <tspan class="letter6">C</tspan>
                <tspan class="letter7">e</tspan>
                <tspan class="letter8">l</tspan>
                <tspan class="letter9">l</tspan>
                &nbsp;
                <tspan class="letter10">T</tspan>
                <tspan class="letter11">o</tspan>
                <tspan class="letter12">w</tspan>
                <tspan class="letter13">e</tspan>
                <tspan class="letter14">r</tspan>
                <tspan class="letter15">s</tspan>
              </tspan>
            </text>
            <text
              transform="matrix(1 0 0 1 339.3945 631.4512)"
              className="st1 st5 st6 typewriterText"
            >
              {/* Outdoor DAS */}
              <tspan class="letter1">O</tspan>
              <tspan class="letter2">u</tspan>
              <tspan class="letter3">t</tspan>
              <tspan class="letter4">d</tspan>
              <tspan class="letter5">o</tspan>
              <tspan class="letter6">o</tspan>
              <tspan class="letter7">r</tspan>
              &nbsp;
              <tspan class="letter8">D</tspan>
              <tspan class="letter9">A</tspan>
              <tspan class="letter10">S</tspan>
            </text>
            <text transform="matrix(1 0 0 1 491.9287 38.4517)">
              <tspan x="0" y="0" class="st1 st5 st6">
                {/* fiber networks */}
                <tspan class="letter1">F</tspan>
                <tspan class="letter2">i</tspan>
                <tspan class="letter3">b</tspan>
                <tspan class="letter4">e</tspan>
                <tspan class="letter5">r</tspan>
              </tspan>
              <tspan x="-17.7" y="16.5" class="st1 st5 st6">
                <tspan class="letter6">N</tspan>
                <tspan class="letter7">e</tspan>
                <tspan class="letter8">t</tspan>
                <tspan class="letter9">w</tspan>
                <tspan class="letter10">o</tspan>
                <tspan class="letter11">r</tspan>
                <tspan class="letter12">k</tspan>
                <tspan class="letter13">s</tspan>
              </tspan>
            </text>
            <text
              transform="matrix(1 0 0 1 822.7305 631.4521)"
              className="st1 st5 st6 typewriterText"
            >
              {/* Indoor DAS */}
              <tspan class="letter1">I</tspan>
              <tspan class="letter2">n</tspan>
              <tspan class="letter3">d</tspan>
              <tspan class="letter4">o</tspan>
              <tspan class="letter5">o</tspan>
              <tspan class="letter6">r</tspan>
              &nbsp;
              <tspan class="letter7">D</tspan>
              <tspan class="letter8">A</tspan>
              <tspan class="letter9">S</tspan>
            </text>
            <text transform="matrix(1 0 0 1 955.3506 39.1426)">
              <tspan x="0" y="0" class="st1 st5 st6">
                {/* Rooftop */}
                <tspan class="letter1">R</tspan>
                <tspan class="letter2">o</tspan>
                <tspan class="letter3">o</tspan>
                <tspan class="letter4">f</tspan>
                <tspan class="letter5">t</tspan>
                <tspan class="letter6">o</tspan>
                <tspan class="letter7">p</tspan>
              </tspan>

              <tspan x="-14.1" y="16.5" class="st1 st5 st6">
                {/* Cell Towers */}
                <tspan class="letter8">C</tspan>
                <tspan class="letter9">e</tspan>
                <tspan class="letter10">l</tspan>
                <tspan class="letter11">l</tspan>
                &nbsp;
                <tspan class="letter12">T</tspan>
                <tspan class="letter13">o</tspan>
                <tspan class="letter14">w</tspan>
                <tspan class="letter15">e</tspan>
                <tspan class="letter16">r</tspan>
                <tspan class="letter17">s</tspan>
              </tspan>
            </text>
            <text
              transform="matrix(1 0 0 1 699.0615 43.8535)"
              class="st1 st5 st6"
            >
              {/* Data Centers */}
              <tspan class="letter1">D</tspan>
              <tspan class="letter2">a</tspan>
              <tspan class="letter3">t</tspan>
              <tspan class="letter4">a</tspan>
              &nbsp;
              <tspan class="letter5">C</tspan>
              <tspan class="letter6">e</tspan>
              <tspan class="letter7">n</tspan>
              <tspan class="letter8">t</tspan>
              <tspan class="letter9">e</tspan>
              <tspan class="letter10">r</tspan>
              <tspan class="letter11">s</tspan>
            </text>
            <text
              transform="matrix(1 0 0 1 587.7549 631.4531)"
              class="st1 st5 st6"
            >
              {/* Small Cells */}
              <tspan class="letter1">S</tspan>
              <tspan class="letter2">m</tspan>
              <tspan class="letter3">a</tspan>
              <tspan class="letter4">l</tspan>
              <tspan class="letter5">l</tspan>
              &nbsp;
              <tspan class="letter6">C</tspan>
              <tspan class="letter7">e</tspan>
              <tspan class="letter8">l</tspan>
              <tspan class="letter9">l</tspan>
              <tspan class="letter10">s</tspan>
            </text>
            {/* <g>
        <g className="dotted-line-up">
          <polyline
            class="st7"
            points="389.2,472.3 389.2,398.6 320.7,398.6 		"
          />
          <g>
            <polygon
              class="st8"
              points="322.2,393.7 313.5,398.6 322.2,403.6 			"
            />
          </g>
        </g>
      </g>
      <g>
        <g className="dotted-line-down">
          <polyline
            className="st7 "
            points="270.3,207 270.3,337.1 391.3,337.1 		"
          />
          <g>
            <polygon
              class="st8"
              points="389.8,342.1 398.4,337.1 389.8,332.1 			"
            />
          </g>
        </g>
      </g>
      <g>
        <g className="dotted-line-down">
          <polyline
            class="st7"
            points="508.2,207 508.2,301.2 552.1,301.2 552.1,401.8 		"
          />
          <g>
            <polygon
              class="st8"
              points="547.1,400.3 552.1,409 557.1,400.3 			"
            />
          </g>
        </g>
      </g> */}
            {/* <g>
        <g className="dotted-line-up">
          <line class="st7" x1="865" y1="472.3" x2="865" y2="329.3" />
          <g>
            <polygon class="st8" points="869.9,330.8 865,322.1 860,330.8 			" />
          </g>
        </g>
      </g> */}
            <g>
              <path
                className="st9 city-front"
                d="M918.3,392.6H811v0.1h-6.6v-26.5h-28.2v13.4h-14.6v-47.8h-26.9v16.2h-9.2v-5.7h-11.1v5.7h-5.4v34.5h-11.4v6.6
  l-5.7,5.7h-9.2v-4.2h-7.2v-16.9H672v-17.8h-2.9v-35h-17.6v34.8h-4.7V342h-9.5l-5.2-5.2v-6h-5v6.7h-9.5v16.9h-4.1v-6.8h-2v7h-3.4
  v42.5h-5.2v-21h-16.2l-8.3,10.1h-22.2v-45.9h-6v-17.1h-12l-6.6-6.6v-7.6h-6.3v8.4h-12v21.4H511v-8.5h-2.6v8.8h-6.9v53.5H495v-21.2
  h-28.2v8.1h-14.6v-24.5h-26.9v16.2h-9.2v-5.7h-5.7V350h0.5v1.8h0.3v-0.3h0.2v1.6h0.6v0.1h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6
  h0.1v-0.1h-0.3V353h0.6v-3.3l0.4-0.1v1.7h0v2.1h0.2v-2.1h0v-1.7l0.4-0.1v0.9h0.3v-0.3h0.2v1.8h0.6v0.1h-0.3v0.1h0.1v0.6h0v-0.6h0.9
  v0.6h0v-0.6h0.1v-0.1h-0.3V352h0.6v-7.2h-0.3v-1.4H416v1.4h-0.1V344h-0.1v0.7h-1.1v1h-0.2v-0.3h-0.3v2.5h-0.4v-2.6h0v-1.3h-0.2v1.3
  h0v2.6h-0.4v-2.2h-0.3v-1.4h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1.2h-0.2v-0.3H411v1.3h-0.5v-8.5h0.5v1.8h0.3V341h0.2v1.6h0.6v0.1
  h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3v-0.1h0.6v-3.3l0.4-0.1v1.7h0v2.1h0.2v-2.1h0v-1.7l0.4-0.1v0.9h0.3v-0.3h0.2
  v1.8h0.6v0.1h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3v-0.1h0.6v-7.2h-0.3v-1.4H416v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1
  h-0.2V335h-0.3v2.5h-0.4v-2.6h0v-1.3h-0.2v1.3h0v2.6h-0.4v-2.2h-0.3V334h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1.2h-0.2v-0.3H411v1.3
  h-0.5v-6.6h-0.2v0.2h-0.6v-0.5h0.1l-0.1-0.5h0.2l0.1-0.6h0.3c0,0,0.1,0,0.1-0.1V329h0.5v1.8h0.3v-0.3h0.2v1.6h0.6v0.1h-0.3v0.1h0.1
  v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3v-0.1h0.6v-3.3l0.4-0.1v1.7h0v2.1h0.2v-2.1h0v-1.7l0.4-0.1v0.9h0.3v-0.3h0.2v1.8h0.6v0.1
  h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3V331h0.6v-7.2h-0.3v-1.4H416v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1h-0.2v-0.3h-0.3
  v2.5h-0.4v-2.6h0v-1.3h-0.2v1.3h0v2.6h-0.4v-2.2h-0.3v-1.4h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1.2h-0.2v-0.3H411v1.3h-1.7v-0.6h-0.1
  v0.6h-0.3v-4.6h-0.1v4.6h-0.3v-0.6h-0.1v0.6h-1.7v-2.2h-0.3v-1.4h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1.2h-0.2v-0.3h-0.3v1.3h-0.7
  v-2.6h0v-1.3h-0.2v1.3h0v2.6H403v-3.2h-0.3v-1.4h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1H401v-0.3h-0.3v5h0.3v-0.3h0.2v1.8h0.6v0.1
  h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3V331h0.6v-2.6l0.7,0.1v1.8h0v2.1h0.2v-2.1h0v-1.8l0.7,0.1v2.1h0.3v-0.3h0.2
  v1.6h0.6v0.1h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3v-0.1h0.6V329h0.6v0.4c0,0,0,0.1,0.1,0.1h0.3l0.1,0.6h0.1v0.2
  l-0.1,0.3h0.1v6.8h-1.3v-2.2h-0.3V334h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1.2h-0.2v-0.3h-0.3v1.3h-0.7v-2.6h0v-1.3h-0.2v1.3h0v2.6
  H403v-3.2h-0.3v-1.4h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1H401V335h-0.3v5h0.3v-0.3h0.2v1.8h0.6v0.1h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6
  h0v-0.6h0.1v-0.1h-0.3v-0.1h0.6v-2.6l0.7,0.1v1.8h0v2.1h0.2v-2.1h0v-1.8l0.7,0.1v2.1h0.3V341h0.2v1.6h0.6v0.1h-0.3v0.1h0.1v0.6h0
  v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3v-0.1h0.6v-3.1h0.6v0.4c0,0,0,0.1,0.1,0.1h0.3l0.1,0.6h0.1v0.2l-0.1,0.3h0.1v6.8h-1.3v-2.2h-0.3
  v-1.4h-0.1v1.4h-0.1v-0.7h-0.1v0.7h-1.1v1.2h-0.2v-0.3h-0.3v1.3h-0.7v-2.6h0v-1.3h-0.2v1.3h0v2.6H403v-3.2h-0.3v-1.4h-0.1v1.4h-0.1
  V344h-0.1v0.7h-1.1v1H401v-0.3h-0.3v5h0.3v-0.3h0.2v1.8h0.6v0.1h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1h-0.3V352h0.6
  v-2.6l0.7,0.1v1.8h0v2.1h0.2v-2.1h0v-1.8l0.7,0.1v2.1h0.3v-0.3h0.2v1.6h0.6v0.1h-0.3v0.1h0.1v0.6h0v-0.6h0.9v0.6h0v-0.6h0.1v-0.1
  h-0.3V353h0.6V350h0.6v0.4c0,0,0,0.1,0.1,0.1h0.3l0.1,0.6h0.1v0.2l-0.1,0.3h0.1v14h-3v5.7h-5.4v11.2h-11.4v6.6l-5.7,5.7h-9.2v-4.2
  h-7.2v-16.9h-3.6v-17.8h-2v4.3h-17.2v29.1h-11.5v-2.7h3.2v-4.8h-16.7v4.8h3.2v2.7h-13.9v-2.7h3.2v-4.8h-16.7v4.8h3.2v2.7h-10.8v3.7
  h-1.4H283v11.5h2.3v-2.8h1.4v5.9h-5.1l-2.3,6.4h7.4h35.6h21h17.2h12.8h133.1h89.4h87h248.7L918.3,392.6z M414.4,345.9h0.2v2.1h-0.2
  V345.9z M414.4,348h0.2v0.1h-0.2V348z M414.4,348.3h0.2v0.5h-0.2V348.3z M414.4,349.1l0.2-0.1v0.2h-0.2V349.1z M414.4,349.4
  l0.2-0.1v0.7h-0.2V349.4z M414.1,349.2H414H414.1L414.1,349.2z M413.7,348h0.4v0.1h-0.4V348z M413.7,348.3h0.4v0.5h-0.4V348.3z
   M413.3,348h0.4v0.1h-0.4V348z M413.3,348.3h0.4v0.5h-0.4V348.3z M411.3,347.1h0.2v0.8h-0.2V347.1z M411.3,348h0.2v0.1h-0.2V348z
   M411.3,348.3h0.2v0.5h-0.2V348.3z M411.3,350h0.2v1.4h-0.2V350z M414.4,335.4h0.2v2.1h-0.2V335.4z M414.4,337.6h0.2v0.1h-0.2
  V337.6z M414.4,337.8h0.2v0.5h-0.2V337.8z M414.4,338.6l0.2-0.1v0.2h-0.2V338.6z M414.4,339l0.2-0.1v0.7h-0.2V339z M414.1,338.7
  H414H414.1L414.1,338.7z M413.7,337.6h0.4v0.1h-0.4V337.6z M413.7,337.8h0.4v0.5h-0.4V337.8z M413.3,337.6h0.4v0.1h-0.4V337.6z
   M413.3,337.8h0.4v0.5h-0.4V337.8z M411.3,336.7h0.2v0.8h-0.2V336.7z M411.3,337.6h0.2v0.1h-0.2V337.6z M411.3,337.8h0.2v0.5h-0.2
  V337.8z M411.3,339.5h0.2v1.4h-0.2V339.5z M410.5,337.6h0.5v0.1h-0.5V337.6z M410.5,337.8h0.5v0.5h-0.5V337.8z M410.5,348h0.5v0.1
  h-0.5V348z M410.5,348.3h0.5v0.5h-0.5V348.3z M414.4,324.9h0.2v2.1h-0.2V324.9z M414.4,327.1h0.2v0.1h-0.2V327.1z M414.4,327.4h0.2
  v0.5h-0.2V327.4z M414.4,328.1l0.2-0.1v0.2h-0.2V328.1z M414.4,328.5l0.2-0.1v0.7h-0.2V328.5z M414.1,328.2H414H414.1L414.1,328.2z
   M413.7,327.1h0.4v0.1h-0.4V327.1z M413.7,327.4h0.4v0.5h-0.4V327.4z M413.3,327.1h0.4v0.1h-0.4V327.1z M413.3,327.4h0.4v0.5h-0.4
  V327.4z M411.3,326.2h0.2v0.8h-0.2V326.2z M411.3,327.1h0.2v0.1h-0.2V327.1z M411.3,327.4h0.2v0.5h-0.2V327.4z M411.3,329h0.2v1.4
  h-0.2V329z M401.2,329.1H401v-4.2h0.2V329.1z M403.7,328.2H403V328L403.7,328.2L403.7,328.2z M403.7,327.8H403v-0.5h0.7V327.8z
   M403.7,327.2H403v-0.1h0.7V327.2z M403.8,328.2L403.8,328.2h0.2H403.8z M404.4,327.8h-0.7v-0.5h0.7V327.8z M404.4,327.2h-0.7v-0.1
  h0.7V327.2z M404.9,330.4h-0.2v-1.6l0.2,0V330.4z M404.9,327.8h-0.2v-0.5h0.2V327.8z M404.9,327.2h-0.2v-0.1h0.2V327.2z
   M404.9,327.1h-0.2v-0.8h0.2V327.1z M401.2,339.6H401v-4.2h0.2V339.6z M403.7,338.7H403v-0.2L403.7,338.7L403.7,338.7z
   M403.7,338.3H403v-0.5h0.7V338.3z M403.7,337.7H403v-0.1h0.7V337.7z M403.8,338.7L403.8,338.7h0.2H403.8z M404.4,338.3h-0.7v-0.5
  h0.7V338.3z M404.4,337.7h-0.7v-0.1h0.7V337.7z M404.9,340.9h-0.2v-1.6l0.2,0V340.9z M404.9,338.3h-0.2v-0.5h0.2V338.3z
   M404.9,337.7h-0.2v-0.1h0.2V337.7z M404.9,337.5h-0.2v-0.8h0.2V337.5z M401.2,350.1H401v-4.2h0.2V350.1z M403.7,349.2H403V349
  L403.7,349.2L403.7,349.2z M403.7,348.8H403v-0.5h0.7V348.8z M403.7,348.1H403V348h0.7V348.1z M403.8,349.2L403.8,349.2h0.2H403.8z
   M404.4,348.8h-0.7v-0.5h0.7V348.8z M404.4,348.1h-0.7V348h0.7V348.1z M404.9,351.3h-0.2v-1.6l0.2,0V351.3z M404.9,348.8h-0.2v-0.5
  h0.2V348.8z M404.9,348.1h-0.2V348h0.2V348.1z M404.9,348h-0.2v-0.8h0.2V348z M306.7,389.1h-8.2v-2.7h8.2V389.1z M330.9,389.1h-8.2
  v-2.7h8.2V389.1z M408,348.8h-1.3v-0.5h1.3V348.8z M408,348.1h-1.3V348h1.3V348.1z M408,338.3h-1.3v-0.5h1.3V338.3z M408,337.7
  h-1.3v-0.1h1.3V337.7z M408.5,327.8h-1.7v-0.5h1.7V327.8z M408.5,327.2h-1.7v-0.1h1.7V327.2z M408.9,327.8h-0.3v-0.5h0.3V327.8z
   M408.9,327.2h-0.3v-0.1h0.3V327.2z M409.2,327.8h-0.3v-0.5h0.3V327.8z M409.2,327.2h-0.3v-0.1h0.3V327.2z M409.3,327.1h1.7v0.1
  h-1.7V327.1z M409.3,327.4h1.7v0.5h-1.7V327.4z M410.3,365.6h-0.6v-0.1h0.6V365.6z M410.3,365.4h-0.6v-0.2h0.6V365.4z M410.3,365.1
  h-0.6v-0.2h0.6V365.1z M410.3,364.7h-0.6v-0.2h0.6V364.7z M410.3,364.4h-0.6v-0.2h0.6V364.4z M410.3,364.1h-0.6v-0.2h0.6V364.1z
   M410.3,363.8h-0.6v-0.2h0.6V363.8z M410.3,363.4h-0.6v-0.2h0.6V363.4z M410.3,363.1h-0.6v-0.2h0.6V363.1z M410.3,362.8h-0.6v-0.2
  h0.6V362.8z M410.3,362.4h-0.6v-0.2h0.6V362.4z M410.3,362.1h-0.6v-0.2h0.6V362.1z M410.3,361.8h-0.6v-0.2h0.6V361.8z M410.3,361.5
  h-0.6v-0.2h0.6V361.5z M410.3,361.1h-0.6v-0.2h0.6V361.1z M410.3,360.8h-0.6v-0.2h0.6V360.8z M410.3,360.5h-0.6v-0.2h0.6V360.5z
   M410.3,360.1h-0.6v-0.2h0.6V360.1z M410.3,359.8h-0.6v-0.2h0.6V359.8z M410.3,359.5h-0.6v-0.2h0.6V359.5z M410.3,359.2h-0.6v-0.2
  h0.6V359.2z M410.3,358.8h-0.6v-0.2h0.6V358.8z M410.3,358.5h-0.6v-0.2h0.6V358.5z M410.3,358.2h-0.6v-0.2h0.6V358.2z M410.3,357.8
  h-0.6v-0.2h0.6V357.8z M410.3,357.5h-0.6v-0.2h0.6V357.5z M410.3,357.2h-0.6v-0.2h0.6V357.2z M410.3,356.9h-0.6v-0.2h0.6V356.9z
   M410.3,356.5h-0.6v-0.2h0.6V356.5z M410.3,356.2h-0.6V356h0.6V356.2z M410.3,355.9h-0.6v-0.2h0.6V355.9z M410.3,355.5h-0.6v-0.2
  h0.6V355.5z M410.3,355.2h-0.6V355h0.6V355.2z M410.3,354.9h-0.6v-0.2h0.6V354.9z M410.3,354.5h-0.6v-0.2h0.6V354.5z M410.3,354.2
  h-0.6V354h0.6V354.2z M410.3,353.9h-0.6v-0.2h0.6V353.9z M410.3,353.6h-0.6v-0.2h0.6V353.6z M410.3,353.2h-0.6V353h0.6V353.2z
   M410.3,352.9h-0.6v-0.2h0.6V352.9z M410.3,352.6h-0.6v-0.2h0.6V352.6z M410.3,352.2h-0.6V352h0.6V352.2z M410.3,351.9h-0.6v-0.2
  h0.6V351.9z M410.3,351.6h-0.5l0-0.2h0.5V351.6z M410.3,351.3h-0.5l0-0.2h0.2l0-0.1h0.4V351.3z M410.3,350.9h-0.4l0-0.2h0.3V350.9z
   M410.3,350.6H410l0-0.1h0.3V350.6z M410.3,348.8h-0.6v-0.1L410.3,348.8L410.3,348.8z M410.3,348.6h-0.6v-0.2h0.6V348.6z
   M410.3,348.1h-0.6v-0.1L410.3,348.1L410.3,348.1z M410.3,348h-0.6v-0.2h0.6V348z M410.3,347.6h-0.6v-0.2h0.6V347.6z M410.3,347.3
  h-0.6v-0.2h0.6V347.3z M410.3,347h-0.6v-0.2h0.6V347z M410.3,346.7h-0.6v-0.2h0.6V346.7z M410.3,346.3h-0.6v-0.2h0.6V346.3z
   M410.3,346h-0.6v-0.2h0.6V346z M410.3,345.7h-0.6v-0.2h0.6V345.7z M410.3,345.3h-0.6v-0.2h0.6V345.3z M410.3,345h-0.6v-0.2h0.6
  V345z M410.3,344.7h-0.6v-0.2h0.6V344.7z M410.3,344.3h-0.6v-0.2h0.6V344.3z M410.3,344h-0.6v-0.2h0.6V344z M410.3,343.7h-0.6v-0.2
  h0.6V343.7z M410.3,343.4h-0.6v-0.2h0.6V343.4z M410.3,343h-0.6v-0.2h0.6V343z M410.3,342.7h-0.6v-0.2h0.6V342.7z M410.3,342.4
  h-0.6v-0.2h0.6V342.4z M410.3,342h-0.6v-0.2h0.6V342z M410.3,341.7h-0.6v-0.2h0.6V341.7z M410.3,341.4h-0.6v-0.2h0.6V341.4z
   M410.3,341.1h-0.5l0-0.2h0.5V341.1z M410.3,340.7h-0.6l0-0.1h0.2l0-0.1h0.4V340.7z M410.3,340.4h-0.4l0-0.2h0.3V340.4z
   M410.3,340.1H410l0-0.1L410.3,340.1L410.3,340.1z M410.3,338.3h-0.6v-0.1h0.6V338.3z M410.3,338.1h-0.6v-0.2h0.6V338.1z
   M410.3,337.7h-0.6v-0.1h0.6V337.7z M410.3,337.4h-0.6v-0.2h0.6V337.4z M410.3,337.1h-0.6v-0.2h0.6V337.1z M410.3,336.8h-0.6v-0.2
  h0.6V336.8z M410.3,336.5h-0.6v-0.2h0.6V336.5z M410.3,336.1h-0.6v-0.2h0.6V336.1z M410.3,335.8h-0.6v-0.2h0.6V335.8z M410.3,335.5
  h-0.6v-0.2h0.6V335.5z M410.3,335.1h-0.6v-0.2h0.6V335.1z M410.3,334.8h-0.6v-0.2h0.6V334.8z M410.3,334.5h-0.6v-0.2h0.6V334.5z
   M410.3,334.1h-0.6v-0.2h0.6V334.1z M410.3,333.8h-0.6v-0.2h0.6V333.8z M410.3,333.5h-0.6v-0.2h0.6V333.5z M410.3,333.2h-0.6v-0.2
  h0.6V333.2z M410.3,332.8h-0.6v-0.2h0.6V332.8z M410.3,332.5h-0.6v-0.2h0.6V332.5z M410.3,332.2h-0.6v-0.2h0.6V332.2z M410.3,331.8
  h-0.6v-0.2h0.6V331.8z M410.3,331.5h-0.6v-0.2h0.6V331.5z M758.6,362.7h-20.8v-27.4h20.8V362.7z"
              />
              <path
                class="st10"
                d="M743.8,382.9c-0.1,0-0.2,0-0.3,0c0-1.1-0.4-2-1.1-2.7c-0.7-0.8-1.7-1.1-2.7-1.1c0-0.1,0-0.2,0-0.3
  C741.8,378.7,743.8,380.6,743.8,382.9z M739.6,379.7c0,0.1,0,0.2,0,0.3c1.5,0,2.9,1.2,2.9,2.9c0.1,0,0.2,0,0.3,0
  C742.8,381.1,741.2,379.7,739.6,379.7z M739.6,380.7c0,0.1,0,0.2,0,0.3c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.5,0.8,0.6,1.4
  c0.1,0,0.2,0,0.3,0C741.8,381.6,740.7,380.6,739.6,380.7z M738.4,413.3h1.5v0.5h-5.2v-0.5h2.8v-31.7h-3v0.3h-5.6v-1.3h5.6v0.1h3
  c0.5,0,0.9,0.4,0.9,0.9v1.7h1.4v4.3h-0.3v0.7l-1.1,1.1V413.3z M738.5,387.5h1.1v-3.9h-1.1V387.5z M738.4,387.7v1.4l0.8-0.8v-0.6
  H738.4z M614.5,378.7c0,0.1,0,0.2,0,0.3c1.1,0,2,0.4,2.7,1.1c0.8,0.8,1.1,1.7,1.1,2.7c0.1,0,0.2,0,0.3,0
  C618.7,380.6,616.7,378.7,614.5,378.7z M614.5,379.7c0,0.1,0,0.2,0,0.3c1.5,0,2.9,1.2,2.9,2.9c0.1,0,0.2,0,0.3,0
  C617.7,381.1,616.1,379.7,614.5,379.7z M614.5,380.7c0,0.1,0,0.2,0,0.3c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.5,0.8,0.6,1.4
  c0.1,0,0.2,0,0.3,0C616.7,381.6,615.6,380.6,614.5,380.7z M613.3,413.3h1.5v0.5h-5.2v-0.5h2.8v-31.7h-3v0.3h-5.6v-1.3h5.6v0.1h3
  c0.5,0,0.9,0.4,0.9,0.9v1.7h1.4v4.3h-0.3v0.7l-1.1,1.1V413.3z M613.4,387.5h1.1v-3.9h-1.1V387.5z M613.3,387.7v1.4l0.8-0.8v-0.6
  H613.3z M489.4,378.7c0,0.1,0,0.2,0,0.3c1.1,0,2,0.4,2.7,1.1c0.8,0.8,1.1,1.7,1.1,2.7c0.1,0,0.2,0,0.3,0
  C493.6,380.6,491.6,378.7,489.4,378.7z M489.4,379.7c0,0.1,0,0.2,0,0.3c1.5,0,2.9,1.2,2.9,2.9c0.1,0,0.2,0,0.3,0
  C492.6,381.1,491,379.7,489.4,379.7z M489.4,380.7c0,0.1,0,0.2,0,0.3c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.5,0.8,0.6,1.4
  c0.1,0,0.2,0,0.3,0C491.6,381.6,490.5,380.6,489.4,380.7z M488.2,413.3h1.5v0.5h-5.2v-0.5h2.8v-31.7h-3v0.3h-5.6v-1.3h5.6v0.1h3
  c0.5,0,0.9,0.4,0.9,0.9v1.7h1.4v4.3h-0.3v0.7l-1.1,1.1V413.3z M488.3,387.5h1.1v-3.9h-1.1V387.5z M488.2,387.7v1.4l0.8-0.8v-0.6
  H488.2z M378.9,378.7c0,0.1,0,0.2,0,0.3c1.1,0,2,0.4,2.7,1.1c0.8,0.8,1.1,1.7,1.1,2.7c0.1,0,0.2,0,0.3,0
  C383.1,380.6,381.2,378.7,378.9,378.7z M379,379.7c0,0.1,0,0.2,0,0.3c1.5,0,2.9,1.2,2.9,2.9c0.1,0,0.2,0,0.3,0
  C382.1,381.1,380.5,379.7,379,379.7z M379,380.7c0,0.1,0,0.2,0,0.3c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.5,0.8,0.6,1.4c0.1,0,0.2,0,0.3,0
  C381.2,381.6,380,380.6,379,380.7z M377.7,413.3h1.5v0.5H374v-0.5h2.8v-31.7h-3v0.3h-5.6v-1.3h5.6v0.1h3c0.5,0,0.9,0.4,0.9,0.9v1.7
  h1.4v4.3h-0.3v0.7l-1.1,1.1V413.3z M377.8,387.5h1.1v-3.9h-1.1V387.5z M377.7,387.7v1.4l0.8-0.8v-0.6H377.7z M872.6,378.7
  c0,0.1,0,0.2,0,0.3c1.1,0,2,0.4,2.7,1.1c0.8,0.8,1.1,1.7,1.1,2.7c0.1,0,0.2,0,0.3,0C876.8,380.6,874.8,378.7,872.6,378.7z
   M872.6,379.7c0,0.1,0,0.2,0,0.3c1.5,0,2.9,1.2,2.9,2.9c0.1,0,0.2,0,0.3,0C875.8,381.1,874.2,379.7,872.6,379.7z M872.6,380.7
  c0,0.1,0,0.2,0,0.3c0.5,0,1,0.2,1.4,0.6c0.4,0.4,0.5,0.8,0.6,1.4c0.1,0,0.2,0,0.3,0C874.9,381.6,873.7,380.6,872.6,380.7z
   M871.4,413.3h1.5v0.5h-5.2v-0.5h2.8v-31.7h-3v0.3h-5.6v-1.3h5.6v0.1h3c0.5,0,0.9,0.4,0.9,0.9v1.7h1.4v4.3h-0.3v0.7l-1.1,1.1V413.3
  z M871.5,387.5h1.1v-3.9h-1.1V387.5z M871.4,387.7v1.4l0.8-0.8v-0.6H871.4z"
              />
            </g>
            <g>
              <g className="dotted-line-up">
                <polyline
                  class="st7"
                  points="389.2,472.3 389.2,398.6 320.7,398.6 		"
                />
                <g>
                  <polygon
                    class="st8"
                    points="322.2,393.7 313.5,398.6 322.2,403.6 			"
                  />
                </g>
              </g>
            </g>
            <g>
              <g className="dotted-line-down">
                <polyline
                  className="st7 "
                  points="270.3,207 270.3,337.1 391.3,337.1 		"
                />
                <g>
                  <polygon
                    class="st8"
                    points="389.8,342.1 398.4,337.1 389.8,332.1 			"
                  />
                </g>
              </g>
            </g>
            <g>
              <g className="dotted-line-down">
                <polyline
                  class="st7"
                  points="508.2,207 508.2,301.2 552.1,301.2 552.1,401.8 		"
                />
                <g>
                  <polygon
                    class="st8"
                    points="547.1,400.3 552.1,409 557.1,400.3 			"
                  />
                </g>
              </g>
            </g>
            <g>
              <g className="dotted-line-up">
                <line class="st7" x1="865" y1="472.3" x2="865" y2="329.3" />
                <g>
                  <polygon
                    class="st8"
                    points="869.9,330.8 865,322.1 860,330.8 			"
                  />
                </g>
              </g>
            </g>
            <g>
              <g className="dotted-line-up">
                <polyline
                  class="st7"
                  points="626.9,472.3 626.9,385.5 719.4,385.5 		"
                />
                <g>
                  <polygon
                    class="st8"
                    points="717.9,390.5 726.5,385.5 717.9,380.5 			"
                  />
                </g>
              </g>
            </g>
            <g>
              <g className="dotted-line-down">
                <line class="st7" x1="746" y1="205.8" x2="746" y2="319" />
                <g>
                  <polygon
                    class="st8"
                    points="741,317.5 746,326.2 751,317.5 			"
                  />
                </g>
              </g>
            </g>
            <g>
              <g className="dotted-line-down">
                <polyline class="st7" points="983.9,207 983.9,272 790.9,272 		" />
                <g>
                  <polygon
                    class="st8"
                    points="792.3,267.1 783.7,272 792.3,277 			"
                  />
                </g>
              </g>
            </g>
            <g className="hexagon-from-bottom-3">
              <defs>
                <polygon
                  id="SVGID_1_"
                  points="923.7,575 923.7,507.1 865,473.2 806.2,507.1 806.2,575 865,608.9 		"
                />
              </defs>
              <clipPath id="SVGID_00000036939976673498177060000002282640661449446530_">
                <use xlinkHref="#SVGID_1_" style={{ overflow: "visible" }} />
              </clipPath>
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000036939976673498177060000002282640661449446530_)",
                }}
              >
                <circle class="st0" cx="865" cy="544.9" r="106.2" />
                <g>
                  <path
                    class="st1"
                    d="M865,624.5c-0.1,0-0.2,0-0.3-0.1l-35.1-15.2c-0.3-0.1-0.4-78.4-0.4-78.7s0.2-0.5,0.4-0.6l35.1-15.2
      c0.2-0.1,0.4-0.1,0.5,0l35.1,15.2c0.3,0.1,0.4,0.4,0.4,0.6s-0.2,78.6-0.4,78.7l-35.1,15.2C865.1,624.5,865,624.5,865,624.5z"
                  />
                </g>
                <g>
                  <circle class="st12" cx="895.3" cy="523.1" r="102.2" />
                  <circle class="st12" cx="895.3" cy="523.1" r="94.1" />
                  <circle class="st12" cx="895.3" cy="523.1" r="85.9" />
                  <circle class="st12" cx="895.3" cy="523.1" r="77.7" />
                  <circle class="st12" cx="895.3" cy="523.1" r="69.5" />
                  <circle class="st12" cx="895.3" cy="523.1" r="61.3" />
                  <circle class="st12" cx="895.3" cy="523.1" r="53.1" />
                  <circle class="st12" cx="895.3" cy="523.1" r="44.9" />
                  <circle class="st12" cx="895.3" cy="523.1" r="36.8" />
                  <circle class="st12" cx="895.3" cy="523.1" r="28.6" />
                  <circle class="st12" cx="895.3" cy="523.1" r="20.4" />
                  <circle class="st12" cx="895.3" cy="523.1" r="12.2" />
                  <circle class="st12" cx="895.3" cy="523.1" r="4" />
                </g>
                <polygon
                  class="st13"
                  points="865,515.3 829.8,530.5 829.8,600.2 865,615.4 900.1,600.2 900.1,530.5 		"
                />
                <polygon
                  class="st0"
                  points="865,588.8 829.8,573.6 865,558.4 900.1,573.6 		"
                />
                <g>
                  <g>
                    <path
                      class="st1"
                      d="M865,584c-0.1,0-0.1,0-0.2,0l-22.9-9.9c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.2,0.1-0.3,0.3-0.4l22.9-9.9
        c0.1,0,0.2,0,0.4,0l22.9,9.9c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4l-22.9,9.9C865.1,584,865,584,865,584z M843.2,573.6
        l21.8,9.4l21.8-9.4l-21.8-9.4L843.2,573.6z"
                    />
                  </g>
                  <g>
                    <ellipse
                      class="st1"
                      cx="887.9"
                      cy="573.6"
                      rx="3"
                      ry="1.7"
                    />
                  </g>
                  <g>
                    <ellipse class="st1" cx="865" cy="563.7" rx="3" ry="1.7" />
                  </g>
                  <g>
                    <ellipse class="st1" cx="842" cy="573.6" rx="3" ry="1.7" />
                  </g>
                  <g>
                    <ellipse class="st1" cx="865" cy="583.6" rx="3" ry="1.7" />
                  </g>
                </g>
                <g>
                  <polygon
                    class="st1"
                    points="847.5,581.4 847.3,581 876.3,568.5 876.5,568.9 			"
                  />
                </g>
                <polygon
                  class="st0"
                  points="865,573.6 829.8,558.4 865,543.2 900.1,558.4 		"
                />
                <g>
                  <path
                    class="st1"
                    d="M847.4,566.5c-0.2,0-0.3-0.1-0.4-0.3c-0.1-0.2,0-0.5,0.2-0.6l29-12.6c0.2-0.1,0.5,0,0.6,0.2
      c0.1,0.2,0,0.5-0.2,0.6l-29,12.6C847.5,566.5,847.4,566.5,847.4,566.5z"
                  />
                </g>
                <g>
                  <g>
                    <path
                      class="st1"
                      d="M865,568.8c-0.1,0-0.1,0-0.2,0l-22.9-9.9c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.2,0.1-0.3,0.3-0.4l22.9-9.9
        c0.1-0.1,0.2-0.1,0.4,0l22.9,9.9c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4l-22.9,9.9C865.1,568.8,865,568.8,865,568.8z
         M843.2,558.4l21.8,9.4l21.8-9.4L865,549L843.2,558.4z"
                    />
                  </g>
                  <g>
                    <ellipse
                      class="st1"
                      cx="887.9"
                      cy="558.4"
                      rx="3"
                      ry="1.7"
                    />
                  </g>
                  <g>
                    <ellipse class="st1" cx="865" cy="548.5" rx="3" ry="1.7" />
                  </g>
                  <g>
                    <ellipse class="st1" cx="842" cy="558.4" rx="3" ry="1.7" />
                  </g>
                  <g>
                    <ellipse class="st1" cx="865" cy="568.3" rx="3" ry="1.7" />
                  </g>
                </g>
                <g>
                  <polygon
                    class="st0"
                    points="865,558.4 829.8,543.2 865,528 900.1,543.2 			"
                  />
                </g>
                <g>
                  <g>
                    <path
                      class="st1"
                      d="M865,553.6c-0.1,0-0.1,0-0.2,0l-22.9-9.9c-0.2-0.1-0.3-0.2-0.3-0.4c0-0.2,0.1-0.3,0.3-0.4l22.9-9.9
        c0.1-0.1,0.2-0.1,0.4,0l22.9,9.9c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4l-22.9,9.9C865.1,553.6,865,553.6,865,553.6z
         M843.2,543.2l21.8,9.4l21.8-9.4l-21.8-9.4L843.2,543.2z"
                    />
                  </g>
                  <g>
                    <ellipse
                      class="st1"
                      cx="887.9"
                      cy="543.2"
                      rx="3"
                      ry="1.7"
                    />
                  </g>
                  <g>
                    <ellipse class="st1" cx="865" cy="533.3" rx="3" ry="1.7" />
                  </g>
                  <g>
                    <ellipse class="st1" cx="842" cy="543.2" rx="3" ry="1.7" />
                  </g>
                  <g>
                    <ellipse class="st1" cx="865" cy="553.1" rx="3" ry="1.7" />
                  </g>
                </g>
                <g>
                  <path
                    class="st1"
                    d="M847.4,608.3c-0.3,0-0.5-0.2-0.5-0.5v-57c0-0.2,0.1-0.3,0.3-0.4l29-12.6c0.2-0.1,0.5,0,0.6,0.2
      c0.1,0.2,0,0.5-0.2,0.6l-28.8,12.4v56.7C847.8,608.1,847.6,608.3,847.4,608.3z"
                  />
                </g>
                <g>
                  <g>
                    <path
                      class="st1"
                      d="M865,616.1c-0.1,0-0.3,0-0.4-0.1c-0.2-0.1-0.3-0.3-0.3-0.6v-69.7c0-0.3,0.2-0.5,0.4-0.6l35.1-15.2
        c0.2-0.1,0.5-0.1,0.7,0.1c0.2,0.1,0.3,0.3,0.3,0.6v69.7c0,0.3-0.2,0.5-0.4,0.6l-35.1,15.2C865.1,616.1,865,616.1,865,616.1z
         M865.6,546.2v68.2l33.8-14.6v-68.2L865.6,546.2z"
                    />
                  </g>
                  <g>
                    <path
                      class="st1"
                      d="M865,546.4c-0.1,0-0.2,0-0.3-0.1l-35.1-15.2c-0.3-0.1-0.4-0.4-0.4-0.6s0.2-0.5,0.4-0.6l35.1-15.2
        c0.2-0.1,0.4-0.1,0.5,0l35.1,15.2c0.3,0.1,0.4,0.4,0.4,0.6s-0.2,0.5-0.4,0.6l-35.1,15.2C865.1,546.4,865,546.4,865,546.4z
         M831.5,530.5L865,545l33.4-14.5L865,516L831.5,530.5z"
                    />
                  </g>
                  <g>
                    <path
                      class="st1"
                      d="M865,616.1c-0.1,0-0.2,0-0.3-0.1l-35.1-15.2c-0.3-0.1-0.4-0.4-0.4-0.6v-69.7c0-0.2,0.1-0.4,0.3-0.6
        c0.2-0.1,0.4-0.2,0.7-0.1l35.1,15.2c0.3,0.1,0.4,0.4,0.4,0.6v69.7c0,0.2-0.1,0.4-0.3,0.6C865.2,616.1,865.1,616.1,865,616.1z
         M830.5,599.8l33.8,14.6v-68.2l-33.8-14.6V599.8z"
                    />
                  </g>
                </g>
                <g>
                  <polygon
                    class="st10"
                    points="897.1,530.5 895.3,531.3 895.3,523.9 897.1,523.1 			"
                  />
                  <polygon
                    class="st14"
                    points="895.3,523.9 893.5,523.1 895.3,522.3 897.1,523.1 			"
                  />
                  <polygon
                    class="st15"
                    points="895.3,531.3 893.5,530.5 893.5,523.1 895.3,523.9 			"
                  />
                </g>
                <g>
                  <path
                    class="st1"
                    d="M865,615.9c-0.1,0-0.1,0-0.2,0l-17.6-7.6c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.2l17.4,7.5
      l29.9-12.9v-69.4c0-0.2,0.1-0.3,0.3-0.4l1.4-0.6l-0.5-0.2c-0.2-0.1-0.3-0.4-0.2-0.6c0.1-0.2,0.4-0.3,0.6-0.2l1.5,0.7
      c0.2,0.1,0.3,0.2,0.3,0.4c0,0.2-0.1,0.3-0.3,0.4l-2.1,0.9v69.4c0,0.2-0.1,0.3-0.3,0.4l-30.3,13.1
      C865.1,615.9,865,615.9,865,615.9z"
                  />
                </g>
              </g>
            </g>
            <g className="hexagon-from-bottom-2">
              <defs>
                <polygon
                  id="SVGID_00000147923785711471269110000010995157814920637834_"
                  points="685.7,575 685.7,507.1 626.9,473.2 568.1,507.1 
    568.1,575 626.9,608.9 		"
                />
              </defs>
              <clipPath id="SVGID_00000076602053369129132130000007429534702874200507_">
                <use
                  xlinkHref="#SVGID_00000147923785711471269110000010995157814920637834_"
                  style={{ overflow: "visible" }}
                />
              </clipPath>
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000076602053369129132130000007429534702874200507_)",
                }}
              >
                <rect
                  x="530.5"
                  y="454.7"
                  class="st0"
                  width="241.4"
                  height="97"
                />
                <polygon
                  class="st14"
                  points="773.1,532 768.1,532 768.1,538.4 761.5,538.4 761.5,508.2 759.2,508.2 755.9,504.8 751.5,504.8 
    748.1,508.3 746,508.3 746,538.4 738.3,538.4 738.3,548.1 732.4,548.1 732.4,520.9 729.6,520.9 729.6,525.5 728.3,525.5 
    728.3,530.5 726.9,530.5 726.9,548.1 724.9,548.1 724.9,525.6 723.1,525.6 723.1,512.3 721,512.3 721,504.6 716.6,500.2 
    712,504.8 712,512 710.4,512 710.4,525.6 708.3,525.6 708.3,536.7 700.8,536.7 700.8,545.7 694.3,545.7 694.3,531.2 684.2,531.2 
    684.2,492.4 682.1,492.4 682.1,490.7 670,490.7 661.7,497.2 661.7,522.4 653.9,522.4 651.7,524.6 651.7,527.3 652.7,527.3 
    652.7,543 649.2,543 649.2,538.3 641.7,538.3 641.7,498.1 627.9,498.1 624,502 624,506.7 625.9,506.7 625.9,534.5 619.6,534.5 
    619.6,526.3 603.9,526.3 603.9,534.3 595.6,534.3 595.6,496.3 592.7,496.3 588.5,492 583,492 578.7,496.4 576.1,496.4 
    576.1,534.3 566.3,534.3 566.3,546.6 558.9,546.6 558.9,512.3 555.4,512.3 555.4,518.1 553.8,518.1 553.8,524.4 552,524.4 
    552,546.6 549.4,546.6 549.4,518.2 547.1,518.2 531.2,518.2 530.5,518.2 530.5,553.8 641.7,553.8 670,553.8 687.1,553.8 
    773.1,553.8 		"
                />
                <polygon
                  class="st9"
                  points="737.2,531.4 735.2,531.4 735.2,521.4 733.6,521.4 733.6,501.9 723.7,501.9 723.7,521.3 721.1,521.3 
    721.1,513.7 715.8,513.7 712.9,510.8 712.9,507.5 710.1,507.5 710.1,511.2 704.8,511.2 704.8,520.7 702.5,520.7 702.5,516.9 
    701.4,516.9 701.4,520.8 699.5,520.8 699.5,544.5 696.6,544.5 696.6,532.8 684.1,532.8 684.1,538.7 677.6,538.7 677.6,517.5 
    665.7,517.5 665.7,524.7 661.6,524.7 661.6,522.2 656.7,522.2 656.7,524.7 654.3,524.7 654.3,540 649.2,540 649.2,542.9 
    646.7,545.4 642.6,545.4 642.6,543.6 639.4,543.6 639.4,536.1 637.8,536.1 637.8,528.1 636.5,528.1 636.5,512.6 628.7,512.6 
    628.7,528 626.6,528 626.6,522 622.4,522 620.1,519.7 620.1,517.1 617.9,517.1 617.9,520 613.7,520 613.7,527.5 611.9,527.5 
    611.9,524.5 611,524.5 611,527.6 609.5,527.6 609.5,546.5 607.2,546.5 607.2,537.2 600,537.2 600,531.4 598,531.4 598,521.4 
    596.4,521.4 596.4,501.9 586.5,501.9 586.5,521.3 583.9,521.3 583.9,513.7 578.6,513.7 575.7,510.8 575.7,507.5 572.9,507.5 
    572.9,511.2 567.6,511.2 567.6,520.7 565.3,520.7 565.3,516.9 564.2,516.9 564.2,520.8 562.3,520.8 562.3,544.5 559.4,544.5 
    559.4,532.8 546.9,532.8 546.9,538.7 540.4,538.7 540.4,517.5 528.5,517.5 528.5,524.7 524.4,524.7 524.4,522.2 519.5,522.2 
    519.5,524.7 517.1,524.7 517.1,540 512.1,540 512.1,542.9 509.5,545.4 505.4,545.4 505.4,543.6 502.3,543.6 502.3,536.1 
    500.7,536.1 500.7,528.1 499.8,528.1 499.8,553.8 505.4,553.8 564.4,553.8 604,553.8 642.6,553.8 741.2,553.8 741.2,540.9 
    737.2,540.9 		"
                />
                <rect
                  x="530.5"
                  y="551.5"
                  class="st1"
                  width="241.4"
                  height="60.5"
                />
                <g>
                  <path
                    class="st10"
                    d="M596.2,524.4c0,0.1,0,0.2,0,0.2c0.8,0,1.5,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1c0.1,0,0.2,0,0.2,0
      C599.5,525.8,598,524.4,596.2,524.4z"
                  />
                  <path
                    class="st10"
                    d="M596.3,525.2c0,0.1,0,0.2,0,0.2c1.2,0,2.2,1,2.2,2.2c0.1,0,0.2,0,0.2,0
      C598.7,526.2,597.5,525.1,596.3,525.2z"
                  />
                  <path
                    class="st10"
                    d="M596.3,525.9c0,0.1,0,0.2,0,0.2c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1.1c0.1,0,0.2,0,0.2,0
      C598,526.6,597.1,525.8,596.3,525.9z"
                  />
                  <path
                    class="st10"
                    d="M595.3,532.8l0.9-0.9v-0.6h0.3V528h-1.1v-1.3c0-0.4-0.3-0.7-0.7-0.7h-2.3v-0.1h-4.4v1h4.4v-0.2h2.3v24.6
      h-2.2v0.4h4v-0.4h-1.1V532.8z M592.1,526.7h-4V526h4V526.7z M595.4,528.1h0.9v3h-0.9V528.1z M596,531.3v0.5l-0.6,0.6v-1.1H596z"
                  />
                </g>
                <g>
                  <path
                    class="st10"
                    d="M645,524.4c0,0.1,0,0.2,0,0.2c0.8,0,1.5,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1c0.1,0,0.2,0,0.2,0
      C648.2,525.8,646.7,524.4,645,524.4z"
                  />
                  <path
                    class="st10"
                    d="M645,525.2c0,0.1,0,0.2,0,0.2c1.2,0,2.2,1,2.2,2.2c0.1,0,0.2,0,0.2,0C647.5,526.2,646.2,525.1,645,525.2z"
                  />
                  <path
                    class="st10"
                    d="M645,525.9c0,0.1,0,0.2,0,0.2c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1.1c0.1,0,0.2,0,0.2,0
      C646.7,526.6,645.8,525.8,645,525.9z"
                  />
                  <path
                    class="st10"
                    d="M644,532.8l0.9-0.9v-0.6h0.3V528H644v-1.3c0-0.4-0.3-0.7-0.7-0.7H641v-0.1h-4.4v1h4.4v-0.2h2.3v24.6h-2.2
      v0.4h4v-0.4H644V532.8z M640.8,526.7h-4V526h4V526.7z M644.1,528.1h0.9v3h-0.9V528.1z M644.7,531.3v0.5l-0.6,0.6v-1.1H644.7z"
                  />
                </g>
                <g>
                  <path
                    class="st10"
                    d="M683.4,524.4c0,0.1,0,0.2,0,0.2c0.8,0,1.5,0.3,2.1,0.9c0.6,0.6,0.9,1.3,0.9,2.1c0.1,0,0.2,0,0.2,0
      C686.7,525.8,685.1,524.4,683.4,524.4z"
                  />
                  <path
                    class="st10"
                    d="M683.4,525.2c0,0.1,0,0.2,0,0.2c1.2,0,2.2,1,2.2,2.2c0.1,0,0.2,0,0.2,0
      C685.9,526.2,684.7,525.1,683.4,525.2z"
                  />
                  <path
                    class="st10"
                    d="M683.4,525.9c0,0.1,0,0.2,0,0.2c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1.1c0.1,0,0.2,0,0.2,0
      C685.2,526.6,684.3,525.8,683.4,525.9z"
                  />
                  <path
                    class="st10"
                    d="M682.5,532.8l0.9-0.9v-0.6h0.3V528h-1.1v-1.3c0-0.4-0.3-0.7-0.7-0.7h-2.3v-0.1h-4.4v1h4.4v-0.2h2.3v24.6
      h-2.2v0.4h4v-0.4h-1.1V532.8z M679.3,526.7h-4V526h4V526.7z M682.6,528.1h0.9v3h-0.9V528.1z M683.1,531.3v0.5l-0.6,0.6v-1.1
      H683.1z"
                  />
                </g>
              </g>
            </g>
            {/* start new */}
       
            {/* end new */}
            {/* start */}
            <g className="hexagon-from-bottom-1">
              <defs>
                <polygon
                  id="SVGID_00000076594863804085078400000008007767896317442738_"
                  points="448,575 448,507.1 389.2,473.2 330.5,507.1 
    330.5,575 389.2,608.9 		"
                />
                
              </defs>
              <use
                xlinkHref="#SVGID_00000076594863804085078400000008007767896317442738_"
                style={{ overflow: "visible", fill: "#B4CBDF" }}
              />
              <clipPath id="SVGID_00000095320102106307571670000005137112670900025759_">
                
                <use
                  xlinkHref="#SVGID_00000076594863804085078400000008007767896317442738_"
                  style={{ overflow: "visible" }}
                />
              </clipPath>
              
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000095320102106307571670000005137112670900025759_)",
                }}
              >
                
                <polygon
                  class="st18"
                  points="438.4,563.7 424,555.4 407.3,565.1 421.4,573.6 		"
                />
                <polygon
                  class="st19"
                  points="438.4,563.2 424,554.9 407.3,564.6 421.4,573.1 		"
                />
                <g>
                  <polygon
                    class="st20"
                    points="343.7,564.7 343.7,559.6 342.9,560 342.9,565.1 			"
                  />

                  <linearGradient
                    id="SVGID_00000093158235680513338170000006335120093379690655_"
                    gradientUnits="userSpaceOnUse"
                    x1="338.1263"
                    y1="557.7336"
                    x2="347.1188"
                    y2="566.9538"
                  >
                    <stop
                      offset="6.230040e-02"
                      style={{ stopColor: "#D8DEDE" }}
                    />
                    <stop offset="0.169" style={{ stopColor: "#D4DADA" }} />
                    <stop offset="0.2808" style={{ stopColor: "#C7CDCD" }} />
                    <stop offset="0.3948" style={{ stopColor: "#B2B8B8" }} />
                    <stop offset="0.4184" style={{ stopColor: "#ADB3B3" }} />
                    <stop offset="0.637" style={{ stopColor: "#B0B6B6" }} />
                    <stop offset="0.7841" style={{ stopColor: "#B9BFBF" }} />
                    <stop offset="0.9097" style={{ stopColor: "#C8CECE" }} />
                    <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                  </linearGradient>
                  
                  <polygon
                    style={{
                      fill: "url(#SVGID_00000093158235680513338170000006335120093379690655_)",
                    }}
                    points="342.9,565.1 342.5,564.9 
      342.5,559.8 342.9,560 			"
                  />
                </g>
                <g>
                  <polygon
                    class="st20"
                    points="338.8,561.6 338.8,556.5 338.1,556.9 338.1,562 			"
                  />

                  <linearGradient
                    id="SVGID_00000034067298807746401990000002741353654600772743_"
                    gradientUnits="userSpaceOnUse"
                    x1="333.2512"
                    y1="554.5995"
                    x2="342.2437"
                    y2="563.8197"
                  >
                    <stop
                      offset="6.230040e-02"
                      style={{ stopColor: "#D8DEDE" }}
                    />
                    <stop offset="0.169" style={{ stopColor: "#D4DADA" }} />
                    <stop offset="0.2808" style={{ stopColor: "#C7CDCD" }} />
                    <stop offset="0.3948" style={{ stopColor: "#B2B8B8" }} />
                    <stop offset="0.4184" style={{ stopColor: "#ADB3B3" }} />
                    <stop offset="0.637" style={{ stopColor: "#B0B6B6" }} />
                    <stop offset="0.7841" style={{ stopColor: "#B9BFBF" }} />
                    <stop offset="0.9097" style={{ stopColor: "#C8CECE" }} />
                    <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                  </linearGradient>
                  <polygon
                    style={{
                      fill: "url(#SVGID_00000034067298807746401990000002741353654600772743_)",
                    }}
                    points="338.1,562 337.6,561.8 
      337.6,556.6 338.1,556.9 			"
                  />
                </g>
                <polygon
                  class="st23"
                  points="337.6,558.4 335.6,559.5 335.6,563 337.6,561.8 		"
                />
                <polygon
                  class="st24"
                  points="337.6,560.7 335.6,561.9 335.6,563 337.6,561.8 		"
                />

                <linearGradient
                  id="SVGID_00000011748901855295377600000013856498474267469445_"
                  gradientUnits="userSpaceOnUse"
                  x1="333.7015"
                  y1="555.7264"
                  x2="339.5326"
                  y2="560.3148"
                >
                  <stop
                    offset="5.102040e-03"
                    style={{ stopColor: "#CAB100" }}
                  />
                  <stop offset="0.9949" style={{ stopColor: "#B87F40" }} />
                </linearGradient>
                <polygon
                  style={{
                    fill: "url(#SVGID_00000011748901855295377600000013856498474267469445_)",
                  }}
                  points="337.6,556.6 337.6,558.2 
    335.6,559.4 335.6,558.7 		"
                />
                <polygon
                  class="st26"
                  points="364.3,576 362.2,577.2 362.2,578.2 364.3,577 		"
                />
                <g>
                  <g>
                    <path
                      class="st27"
                      d="M370.8,563.4l-17.1-10.1c-2.4-1.4-3.7-3.4-3.7-5.6c0-2.3,1.2-4.1,3.6-5.5l42.6-25c1.9-1.1,4.5-1.8,7.2-1.8
        c2.7,0,5.2,0.6,7.2,1.7l16.9,10c2.4,1.4,3.7,3.4,3.7,5.6c0,2.2-1.3,4.2-3.7,5.6l-43.9,25.7C383.6,564.2,378.2,566.8,370.8,563.4
        z"
                    />
                    <path
                      class="st28"
                      d="M380.4,565.2c-2.7,0-5-0.4-6.9-1.6l-28.1-16.3c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l26.1,14.9c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5l-50.1,31.2
        C387.2,563.5,384.3,565.2,380.4,565.2z"
                    />
                    <path
                      class="st27"
                      d="M378.6,565.1c-2.7,0-5-0.4-6.9-1.6l-26.3-15.3c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l26,14.8c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5l-51.8,30.3
        C385.4,563.4,382.6,565.1,378.6,565.1z"
                    />
                    <path
                      class="st28"
                      d="M378.6,565.7c-2.7,0-5-0.4-6.9-1.6l-26.3-15.4c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l26,14.9c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5L385.4,564
        C385.4,564,382.5,565.7,378.6,565.7z"
                    />
                    <path
                      class="st27"
                      d="M378.3,566.2c-2.7,0-5-0.4-6.9-1.6l-25.9-15c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l25.6,14.6c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5l-51.8,30.3
        C385.1,564.4,382.3,566.2,378.3,566.2z"
                    />
                    <path
                      class="st28"
                      d="M378.4,566.7c-2.7,0-5-0.4-6.9-1.6L345.5,550c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l25.6,14.7c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5L385.2,565
        C385.2,565,382.3,566.7,378.4,566.7z"
                    />
                    <path
                      class="st27"
                      d="M378.2,567.3c-2.7,0-5-0.4-6.9-1.6l-25.7-15c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l25.4,14.5c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5L385,565.5
        C385,565.5,382.1,567.3,378.2,567.3z"
                    />
                    <path
                      class="st28"
                      d="M377.9,567.5c-2.7,0-5-0.4-6.9-1.6l-25.4-14.8c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l25.1,14.3c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5l-51.8,30.3
        C384.7,565.8,381.8,567.5,377.9,567.5z"
                    />
                    <path
                      class="st27"
                      d="M377.9,568.2c-2.7,0-5-0.4-6.9-1.6l-25.4-14.8c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l25.1,14.3c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5l-51.8,30.3
        C384.7,566.5,381.8,568.2,377.9,568.2z"
                    />
                    <path
                      class="st28"
                      d="M377.9,568.6c-2.7,0-5-0.4-6.9-1.6l-25.4-14.8c-2.3-1.3-3.6-3.6-3.6-5.7c0-2.2,1.1-4.2,3.4-5.6l51.2-29.8
        c1.5-1,5-1.5,7.8-1.5c2.7,0,5.3,0.7,7.3,1.9l25.1,14.3c2.3,1.3,3.3,3,3.3,5.2c0,2.2-1.1,4.2-3.4,5.5l-51.8,30.3
        C384.7,566.9,381.8,568.6,377.9,568.6z"
                    />
                    <path
                      class="st14"
                      d="M378.4,568.3c-2.7,0-4.9-0.4-6.8-1.5l-25.3-14.6c-2.3-1.3-3.6-3.5-3.6-5.6c0-2.1,1.1-4.1,3.3-5.5
        l50.4-29.3c1.5-0.9,5-1.5,7.6-1.5c2.7,0,5.2,0.7,7.2,1.8l25,14.1c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1.1,4.1-3.4,5.4l-51,29.8
        C385.1,566.6,382.3,568.3,378.4,568.3z"
                    />
                    <path
                      class="st29"
                      d="M378.4,568.3c-2.7,0-4.9-0.4-6.8-1.5l-24.7-14.2c-2.3-1.3-3.6-3.5-3.6-5.6c0-2.1,1.1-4.1,3.3-5.5
        l49.8-29.1c1.5-0.9,5-1.5,7.6-1.5c2.7,0,5.1,0.7,7,1.8l24.4,13.7c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1.1,4.1-3.4,5.4l-50.2,29.6
        C385.1,566.6,382.3,568.3,378.4,568.3z"
                    />
                    <path
                      class="st27"
                      d="M377.7,564.1c-2.7,0-4.9-0.4-6.8-1.5l-19.5-11.5c-2.3-1.3-3.6-3.5-3.6-5.6c0-2.1,1.1-4.1,3.3-5.5
        l45.3-26.3c1.9-1.1,5.1-1.5,7.7-1.5c2.7,0,5.2,0.8,7.2,1.9l19.2,11c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1.1,4.1-3.4,5.4l-45.9,26.8
        C384.4,562.5,381.6,564.1,377.7,564.1z"
                    />
                    <path
                      class="st14"
                      d="M377.7,564.5c-2.7,0-4.9-0.4-6.8-1.5l-19.5-11.5c-2.3-1.3-3.6-3.5-3.6-5.6c0-2.1,1.1-4.1,3.3-5.5
        l45.3-26.3c1.9-1.1,5.1-1.5,7.7-1.5c2.7,0,5.2,0.8,7.2,1.9l19.2,11c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1.1,4.1-3.4,5.4l-45.9,26.8
        C384.4,562.8,381.6,564.5,377.7,564.5z"
                    />
                    <path
                      class="st27"
                      d="M377.7,565.1c-2.7,0-4.9-0.4-6.8-1.5l-19.5-11.5c-2.3-1.3-3.6-3.5-3.6-5.6c0-2.1,1.1-4.1,3.3-5.5
        l45.3-26.3c1.9-1.1,5-1.6,7.6-1.6c2.7,0,5.3,0.9,7.3,2l19.2,11c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1.1,4.1-3.4,5.4l-45.9,26.8
        C384.4,563.5,381.6,565.1,377.7,565.1z"
                    />
                    <path
                      class="st28"
                      d="M377.7,565c-2.7,0-4.9-0.4-6.8-1.5l-19.2-11.1c-2.3-1.3-3.6-3.5-3.6-5.6c0-2.1,1.1-4.1,3.3-5.5l45-26.2
        c1.9-1.1,4.8-1.6,7.5-1.6c2.7,0,5.5,0.9,7.4,2l18.7,10.8c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1,3.9-3.3,5.2l-45.6,26.7
        C384.4,563.3,381.6,565,377.7,565z"
                    />
                    <path
                      class="st28"
                      d="M377.7,564.7c-2.7,0-4.9-0.4-6.8-1.5L352,552.4c-2.3-1.3-3.6-3.2-3.6-5.4c0-2.1,1-4.1,3.3-5.5l44.4-25.9
        c1.9-1.1,4.8-1.6,7.4-1.6c2.7,0,5.5,0.7,7.4,1.8l18.4,10.5c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1,3.8-3.3,5.2l-45,26.4
        C384.3,563,381.5,564.7,377.7,564.7z"
                    />
                    <path
                      class="st27"
                      d="M377.7,564.7c-2.7,0-4.9-0.4-6.8-1.5L352,552.4c-2.3-1.3-3.6-3.2-3.6-5.4c0-2.1,1-4.1,3.3-5.5l44.4-25.9
        c1.9-1.1,4.8-1.6,7.4-1.6c2.7,0,5.5,0.7,7.4,1.8l18.4,10.5c2.3,1.3,3.2,3,3.2,5.1c0,2.1-1,3.8-3.3,5.2l-45,26.4
        C384.3,563,381.5,564.7,377.7,564.7z"
                    />
                    <path
                      class="st28"
                      d="M377.9,564.7c-2.6,0-4.9-0.4-6.8-1.5l-18.8-10.7c-2.3-1.3-3.5-3.2-3.6-5.3c0-2.1,1-4.1,3.3-5.4l44.2-25.8
        c1.9-1.1,4.7-1.5,7.4-1.5c2.6,0,5.2,0.5,7.1,1.6l18.3,10.5c2.3,1.3,3.3,3,3.3,5.1c0,2.1-0.8,3.8-3.1,5.1L384.5,563
        C384.5,563,381.7,564.7,377.9,564.7z"
                    />
                    <path
                      class="st27"
                      d="M377.8,564.7c-2.6,0-4.8-0.4-6.7-1.5l-18.7-10.5c-2.3-1.3-3.5-3.2-3.5-5.2c0-2.1,1-4,3.3-5.3l44.1-25.6
        c1.9-1.1,4.4-1.6,7.1-1.6c2.6,0,5.3,0.6,7.2,1.7l18.4,10.5c2.5,1.4,3.1,3,3.2,5.1c0,2.1-0.8,3.8-3.1,5.1L384.4,563
        C384.4,563,381.7,564.7,377.8,564.7z"
                    />
                    <path
                      class="st28"
                      d="M378,565c-2.6,0-4.8-0.4-6.7-1.5l-18.6-10.6c-2.3-1.3-3.5-3.2-3.5-5.3c0-2.1,1-4.1,3.3-5.4l43.8-25.5
        c1.9-1.1,4.4-1.6,7.1-1.6c2.6,0,5.4,0.6,7.3,1.7l18.2,10.4c2.3,1.3,3.3,3,3.3,5.1c0,2.1-0.8,3.8-3.1,5.1l-44.4,26
        C384.5,563.4,381.7,565,378,565z"
                    />
                    <path
                      class="st27"
                      d="M378.3,565.2c-2.6,0-4.8-0.4-6.7-1.5l-18.6-10.6c-2.3-1.3-3.5-3.2-3.5-5.3c0-2.1,1.2-4,3.5-5.3l43.5-25.5
        c1.9-1.1,4.2-1.6,6.9-1.6c2.6,0,5.2,0.5,7.1,1.6l18.3,10.5c2.3,1.3,3.3,3,3.3,5.1c0,2.1-0.8,3.8-3.1,5.1l-44,25.9
        C384.8,563.6,382.1,565.2,378.3,565.2z"
                    />
                    <path
                      class="st28"
                      d="M377.7,565.3c2.6,0,5.5-0.8,7.4-1.8l43.5-25.6c2.1-1.2,3.2-2.9,3.2-5c0-2-1.2-3.8-3.4-5.1l-18-10.3
        c-1.9-1.1-4.4-1.7-7-1.7c-2.6,0-5.1,0.6-7,1.7l-43.5,25.5c-2.2,1.3-3.4,3.1-3.4,5.1c0,2,1.2,3.8,3.4,5.1l18.2,10.3
        C371.1,563.4,374.1,565.1,377.7,565.3z"
                    />
                    <path
                      class="st27"
                      d="M378.1,565.1c-2.5,0-5-0.6-6.8-1.6l-18.6-10.6c-2.1-1.2-3.2-2.9-3.2-4.7c0-1.9,1.1-3.6,3.2-4.7l43.9-25.6
        c1.8-1.1,4.2-1.6,6.8-1.6c2.5,0,5,0.6,6.8,1.6l18.4,10.5c2.1,1.2,3.2,2.9,3.2,4.7c0,1.9-0.9,3.5-3,4.6l-43.9,25.8
        C383,564.5,380.6,565.1,378.1,565.1L378.1,565.1z"
                    />
                    <path
                      class="st28"
                      d="M378.2,565c-2.5,0-4.9-0.6-6.7-1.6l-18.5-10.5c-2-1.2-3.2-2.8-3.2-4.7c0-1.9,1.1-3.5,3.1-4.7l43.6-25.5
        c1.8-1,4.2-1.6,6.7-1.6c2.5,0,4.9,0.6,6.7,1.6l18.3,10.5c2,1.2,3.2,2.8,3.2,4.7c0,1.9-0.9,3.4-3,4.6L385,563.4
        C383.1,564.4,380.8,565,378.2,565L378.2,565z"
                    />
                    <path
                      class="st27"
                      d="M378.5,564.8c-2.5,0-4.9-0.6-6.6-1.6l-18.1-10.4c-2-1.2-3.4-2.7-3.4-4.6c0-1.8,0.9-3.3,3.4-4.7l43.2-25.2
        c1.8-1,4.1-1.6,6.6-1.6c2.5,0,4.9,0.6,6.6,1.6l17.9,10.4c3,1.7,3.3,3,3.1,4.6c-0.2,1.8-1.1,3.5-3.1,4.6l-43,25.3
        C383.3,564.3,381,564.8,378.5,564.8L378.5,564.8z"
                    />
                    <path
                      class="st28"
                      d="M378.1,564.8c-2.4,0-4.7-0.5-6.4-1.5L353,552.5c-1.8-1.1-2.9-2.5-2.9-4.1c0-1.6,1-3.1,2.8-4.2l44-25.7
        c1.7-1,4-1.5,6.4-1.5c2.4,0,4.7,0.5,6.4,1.5l18.5,10.7c1.8,1.1,2.9,2.5,2.9,4.1c0,1.6-1,3.1-2.8,4.2l-43.8,25.7
        C382.8,564.2,380.5,564.8,378.1,564.8L378.1,564.8z"
                    />
                    <path
                      class="st27"
                      d="M378,564.5c-2.4,0-4.2-0.5-5.9-1.5l-18.5-10.7c-1.8-1.1-3-2.4-3-3.9c0-1.6,1-3.1,2.8-4.1l43.5-25.4
        c1.7-1,3.9-1.6,6.3-1.6c2.4,0,4.7,0.5,6.4,1.5l18.3,10.6c2.8,1.6,2.8,2.7,2.9,4.3c0,1.6-1,3.1-2.8,4.1L384.8,563
        c-1.7,1-3.9,1.5-6.3,1.5L378,564.5z"
                    />
                  </g>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="364,535.7 365.6,534.8 365.6,535.6 364,536.6 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="364.1,535.8 365.5,535 365.5,535.7 364.1,536.5 							"
                          />
                        </g>
                      </g>
                    </g>
                    <polygon
                      class="st33"
                      points="362.9,535.1 364,535.7 364,536.6 363.8,536.5 363.8,536.2 363.3,535.9 363.3,535.6 362.9,535.3 
                "
                    />
                    <polygon
                      class="st14"
                      points="364,535.7 365.6,534.8 364.6,534.2 362.9,535.1 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="386.6,522.6 388.2,521.7 388.2,522.5 386.6,523.5 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="386.8,522.7 388.1,521.9 388.1,522.6 386.7,523.4 							"
                          />
                        </g>
                      </g>
                    </g>
                    <polygon
                      class="st33"
                      points="385.6,522 386.6,522.6 386.6,523.5 386.4,523.4 386.4,523.1 386,522.8 386,522.5 385.6,522.2 				
        "
                    />
                    <polygon
                      class="st14"
                      points="386.6,522.6 388.2,521.7 387.2,521.1 385.6,522 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="411.1,517.5 409.5,516.6 409.5,517.4 411.1,518.4 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="411,517.6 409.6,516.8 409.6,517.5 411,518.3 							"
                          />
                        </g>
                      </g>
                    </g>
                    
                    <polygon
                      class="st33"
                      points="412.1,516.9 411.1,517.5 411.1,518.4 411.3,518.3 411.3,517.9 411.8,517.7 411.8,517.4 
        412.1,517.1 				"
                    />
                    <polygon
                      class="st14"
                      points="411.1,517.5 409.5,516.6 410.5,516 412.1,516.9 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="425.9,525.9 424.3,525 424.3,525.9 425.9,526.8 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="425.8,526 424.4,525.2 424.4,525.9 425.8,526.7 							"
                          />
                        </g>
                      </g>
                    </g>
                    <polygon
                      class="st33"
                      points="426.9,525.3 425.9,525.9 425.9,526.8 426.1,526.7 426.1,526.4 426.5,526.1 426.5,525.8 
        426.9,525.6 				"
                    />
                    <polygon
                      class="st14"
                      points="425.9,525.9 424.3,525 425.3,524.4 426.9,525.3 				"
                    />
                  </g>

                  <image
                    style={{ overflow: "visible", opacity: "0.6" }}
                    width="87"
                    height="38"
                    xlinkHref="4B46F7F68BA86F71.png"
                    transform="matrix(1 0 0 1 347 513)"
                  ></image>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="359.9,531.6 361.6,530.7 361.6,531.5 359.9,532.5 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="360.1,531.7 361.4,530.9 361.4,531.6 360.1,532.4 							"
                          />
                        </g>
                      </g>
                    </g>
                    <polygon
                      class="st33"
                      points="358.9,531 359.9,531.6 359.9,532.5 359.8,532.4 359.8,532.1 359.3,531.8 359.3,531.5 358.9,531.2 
                "
                    />
                    <polygon
                      class="st14"
                      points="359.9,531.6 361.6,530.7 360.6,530.1 358.9,531 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="382.6,518.5 384.2,517.6 384.2,518.4 382.6,519.4 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="382.7,518.6 384.1,517.8 384.1,518.5 382.7,519.3 							"
                          />
                        </g>
                      </g>
                    </g>
                    <polygon
                      class="st33"
                      points="381.6,517.9 382.6,518.5 382.6,519.4 382.4,519.3 382.4,519 382,518.7 382,518.4 381.6,518.1 				
        "
                    />
                    <polygon
                      class="st14"
                      points="382.6,518.5 384.2,517.6 383.2,517 381.6,517.9 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="415.5,513 413.9,512 413.9,512.9 415.5,513.8 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="415.4,513.1 414,512.3 414,513 415.4,513.8 							"
                          />
                        </g>
                      </g>
                    </g>
                    <polygon
                      class="st33"
                      points="416.5,512.4 415.5,513 415.5,513.8 415.7,513.7 415.7,513.4 416.1,513.1 416.1,512.8 416.5,512.6 
                "
                    />
                    <polygon
                      class="st14"
                      points="415.5,513 413.9,512 414.9,511.5 416.5,512.4 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st31"
                            points="430.3,521.4 428.7,520.5 428.7,521.3 430.3,522.3 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g class="st30">
                        <g>
                          <polygon
                            class="st32"
                            points="430.1,521.5 428.8,520.7 428.8,521.4 430.1,522.2 							"
                          />
                        </g>
                      </g>
                    </g>
                    <polygon
                      class="st33"
                      points="431.3,520.8 430.3,521.4 430.3,522.3 430.5,522.2 430.5,521.9 430.9,521.6 430.9,521.3 431.3,521 
                "
                    />
                    <polygon
                      class="st14"
                      points="430.3,521.4 428.7,520.5 429.7,519.9 431.3,520.8 				"
                    />
                  </g>

                  <image
                    style={{ overflow: "visible", opacity: "0.64" }}
                    width="98"
                    height="42"
                    xlinkHref="4B46F7F68BA86F77.png"
                    transform="matrix(1 0 0 1 343 505)"
                  ></image>

                  <radialGradient
                    id="SVGID_00000015347871488427500610000017188850944247893180_"
                    cx="394.5993"
                    cy="524.7054"
                    r="69.0763"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0" style={{ stopColor: "#C06A1D" }} />
                    <stop offset="1" style={{ stopColor: "#8E4900" }} />
                  </radialGradient>
                  <path
                    style={{
                      fill: "url(#SVGID_00000015347871488427500610000017188850944247893180_)",
                    }}
                    d="M385,562.6l43.2-25.3
      c1.6-0.9,2.5-2.2,2.5-3.5c0-1.3-0.9-2.6-2.5-3.5l-18.6-10.8c-1.6-0.9-3.8-1.4-6.1-1.4c-2.3,0-4.5,0.5-6.1,1.4L353,545.3
      c-1.6,0.9-2.5,2.2-2.5,3.5c0,1.3,0.9,2.6,2.5,3.5l18.8,10.9c1.6,0.9,3.8,1.4,6.1,1.4c2.3,0,4.5-0.6,6.1-1.5L385,562.6z"
                  />

                  <radialGradient
                    id="SVGID_00000007395645644938930430000014987705376777305776_"
                    cx="388.7565"
                    cy="514.5832"
                    r="48.5027"
                    gradientUnits="userSpaceOnUse"
                  >
                    {/* Orange color outline */}
                    <stop offset="0" style={{ stopColor: "#a5bdd7" }} />
                    <stop offset="1" style={{ stopColor: "#3d75a6" }} /> 
                  </radialGradient>
                  <path
                    style={{
                      fill: "url(#SVGID_00000007395645644938930430000014987705376777305776_)",
                    }}
                    d="M377.2,564.3c-2.2,0-3.5-0.5-5.1-1.4
      l-18.8-10.9c-1.5-0.9-2.3-2-2.3-3.2c0-1.2,0.8-2.3,2.3-3.2l44.3-25.9c1.5-0.9,3.6-1.4,5.9-1.4c2.2,0,4.3,0.5,5.9,1.4l18.6,10.8
      c1.5,0.9,2.3,2,2.3,3.2c0,1.2-0.8,2.3-2.3,3.2l-44.1,25.9c-1.5,0.9-3,1.4-5.2,1.4H377.2z"
                  />

                  <radialGradient
                    id="SVGID_00000006699704429683903120000004940023650824258225_"
                    cx="384.5985"
                    cy="511.2855"
                    r="73.1325"
                    gradientUnits="userSpaceOnUse"
                  >
                    {/* orange color fill */}
                    <stop offset="0" style={{ stopColor: "#a5bdd7" }} />
                    <stop offset="1" style={{ stopColor: "#3d75a6" }} />
                  </radialGradient>
                  <polygon
                    style={{
                      fill: "url(#SVGID_00000006699704429683903120000004940023650824258225_)",
                    }}
                    points="352.9,548.6 378.1,563.2 
      378.4,563.3 428.3,534 428,533.8 403.1,519.4 402.7,519.6 353.2,548.5 			"
                  />
                  <path
                    class="st37"
                    d="M409,519.2c0,0-5-2.6-11.1,0l-44.7,26.1c0,0-2.3,1.2-2.5,3.1c0,0-0.4-1.8,2.3-3.4l44.8-26.2
      c0,0,5.3-2.8,11.3,0l19.7,11.3c0,0,2.1,1.4,2,3.3c0,0-0.2-1.6-2-2.8L409,519.2z"
                  />
                  <path
                    class="st37"
                    d="M430.6,533.5c0,0,0.5,1.9-2.1,3.6L384,563.3c0,0-2.2,1.4-6,1.4c-3.8,0-5.8-1.3-5.8-1.3l-19.4-11.2
      c0,0-2.1-1.3-2.2-3.1l0-0.5l0.1,0.1c0,0,0.1,1.5,1.9,2.7l5.9,3.4l13.9,8c0,0,2.1,1.3,5.7,1.3c3.6,0,5.8-1.3,5.8-1.3l7.7-4.5
      l11.1-6.5l5.1-3l5.4-3.2l15.6-9.2C428.7,536.5,430.6,535.2,430.6,533.5z"
                  />

                  <linearGradient
                    id="SVGID_00000044873577180931250160000013172312490762132641_"
                    gradientUnits="userSpaceOnUse"
                    x1="373.3698"
                    y1="509.9625"
                    x2="441.9667"
                    y2="627.038"
                  >
                    <stop
                      offset="5.102040e-03"
                      style={{ stopColor: "#182E39" }}
                    />
                    <stop offset="0.9949" style={{ stopColor: "#106DAE" }} />
                  </linearGradient>
                  <path
                    style={{
                      fill: "url(#SVGID_00000044873577180931250160000013172312490762132641_)",
                    }}
                    d="M447,540.3c0,3.2-2.2,6.4-6.4,8.9
      l-47.4,25.9c-8.5,5-22.5,5-31.1,0l-20.7-11.6c-4.5-2.6-6.7-6.1-6.5-9.5v-16.1l35.9,20.1l13.6-0.1l52.5-30.4l10-4.1
      C447,523.4,447,540.2,447,540.3z"
                  />

                  <radialGradient
                    id="SVGID_00000013906697550246121100000007116421319863495817_"
                    cx="377.8661"
                    cy="527.7333"
                    r="49.4579"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="0.6224" style={{ stopColor: "#182E39" }} />
                    <stop offset="1" style={{ stopColor: "#66757C" }} />
                  </radialGradient>
                  <path
                    style={{
                      opacity: "0.3",
                      fill: "url(#SVGID_00000013906697550246121100000007116421319863495817_)",
                    }}
                    d="M364.9,572l0.2,4.5
      c0,0,15.2,6.4,29.8-2.3v-5.3l-4.5,2.5c0,0-4.1,1.8-8.3,2C377.6,573.6,371.6,573.8,364.9,572z"
                  />
                  <g>
                    <polygon
                      class="st20"
                      points="359.6,573.7 359.6,568.6 358.8,569 358.8,574.1 				"
                    />

                    <linearGradient
                      id="SVGID_00000140011174896919081770000003114750266132998819_"
                      gradientUnits="userSpaceOnUse"
                      x1="354.0422"
                      y1="566.7101"
                      x2="363.0348"
                      y2="575.9302"
                    >
                      <stop
                        offset="6.230040e-02"
                        style={{ stopColor: "#D8DEDE" }}
                      />
                      <stop offset="0.169" style={{ stopColor: "#D4DADA" }} />
                      <stop offset="0.2808" style={{ stopColor: "#C7CDCD" }} />
                      <stop offset="0.3948" style={{ stopColor: "#B2B8B8" }} />
                      <stop offset="0.4184" style={{ stopColor: "#ADB3B3" }} />
                      <stop offset="0.637" style={{ stopColor: "#B0B6B6" }} />
                      <stop offset="0.7841" style={{ stopColor: "#B9BFBF" }} />
                      <stop offset="0.9097" style={{ stopColor: "#C8CECE" }} />
                      <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                    </linearGradient>
                    <polygon
                      style={{
                        fill: "url(#SVGID_00000140011174896919081770000003114750266132998819_)",
                      }}
                      points="358.8,574.1 358.4,573.9 
        358.4,568.7 358.8,569 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st20"
                      points="365,576.5 365,571.4 364.3,571.8 364.3,577 				"
                    />

                    <linearGradient
                      id="SVGID_00000051353883236785873300000012504856941169158326_"
                      gradientUnits="userSpaceOnUse"
                      x1="359.4534"
                      y1="569.5479"
                      x2="368.4459"
                      y2="578.7681"
                    >
                      <stop
                        offset="6.230040e-02"
                        style={{ stopColor: "#D8DEDE" }}
                      />
                      <stop offset="0.169" style={{ stopColor: "#D4DADA" }} />
                      <stop offset="0.2808" style={{ stopColor: "#C7CDCD" }} />
                      <stop offset="0.3948" style={{ stopColor: "#B2B8B8" }} />
                      <stop offset="0.4184" style={{ stopColor: "#ADB3B3" }} />
                      <stop offset="0.637" style={{ stopColor: "#B0B6B6" }} />
                      <stop offset="0.7841" style={{ stopColor: "#B9BFBF" }} />
                      <stop offset="0.9097" style={{ stopColor: "#C8CECE" }} />
                      <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                    </linearGradient>
                    <polygon
                      style={{
                        fill: "url(#SVGID_00000051353883236785873300000012504856941169158326_)",
                      }}
                      points="364.3,577 363.8,576.7 
        363.8,571.6 364.3,571.8 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st20"
                      points="354.3,570.7 354.3,565.6 353.5,566 353.5,571.1 				"
                    />

                    <linearGradient
                      id="SVGID_00000009563408404025111830000012282118518693212592_"
                      gradientUnits="userSpaceOnUse"
                      x1="348.7328"
                      y1="563.7236"
                      x2="357.7253"
                      y2="572.9437"
                    >
                      <stop
                        offset="6.230040e-02"
                        style={{ stopColor: "#D8DEDE" }}
                      />
                      <stop offset="0.169" style={{ stopColor: "#D4DADA" }} />
                      <stop offset="0.2808" style={{ stopColor: "#C7CDCD" }} />
                      <stop offset="0.3948" style={{ stopColor: "#B2B8B8" }} />
                      <stop offset="0.4184" style={{ stopColor: "#ADB3B3" }} />
                      <stop offset="0.637" style={{ stopColor: "#B0B6B6" }} />
                      <stop offset="0.7841" style={{ stopColor: "#B9BFBF" }} />
                      <stop offset="0.9097" style={{ stopColor: "#C8CECE" }} />
                      <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                    </linearGradient>
                    <polygon
                      style={{
                        fill: "url(#SVGID_00000009563408404025111830000012282118518693212592_)",
                      }}
                      points="353.5,571.1 353.1,570.9 
        353.1,565.8 353.5,566 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st20"
                      points="349,567.7 349,562.6 348.2,563 348.2,568.2 				"
                    />

                    <linearGradient
                      id="SVGID_00000073679365576215696100000014903859937322203014_"
                      gradientUnits="userSpaceOnUse"
                      x1="343.4233"
                      y1="560.7543"
                      x2="352.4159"
                      y2="569.9745"
                    >
                      <stop
                        offset="6.230040e-02"
                        style={{ stopColor: "#D8DEDE" }}
                      />
                      <stop offset="0.169" style={{ stopColor: "#D4DADA" }} />
                      <stop offset="0.2808" style={{ stopColor: "#C7CDCD" }} />
                      <stop offset="0.3948" style={{ stopColor: "#B2B8B8" }} />
                      <stop offset="0.4184" style={{ stopColor: "#ADB3B3" }} />
                      <stop offset="0.637" style={{ stopColor: "#B0B6B6" }} />
                      <stop offset="0.7841" style={{ stopColor: "#B9BFBF" }} />
                      <stop offset="0.9097" style={{ stopColor: "#C8CECE" }} />
                      <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                    </linearGradient>
                    <polygon
                      style={{
                        fill: "url(#SVGID_00000073679365576215696100000014903859937322203014_)",
                      }}
                      points="348.2,568.2 347.8,567.9 
        347.8,562.8 348.2,563 				"
                    />
                  </g>

                  <linearGradient
                    id="SVGID_00000054982934652742804770000017284482915381396883_"
                    gradientUnits="userSpaceOnUse"
                    x1="333.6123"
                    y1="551.9678"
                    x2="449.0866"
                    y2="551.9678"
                  >
                    <stop offset="0.246" style={{ stopColor: "#D8DEDE" }} />
                    <stop offset="0.2563" style={{ stopColor: "#D6DCDC" }} />
                    <stop offset="0.26" style={{ stopColor: "#CFD5D5" }} />
                    <stop offset="0.2626" style={{ stopColor: "#C4CACA" }} />
                    <stop offset="0.2648" style={{ stopColor: "#B3B9B9" }} />
                    <stop offset="0.2653" style={{ stopColor: "#ADB3B3" }} />
                    <stop offset="0.5636" style={{ stopColor: "#AAB0B0" }} />
                    <stop offset="0.7642" style={{ stopColor: "#A1A8A8" }} />
                    <stop offset="0.9355" style={{ stopColor: "#929A9A" }} />
                    <stop offset="0.9796" style={{ stopColor: "#8D9595" }} />
                    <stop offset="0.9838" style={{ stopColor: "#929A9A" }} />
                    <stop offset="0.989" style={{ stopColor: "#A1A9A9" }} />
                    <stop offset="0.9947" style={{ stopColor: "#BAC1C1" }} />
                    <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                  </linearGradient>
                  <path
                    style={{
                      fill: "url(#SVGID_00000054982934652742804770000017284482915381396883_)",
                    }}
                    d="M333.8,543.8l2.9,6.9l15.1,9.5l15.7,7.8
      c0,0,4.1,1,5.5,1.1c8.6,0.9,18.5-2.7,18.5-2.7l22.4-13.3c0,0,28.8-16.6,30.7-17.9c1.9-1.4,2.5-2.3,3-3.6c0.5-1.3,0.7-2.1,0.7-2.1
      v5.9c0,3.3-1.5,5.4-5.8,7.9l-48.8,27.1c-8.8,5.1-23.2,5.4-32,0.3l-21.7-12.5c-4.6-2.7-6.2-6.3-6-9.8L333.8,543.8z"
                  />
                  <g>
                    <polygon
                      class="st26"
                      points="345.3,560.6 349.4,563 349.4,560.1 345.3,557.7 				"
                    />
                    <polygon
                      class="st45"
                      points="345.3,557.7 345.3,560.6 345.8,560.4 345.8,558 				"
                    />
                    <polygon
                      class="st46"
                      points="349.4,563 345.3,560.6 345.8,560.4 349.4,562.5 				"
                    />
                    <polygon
                      class="st47"
                      points="345.8,558 345.8,559.4 349.4,561.4 349.4,560.1 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st26"
                      points="350.3,563.6 354.4,565.9 354.4,563 350.3,560.7 				"
                    />
                    <polygon
                      class="st45"
                      points="350.3,560.7 350.3,563.6 350.8,563.4 350.8,561 				"
                    />
                    <polygon
                      class="st46"
                      points="354.4,565.9 350.3,563.6 350.8,563.4 354.4,565.4 				"
                    />
                    <polygon
                      class="st47"
                      points="350.8,561 350.8,562.3 354.4,564.3 354.4,563 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st26"
                      points="355.3,566.5 359.3,568.8 359.3,565.9 355.2,563.6 				"
                    />
                    <polygon
                      class="st45"
                      points="355.2,563.6 355.2,566.5 355.8,566.3 355.8,563.9 				"
                    />
                    <polygon
                      class="st46"
                      points="359.3,568.8 355.2,566.5 355.8,566.3 359.3,568.3 				"
                    />
                    <polygon
                      class="st47"
                      points="355.8,563.9 355.8,565.3 359.3,567.2 359.3,565.9 				"
                    />
                  </g>
                  <path
                    class="st14"
                    d="M446.2,525c2.2,2.1,2.1,4.7,2.1,4.7c0,3.3-1.5,5-5.8,7.5l-48.8,28.2c-9.6,4.4-23.4,5.4-32,0.7l-21.7-12.5
      c-4.6-2.7-6.2-6.3-6-9.8c0.1-1.5,2.3-3.6,2.3-3.6l-1.3,3.7c-0.2,3.4,1.9,6.9,6.5,9.5l20.7,11.6c8.1,4.5,22.1,3.7,31.1-0.7
      l47.4-27.4c4.2-2.4,6.3-3.5,6.4-6.7L446.2,525z"
                  />

                  <linearGradient
                    id="SVGID_00000132047460820044034690000015143808312889914301_"
                    gradientUnits="userSpaceOnUse"
                    x1="364.1512"
                    y1="572.2826"
                    x2="445.5636"
                    y2="523.9605"
                  >
                    <stop offset="0" style={{ stopColor: "#F4F6F6" }} />
                    <stop
                      offset="1.182375e-02"
                      style={{ stopColor: "#F2F4F4" }}
                    />
                    <stop
                      offset="1.608221e-02"
                      style={{ stopColor: "#EBEEEE" }}
                    />
                    <stop
                      offset="1.911843e-02"
                      style={{ stopColor: "#E0E3E3" }}
                    />
                    <stop
                      offset="2.157310e-02"
                      style={{ stopColor: "#CFD3D3" }}
                    />
                    <stop
                      offset="2.367571e-02"
                      style={{ stopColor: "#B9BEBE" }}
                    />
                    <stop
                      offset="2.550373e-02"
                      style={{ stopColor: "#9EA5A5" }}
                    />
                    <stop
                      offset="2.579690e-02"
                      style={{ stopColor: "#99A0A0" }}
                    />
                    <stop offset="0.8587" style={{ stopColor: "#9BA3A3" }} />
                    <stop offset="0.9779" style={{ stopColor: "#9CA4A4" }} />
                    <stop offset="0.9815" style={{ stopColor: "#A1A9A9" }} />
                    <stop offset="0.9859" style={{ stopColor: "#B0B8B8" }} />
                    <stop offset="0.9907" style={{ stopColor: "#C9CFCF" }} />
                    <stop offset="0.9931" style={{ stopColor: "#D8DEDE" }} />
                  </linearGradient>
                  <path
                    style={{
                      fill: "url(#SVGID_00000132047460820044034690000015143808312889914301_)",
                    }}
                    d="M446.2,525l0.8,5.3
      c0,3.2-2.2,4.3-6.4,6.7l-47.4,27.4c-9.1,4.3-23,5.1-31.1,0.7l-2.7-1.5v1.2l2.3,1.3c8.6,4.7,22.4,3.7,32-0.7l48.8-28.2
      c4.3-2.5,5.8-4.2,5.8-7.5C448.3,529.7,448.4,527.1,446.2,525z"
                  />

                  <image
                    style={{ overflow: "visible", opacity: "0.24" }}
                    width="66"
                    height="26"
                    xlinkHref="4B46F7F68BA86F70.png"
                    transform="matrix(1 0 0 1 333 543)"
                  ></image>
                  <g>
                    <path
                      class="st49"
                      d="M378,564.2c-2.3,0-4.5-0.5-6.1-1.4L353,551.9c-1.6-0.9-2.5-2.2-2.5-3.6c0-1.4,0.9-2.6,2.5-3.6l44.3-25.9
        c1.6-0.9,3.8-1.4,6.1-1.5c2.3,0,4.5,0.5,6.1,1.4l18.6,10.8c1.6,0.9,2.5,2.2,2.5,3.6c0,1.4-0.9,2.6-2.5,3.6l-44.1,25.9
        C382.5,563.7,380.3,564.2,378,564.2z M403.4,517.6c-2.3,0-4.5,0.5-6,1.4L353,544.9c-1.6,0.9-2.5,2.2-2.4,3.5
        c0,1.3,0.9,2.6,2.5,3.5l18.8,10.9c1.6,0.9,3.8,1.4,6.1,1.4c2.3,0,4.5-0.5,6-1.4l44.1-25.9c1.6-0.9,2.5-2.2,2.4-3.5
        c0-1.3-0.9-2.6-2.5-3.5L409.5,519C407.9,518.1,405.7,517.6,403.4,517.6z"
                    />
                  </g>
                  <g>
                    <g>
                      <linearGradient
                        id="SVGID_00000034074569383057003780000003852308111525508796_"
                        gradientUnits="userSpaceOnUse"
                        x1="382.6715"
                        y1="526.0303"
                        x2="400.3438"
                        y2="559.0494"
                      >
                        {/* Green field */}
                        <stop offset="0" style={{ stopColor: "#437bac" }} />
                        <stop offset="1" style={{ stopColor: "#548cbd" }} />
                      </linearGradient>
                      <polygon
                        style={{
                          fill: "url(#SVGID_00000034074569383057003780000003852308111525508796_)",
                        }}
                        points="401.3,522.3 423.3,535.1 
          424.5,535.8 423.3,536.5 382.8,560 381.5,560.7 380.3,560 358.3,547.3 357,546.6 358.3,545.9 398.8,522.4 400.1,521.6 					"
                      />
                      <g>
                        <polygon
                          class="st51"
                          points="382.9,560 381.6,560.7 380.4,560 358.4,547.3 357.1,546.6 358.4,545.8 						"
                        />
                        <polygon
                          class="st51"
                          points="385.3,558.5 384,559.2 382.8,558.5 360.8,545.8 359.5,545.1 360.8,544.4 						"
                        />
                        <polygon
                          class="st51"
                          points="387.8,557 386.5,557.7 385.3,557 363.3,544.3 362,543.6 363.3,542.9 						"
                        />
                        <polygon
                          class="st51"
                          points="390.3,555.5 389,556.2 387.8,555.5 365.8,542.8 364.5,542.1 365.8,541.4 						"
                        />
                        <polygon
                          class="st51"
                          points="392.9,554.1 391.6,554.8 390.4,554.1 368.4,541.4 367.1,540.7 368.4,539.9 						"
                        />
                        <polygon
                          class="st51"
                          points="395.4,552.6 394.2,553.3 392.9,552.6 370.9,539.9 369.7,539.2 370.9,538.4 						"
                        />
                        <polygon
                          class="st51"
                          points="398,551.1 396.7,551.8 395.5,551.1 373.5,538.4 372.2,537.7 373.5,536.9 						"
                        />
                        <polygon
                          class="st51"
                          points="400.6,549.6 399.3,550.4 398.1,549.7 376,536.9 374.8,536.2 376.1,535.5 						"
                        />
                        <polygon
                          class="st51"
                          points="403.1,548.1 401.8,548.9 400.6,548.2 378.5,535.4 377.3,534.7 378.6,534 						"
                        />
                        <polygon
                          class="st51"
                          points="405.7,546.7 404.4,547.4 403.1,546.7 381.1,534 379.9,533.3 381.1,532.5 						"
                        />
                        <polygon
                          class="st51"
                          points="408.3,545.3 407,546 405.7,545.3 383.7,532.6 382.5,531.8 383.7,531.1 						"
                        />
                        <polygon
                          class="st51"
                          points="410.8,543.8 409.5,544.5 408.3,543.8 386.3,531.1 385,530.4 386.3,529.6 						"
                        />
                        <polygon
                          class="st51"
                          points="413.3,542.3 412,543 410.8,542.3 388.8,529.6 387.5,528.9 388.8,528.1 						"
                        />
                        <polygon
                          class="st51"
                          points="415.9,540.8 414.6,541.6 413.4,540.9 391.4,528.1 390.1,527.4 391.4,526.7 						"
                        />
                        <polygon
                          class="st51"
                          points="418.4,539.3 417.1,540.1 415.9,539.4 393.9,526.6 392.6,525.9 393.9,525.2 						"
                        />
                        <polygon
                          class="st51"
                          points="421,537.9 419.7,538.6 418.5,537.9 396.5,525.2 395.2,524.5 396.5,523.7 						"
                        />
                        <polygon
                          class="st51"
                          points="423.5,536.4 422.2,537.1 421,536.4 399,523.7 397.7,523 399,522.2 						"
                        />
                      </g>
                      <g>
                        <g>
                          <path
                            class="st52"
                            d="M381.5,560.9l-1.3-0.7l-22-12.7l-1.4-0.8l1.4-0.9l40.5-23.5l1.4-0.8l1.3,0.8l22,12.7l1.4,0.8l-1.4,0.9
              l-40.5,23.5L381.5,560.9z M357.3,546.6l1,0.6l22,12.7l1.2,0.7l1.2-0.7l40.5-23.5l1.1-0.6l-1-0.6l-22-12.7l-1.2-0.7l-1.2,0.7
              L358.4,546L357.3,546.6z"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st52"
                            points="402.8,548.4 401.6,547.7 379.6,535 378.4,534.2 378.5,534 379.8,534.7 401.8,547.5 403,548.2 
                            "
                          />
                        </g>
                        <g>
                          <path
                            class="st52"
                            d="M390.9,546.9c-2.5,0-4.9-0.6-6.7-1.6c-1.8-1.1-2.8-2.5-2.8-4c0-1.5,1-2.9,2.8-4c1.8-1,4.2-1.6,6.7-1.6
              c2.5,0,4.9,0.6,6.7,1.6c1.8,1.1,2.8,2.5,2.8,4c0,1.5-1,2.9-2.8,4C395.8,546.4,393.4,546.9,390.9,546.9z M390.8,536
              c-2.5,0-4.9,0.6-6.6,1.6c-1.7,1-2.7,2.3-2.7,3.7c0,1.4,1,2.8,2.7,3.8c1.8,1,4.1,1.6,6.6,1.6c2.5,0,4.9-0.6,6.6-1.6
              c1.7-1,2.7-2.3,2.7-3.7c0-1.4-1-2.8-2.7-3.8C395.7,536.6,393.3,536,390.8,536z"
                          />
                        </g>
                        <g>
                          <path
                            class="st52"
                            d="M358.4,547.4l-0.2-0.2c0.2-0.2,0.3-0.4,0.3-0.6c0-0.4-0.3-0.7-0.3-0.7l0.2-0.2c0,0,0.4,0.4,0.4,0.8
              C358.7,546.9,358.6,547.2,358.4,547.4z"
                          />
                        </g>
                        <g>
                          <path
                            class="st52"
                            d="M380.4,560.1l-0.2-0.2c0,0,1.1-0.9,2.7,0l-0.1,0.2C381.3,559.3,380.4,560.1,380.4,560.1z"
                          />
                        </g>
                        <g>
                          <path
                            class="st52"
                            d="M423.4,536.5c-0.8-0.8-0.4-1.4-0.4-1.4l0.2,0.1l-0.1-0.1l0.1,0.1c0,0-0.3,0.5,0.4,1.1L423.4,536.5z"
                          />
                        </g>
                        <g>
                          <path
                            class="st52"
                            d="M400.1,522.8c-0.7,0-1.3-0.3-1.4-0.3l0.1-0.2c0,0,1.3,0.6,2.3,0l0.1,0.2
              C400.9,522.7,400.5,522.8,400.1,522.8z"
                          />
                        </g>
                        <g>
                          <g class="st30">
                            <g>
                              <path
                                class="st52"
                                d="M376.2,549.1c1.5,0.9,2.1,1.9,1.5,2.4c0,0-0.1,0-0.1,0.1l-0.2-0.1c0,0,0.1,0,0.1-0.1
                  c0.5-0.4-0.2-1.4-1.5-2.2c-1.3-0.8-3-1.2-3.7-0.9c0,0-0.1,0-0.1,0.1l-0.2-0.1c0,0,0.1,0,0.1-0.1
                  C373,547.9,374.7,548.3,376.2,549.1z"
                              />
                            </g>
                            <g>
                              <path
                                class="st52"
                                d="M368.4,548.1l9.5,5.5l-4.2,2.4l-0.2,0.1l-9.5-5.5l0.2-0.1L368.4,548.1z M373.5,555.9l4-2.3l-9.1-5.3
                  l-4,2.3L373.5,555.9L373.5,555.9z"
                              />
                            </g>
                            <g>
                              <path
                                class="st52"
                                d="M377.7,551.5l5.4,3.1l-6.1,3.5l-3.5-2l0.2-0.1l3.4,1.9l5.7-3.3l-16.2-9.4l-5.7,3.3l3.4,1.9l-0.2,0.1
                  l-3.5-2l6.1-3.5l5.5,3.2c0,0-0.1,0-0.1,0.1l0.2,0.1c0,0,0.1,0,0.1-0.1l5.2,3c0,0-0.1,0-0.1,0.1L377.7,551.5
                  C377.7,551.6,377.7,551.5,377.7,551.5z"
                              />
                            </g>
                          </g>
                        </g>
                        <g>
                          <g class="st30">
                            <g>
                              <path
                                class="st52"
                                d="M404.6,532.8c-1.5-0.9-2.1-1.9-1.5-2.4c0,0,0.1,0,0.1-0.1l0.2,0.1c0,0-0.1,0-0.1,0.1
                  c-0.5,0.4,0.2,1.4,1.5,2.2c1.3,0.8,3,1.2,3.7,0.9c0,0,0.1,0,0.1-0.1l0.2,0.1c0,0-0.1,0-0.1,0.1
                  C407.8,534,406.1,533.7,404.6,532.8z"
                              />
                            </g>
                            <g>
                              <path
                                class="st52"
                                d="M412.4,533.8l-9.5-5.5l4.2-2.4l0.2-0.1l9.5,5.5l-0.2,0.1L412.4,533.8z M407.3,526l-4,2.3l9.1,5.3
                  l4-2.3L407.3,526L407.3,526z"
                              />
                            </g>
                            <g>
                              <path
                                class="st52"
                                d="M403.1,530.4l-5.4-3.1l6.1-3.5l3.5,2l-0.2,0.1l-3.4-1.9l-5.7,3.3l16.2,9.4l5.7-3.3l-3.4-1.9l0.2-0.1
                  l3.5,2l-6.1,3.5l-5.5-3.2c0,0,0.1,0,0.1-0.1l-0.2-0.1c0,0-0.1,0-0.1,0.1l-5.2-3c0,0,0.1,0,0.1-0.1l-0.2-0.1
                  C403.1,530.4,403.1,530.4,403.1,530.4z"
                              />
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <path
                            class="st14"
                            d="M409.6,527.4l-1.2,0.7c-0.2,0-0.3-0.1-0.3-0.1v-2.3c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0l4.4,2.5
              c0,0,0.1,0.1,0.1,0.1v2.2l1.1-0.7c0,0,0.2,0,0.1,0.2l-1.3,0.8c0,0-0.2,0-0.2-0.2v-2.3l-4.2-2.4v2l1.1-0.6c0,0,0.1,0,0.1,0.1
              C409.7,527.3,409.6,527.4,409.6,527.4z"
                          />
                        </g>
                        <g>
                          <path
                            class="st14"
                            d="M409.6,527.4C409.6,527.4,409.5,527.4,409.6,527.4l-1.4-1.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0
              l1.3,1.6C409.8,527.3,409.7,527.3,409.6,527.4C409.7,527.4,409.6,527.4,409.6,527.4z"
                          />
                        </g>
                        <g>
                          <path
                            class="st14"
                            d="M414,530C414,530,413.9,530,414,530l-1.4-1.7c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0l1.3,1.6
              C414.1,529.8,414.1,529.9,414,530C414.1,530,414,530,414,530z"
                          />
                        </g>
                      </g>
                      <g>
                        <rect
                          x="411.7"
                          y="525.9"
                          transform="matrix(0.5049 -0.8632 0.8632 0.5049 -252.323 617.1169)"
                          class="st14"
                          width="0.1"
                          height="5.1"
                        />
                      </g>
                      <g>
                        <rect
                          x="411.4"
                          y="525.4"
                          transform="matrix(0.5049 -0.8632 0.8632 0.5049 -252.07 616.5582)"
                          class="st14"
                          width="0.1"
                          height="5.1"
                        />
                      </g>
                      <g>
                        <rect
                          x="411"
                          y="525"
                          transform="matrix(0.5049 -0.8632 0.8632 0.5049 -251.8411 616.0125)"
                          class="st14"
                          width="0.1"
                          height="5.1"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <path
                            class="st14"
                            d="M371.2,554.6c0,0-0.1,0-0.1-0.1c0-0.1,0-0.1,0-0.2l1.2-0.7v-2.3l-4.2-2.4v2.2c0,0,0,0.1-0.1,0.1
              l-1.3,0.7c-0.1,0-0.1,0-0.2,0c0-0.1,0-0.1,0-0.2l1.2-0.7v-2.3c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0l4.4,2.5
              c0,0,0.1,0.1,0.1,0.1v2.4c0,0,0,0.1-0.1,0.1L371.2,554.6C371.3,554.6,371.3,554.6,371.2,554.6z"
                          />
                        </g>
                        <g>
                          <path
                            class="st14"
                            d="M371.2,554.6C371.2,554.6,371.2,554.6,371.2,554.6l-4.5-2.6c0,0-0.1-0.1,0-0.1l1.3-3.1c0,0,0,0,0,0
              c0,0,0,0,0.1,0l4.4,2.5c0,0,0.1,0.1,0,0.1L371.2,554.6C371.3,554.6,371.3,554.6,371.2,554.6
              C371.3,554.6,371.2,554.6,371.2,554.6z M366.9,551.9l4.3,2.5l1.2-3l-4.3-2.4L366.9,551.9z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <rect
                            x="370"
                            y="547.9"
                            transform="matrix(0.5049 -0.8632 0.8632 0.5049 -291.9287 591.9852)"
                            class="st14"
                            width="0.1"
                            height="5.1"
                          />
                        </g>
                        <g>
                          <rect
                            x="369.9"
                            y="548.3"
                            transform="matrix(0.5049 -0.8632 0.8632 0.5049 -292.3235 592.0673)"
                            class="st14"
                            width="0.1"
                            height="5.1"
                          />
                        </g>
                        <g>
                          <rect
                            x="369.8"
                            y="548.7"
                            transform="matrix(0.5049 -0.8632 0.8632 0.5049 -292.7182 592.1496)"
                            class="st14"
                            width="0.1"
                            height="5.1"
                          />
                        </g>
                        <g>
                          <rect
                            x="369.6"
                            y="549"
                            transform="matrix(0.5049 -0.8632 0.8632 0.5049 -293.1154 592.1879)"
                            class="st14"
                            width="0.1"
                            height="5.1"
                          />
                        </g>
                        <g>
                          <rect
                            x="369.5"
                            y="549.4"
                            transform="matrix(0.5049 -0.8632 0.8632 0.5049 -293.5153 592.2617)"
                            class="st14"
                            width="0.1"
                            height="5.1"
                          />
                        </g>
                        <g>
                          <rect
                            x="369.3"
                            y="549.8"
                            transform="matrix(0.5049 -0.8632 0.8632 0.5049 -293.9038 592.2917)"
                            class="st14"
                            width="0.1"
                            height="5.1"
                          />
                        </g>
                        <g>
                          <rect
                            x="369.2"
                            y="550.1"
                            transform="matrix(0.5049 -0.8632 0.8632 0.5049 -294.2907 592.3479)"
                            class="st14"
                            width="0.1"
                            height="5.1"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <rect
                        x="346.8"
                        y="520.4"
                        transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 693.967 1049.391)"
                        class="st53"
                        width="0.3"
                        height="8.5"
                      />
                      <rect
                        x="346.4"
                        y="520.4"
                        class="st54"
                        width="0.4"
                        height="8.5"
                      />
                    </g>
                    <g>
                      <rect
                        x="351.3"
                        y="517.8"
                        transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 702.8967 1044.1412)"
                        class="st53"
                        width="0.3"
                        height="8.5"
                      />
                      <rect
                        x="350.9"
                        y="517.8"
                        class="st54"
                        width="0.4"
                        height="8.5"
                      />
                    </g>
                    <path
                      class="st14"
                      d="M344.4,521.3v-3.7c0-0.1,0.1-0.3,0.2-0.3l7.3-4.2c0.1,0,0.2-0.1,0.3-0.1c0.5,0.1,0.8,0.3,0.8,0.5v3.5
        c0,0.1-0.1,0.3-0.2,0.3l-7.3,4.5C345.1,522,344.4,521.6,344.4,521.3z"
                    />
                    <path
                      class="st54"
                      d="M344.8,521.5v-3.7c0-0.1,0.1-0.3,0.2-0.3l7.3-4.2c0.3-0.2,0.6,0,0.6,0.3v3.7c0,0.1-0.1,0.3-0.2,0.3
        l-7.3,4.2C345.1,522,344.8,521.8,344.8,521.5z"
                    />
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000058555920510204103310000017872179708086881443_"
                          gradientUnits="userSpaceOnUse"
                          x1="346.5296"
                          y1="517.4042"
                          x2="345.8126"
                          y2="518.6714"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000058555920510204103310000017872179708086881443_)",
                          }}
                          d="M346.5,517.4c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C345.1,517.4,346.5,517.4,346.5,517.4z"
                        />
                        
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000025428771579725264900000002687055842791460248_"
                              class="st30"
                              d="M346.3,517.5c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C345.8,518.1,346,517.7,346.3,517.5z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000025428771579725264900000002687055842791460248_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000091698388311871191570000001535976145550160041_">
                            <use
                              xlinkHref="#SVGID_00000025428771579725264900000002687055842791460248_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        
                        <path
                          class="st14"
                          d="M346.4,517.7c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C346,518.1,346.2,517.8,346.4,517.7z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000037660587625886975590000006110658715127650189_"
                          gradientUnits="userSpaceOnUse"
                          x1="348.4095"
                          y1="516.3846"
                          x2="347.6925"
                          y2="517.6518"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000037660587625886975590000006110658715127650189_)",
                          }}
                          d="M348.4,516.3c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C347,516.4,348.4,516.3,348.4,516.3z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000028288681625441155260000003188038869396445599_"
                              class="st30"
                              d="M348.2,516.5c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C347.7,517,347.9,516.6,348.2,516.5z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000028288681625441155260000003188038869396445599_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000097485905831634521480000002164866002149766018_">
                            <use
                              xlinkHref="#SVGID_00000028288681625441155260000003188038869396445599_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M348.2,516.7c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C347.9,517.1,348,516.8,348.2,516.7z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000183224490069427128630000003912518869687866558_"
                          gradientUnits="userSpaceOnUse"
                          x1="350.2895"
                          y1="515.3013"
                          x2="349.5725"
                          y2="516.5685"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000183224490069427128630000003912518869687866558_)",
                          }}
                          d="M350.2,515.2c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C348.9,515.3,350.2,515.2,350.2,515.2z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000133500962761935410410000001155941559261909121_"
                              class="st30"
                              d="M350.1,515.4c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C349.6,516,349.8,515.6,350.1,515.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000133500962761935410410000001155941559261909121_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000166658515238450313880000016693897899042035855_">
                            <use
                              xlinkHref="#SVGID_00000133500962761935410410000001155941559261909121_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        
                        <path
                          class="st14"
                          d="M350.1,515.6c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C349.7,516,349.9,515.7,350.1,515.6z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000063593264033850950450000000291090775821147290_"
                          gradientUnits="userSpaceOnUse"
                          x1="352.2332"
                          y1="514.2498"
                          x2="351.5162"
                          y2="515.517"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000063593264033850950450000000291090775821147290_)",
                          }}
                          d="M352.2,514.2c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C350.8,514.2,352.2,514.2,352.2,514.2z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000067920420028762276710000011295102120008297134_"
                              class="st30"
                              d="M352,514.3c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C351.5,514.9,351.7,514.5,352,514.3z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000067920420028762276710000011295102120008297134_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000090283703890064218140000014037064999415294613_">
                            <use
                              xlinkHref="#SVGID_00000067920420028762276710000011295102120008297134_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M352.1,514.5c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C351.7,514.9,351.9,514.6,352.1,514.5z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000145037374004655908470000003964899434992951975_"
                          gradientUnits="userSpaceOnUse"
                          x1="346.5296"
                          y1="519.4435"
                          x2="345.8126"
                          y2="520.7108"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000145037374004655908470000003964899434992951975_)",
                          }}
                          d="M346.5,519.4c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C345.1,519.4,346.5,519.4,346.5,519.4z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000127740469706689445760000009395035498190936200_"
                              class="st30"
                              d="M346.3,519.5c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C345.8,520.1,346,519.7,346.3,519.5z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000127740469706689445760000009395035498190936200_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000033351756146925399590000013582624079321476761_">
                            <use
                              xlinkHref="#SVGID_00000127740469706689445760000009395035498190936200_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M346.4,519.7c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C346,520.1,346.2,519.8,346.4,519.7z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000129890233384337567840000011045723028322264719_"
                          gradientUnits="userSpaceOnUse"
                          x1="348.4095"
                          y1="518.4239"
                          x2="347.6925"
                          y2="519.6911"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000129890233384337567840000011045723028322264719_)",
                          }}
                          d="M348.4,518.4c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C347,518.4,348.4,518.4,348.4,518.4z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000101101313758380820410000001359622860796349828_"
                              class="st30"
                              d="M348.2,518.5c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C347.7,519.1,347.9,518.7,348.2,518.5z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000101101313758380820410000001359622860796349828_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000169550696346043882540000004334683499632419985_">
                            <use
                              xlinkHref="#SVGID_00000101101313758380820410000001359622860796349828_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M348.2,518.7c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C347.9,519.1,348,518.8,348.2,518.7z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000036213344969080681770000007187501099424295316_"
                          gradientUnits="userSpaceOnUse"
                          x1="350.2895"
                          y1="517.3405"
                          x2="349.5725"
                          y2="518.6077"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000036213344969080681770000007187501099424295316_)",
                          }}
                          d="M350.2,517.3c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C348.9,517.3,350.2,517.3,350.2,517.3z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000116938900412659064060000001723270228706807452_"
                              class="st30"
                              d="M350.1,517.4c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C349.6,518,349.8,517.6,350.1,517.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000116938900412659064060000001723270228706807452_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000138531122160452010990000003348550827779387548_">
                            <use
                              xlinkHref="#SVGID_00000116938900412659064060000001723270228706807452_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M350.1,517.6c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C349.7,518,349.9,517.7,350.1,517.6z"
                        />
                      </g>
                    </g>
                    
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000066484642085054985300000001418163300195180941_"
                          gradientUnits="userSpaceOnUse"
                          x1="352.2332"
                          y1="516.289"
                          x2="351.5162"
                          y2="517.5562"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000066484642085054985300000001418163300195180941_)",
                          }}
                          d="M352.2,516.2c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C350.8,516.3,352.2,516.2,352.2,516.2z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000159432934865764889730000005076113710737668523_"
                              class="st30"
                              d="M352,516.4c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C351.5,516.9,351.7,516.5,352,516.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000159432934865764889730000005076113710737668523_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000094581536621688074680000006921963661617966984_">
                            <use
                              xlinkHref="#SVGID_00000159432934865764889730000005076113710737668523_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M352.1,516.6c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C351.7,517,351.9,516.7,352.1,516.6z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <rect
                        x="378.4"
                        y="502.2"
                        transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 757.1069 1012.8943)"
                        class="st53"
                        width="0.3"
                        height="8.5"
                      />
                      <rect
                        x="378"
                        y="502.2"
                        class="st54"
                        width="0.4"
                        height="8.5"
                      />
                    </g>
                    <g>
                      <rect
                        x="382.9"
                        y="499.5"
                        transform="matrix(-1 -1.224647e-16 1.224647e-16 -1 766.0366 1007.6446)"
                        class="st53"
                        width="0.3"
                        height="8.5"
                      />
                      <rect
                        x="382.5"
                        y="499.5"
                        class="st54"
                        width="0.4"
                        height="8.5"
                      />
                    </g>
                    <path
                      class="st14"
                      d="M376,503.1v-3.7c0-0.1,0.1-0.3,0.2-0.3l7.3-4.2c0.1,0,0.2-0.1,0.3-0.1c0.5,0.1,0.8,0.3,0.8,0.5v3.5
        c0,0.1-0.1,0.3-0.2,0.3l-7.3,4.5C376.7,503.7,376,503.4,376,503.1z"
                    />
                    <path
                      class="st54"
                      d="M376.4,503.2v-3.7c0-0.1,0.1-0.3,0.2-0.3l7.3-4.2c0.3-0.2,0.6,0,0.6,0.3v3.7c0,0.1-0.1,0.3-0.2,0.3
        l-7.3,4.2C376.7,503.7,376.4,503.5,376.4,503.2z"
                    />
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000169527580448028304080000016219051026928384143_"
                          gradientUnits="userSpaceOnUse"
                          x1="378.0995"
                          y1="499.1559"
                          x2="377.3825"
                          y2="500.4231"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000169527580448028304080000016219051026928384143_)",
                          }}
                          d="M378.1,499.1c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C376.7,499.1,378.1,499.1,378.1,499.1z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000075884078301943121260000003298514187730294459_"
                              class="st30"
                              d="M377.9,499.2c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C377.4,499.8,377.6,499.4,377.9,499.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000075884078301943121260000003298514187730294459_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000072268702329414334510000003199840506620587392_">
                            <use
                              xlinkHref="#SVGID_00000075884078301943121260000003298514187730294459_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M377.9,499.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C377.6,499.8,377.7,499.5,377.9,499.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000108270568342595070830000017523076291980109462_"
                          gradientUnits="userSpaceOnUse"
                          x1="379.9795"
                          y1="498.1363"
                          x2="379.2625"
                          y2="499.4035"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000108270568342595070830000017523076291980109462_)",
                          }}
                          d="M379.9,498.1c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C378.6,498.1,379.9,498.1,379.9,498.1z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000121993559555837210390000017384218923278411911_"
                              class="st30"
                              d="M379.8,498.2c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C379.3,498.8,379.5,498.4,379.8,498.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000121993559555837210390000017384218923278411911_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000041984180228258437850000015502692886706361218_">
                            <use
                              xlinkHref="#SVGID_00000121993559555837210390000017384218923278411911_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M379.8,498.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C379.4,498.8,379.6,498.5,379.8,498.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000078733401335854076870000016412715698674125739_"
                          gradientUnits="userSpaceOnUse"
                          x1="381.8594"
                          y1="497.0529"
                          x2="381.1425"
                          y2="498.3201"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000078733401335854076870000016412715698674125739_)",
                          }}
                          d="M381.8,497c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C380.5,497,381.8,497,381.8,497z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000122703681862322015270000001957536480946444694_"
                              class="st30"
                              d="M381.7,497.1c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C381.1,497.7,381.4,497.3,381.7,497.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000122703681862322015270000001957536480946444694_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000021119371532839147490000012016338779670186907_">
                            <use
                              xlinkHref="#SVGID_00000122703681862322015270000001957536480946444694_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M381.7,497.3c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C381.3,497.7,381.5,497.4,381.7,497.3z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000145750316123852351950000005690868804345556610_"
                          gradientUnits="userSpaceOnUse"
                          x1="383.8031"
                          y1="496.0014"
                          x2="383.0862"
                          y2="497.2686"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000145750316123852351950000005690868804345556610_)",
                          }}
                          d="M383.8,495.9c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C382.4,496,383.8,495.9,383.8,495.9z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000103238318983867721170000009903179388777255829_"
                              class="st30"
                              d="M383.6,496.1c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C383.1,496.7,383.3,496.3,383.6,496.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000103238318983867721170000009903179388777255829_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000085220877093268933080000017177297763552427171_">
                            <use
                              xlinkHref="#SVGID_00000103238318983867721170000009903179388777255829_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M383.6,496.3c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C383.3,496.7,383.4,496.4,383.6,496.3z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000171708985153989043200000014348607493650806144_"
                          gradientUnits="userSpaceOnUse"
                          x1="378.0995"
                          y1="501.1952"
                          x2="377.3825"
                          y2="502.4624"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000171708985153989043200000014348607493650806144_)",
                          }}
                          d="M378.1,501.1c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C376.7,501.2,378.1,501.1,378.1,501.1z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000096046445178470422830000005980872303202501544_"
                              class="st30"
                              d="M377.9,501.3c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C377.4,501.9,377.6,501.5,377.9,501.3z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000096046445178470422830000005980872303202501544_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000163035733756765073470000011317574054687767438_">
                            <use
                              xlinkHref="#SVGID_00000096046445178470422830000005980872303202501544_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M377.9,501.5c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C377.6,501.9,377.7,501.6,377.9,501.5z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000122717831532409439990000003000750789545901471_"
                          gradientUnits="userSpaceOnUse"
                          x1="379.9795"
                          y1="500.1756"
                          x2="379.2625"
                          y2="501.4428"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000122717831532409439990000003000750789545901471_)",
                          }}
                          d="M379.9,500.1c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C378.6,500.1,379.9,500.1,379.9,500.1z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000104685710680693292550000011519151546227460262_"
                              class="st30"
                              d="M379.8,500.3c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3S379.5,500.4,379.8,500.3z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000104685710680693292550000011519151546227460262_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000012445895016899108220000015051341170550011581_">
                            <use
                              xlinkHref="#SVGID_00000104685710680693292550000011519151546227460262_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M379.8,500.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C379.4,500.9,379.6,500.6,379.8,500.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000089550416569276155790000001089120365443630224_"
                          gradientUnits="userSpaceOnUse"
                          x1="381.8594"
                          y1="499.0922"
                          x2="381.1425"
                          y2="500.3594"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000089550416569276155790000001089120365443630224_)",
                          }}
                          d="M381.8,499c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C380.5,499.1,381.8,499,381.8,499z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000169518437807256705290000006515118883795805362_"
                              class="st30"
                              d="M381.7,499.2c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C381.1,499.8,381.4,499.3,381.7,499.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000169518437807256705290000006515118883795805362_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000100379101160816478250000017050289112437225364_">
                            <use
                              xlinkHref="#SVGID_00000169518437807256705290000006515118883795805362_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M381.7,499.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C381.3,499.8,381.5,499.5,381.7,499.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000108993268254565265780000015218391670988049065_"
                          gradientUnits="userSpaceOnUse"
                          x1="383.8031"
                          y1="498.0407"
                          x2="383.0862"
                          y2="499.3079"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000108993268254565265780000015218391670988049065_)",
                          }}
                          d="M383.8,498c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C382.4,498,383.8,498,383.8,498z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000143602848306060508820000001957416616986613661_"
                              class="st30"
                              d="M383.6,498.1c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C383.1,498.7,383.3,498.3,383.6,498.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000143602848306060508820000001957416616986613661_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000178910946024368383620000010065844943511545004_">
                            <use
                              xlinkHref="#SVGID_00000143602848306060508820000001957416616986613661_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M383.6,498.3c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C383.3,498.7,383.4,498.4,383.6,498.3z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <linearGradient
                        id="SVGID_00000018958721824526277940000002304425937118958503_"
                        gradientUnits="userSpaceOnUse"
                        x1="375.1967"
                        y1="504.3753"
                        x2="433.4833"
                        y2="603.854"
                      >
                        <stop offset="0" style={{ stopColor: "#556262" }} />
                        <stop
                          offset="0.1447"
                          style={{ stopColor: "#4F5D5D" }}
                        />
                        <stop
                          offset="0.5859"
                          style={{ stopColor: "#425151" }}
                        />
                        <stop offset="1" style={{ stopColor: "#3E4D4D" }} />
                      </linearGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000018958721824526277940000002304425937118958503_)",
                        }}
                        d="M441.3,512.8
          c9.3,5.4,9.4,14.2,0.1,19.6l-48,27.9c-9.3,5.4-24.5,5.4-33.8,0l-19.3-11.2c-9.3-5.4-9.4-14.2-0.1-19.6l48-27.9
          c9.3-5.4,24.5-5.4,33.8,0L441.3,512.8z M383.3,554l47.7-27.7c1.7-1,2.7-2.3,2.6-3.8c0-1.4-1-2.8-2.7-3.8l-19.3-11.2
          c-1.7-1-4-1.5-6.5-1.5c-2.5,0-4.8,0.5-6.5,1.5l-48,27.9c-1.7,1-2.7,2.3-2.6,3.8c0,1.4,1,2.8,2.7,3.8l19.3,11.2
          c1.7,1,4,1.5,6.5,1.5c2.5,0,4.8-0.5,6.5-1.5L383.3,554z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <linearGradient
                        id="SVGID_00000129183602539902343530000012703727229013810822_"
                        gradientUnits="userSpaceOnUse"
                        x1="374.6998"
                        y1="504.2559"
                        x2="435.2982"
                        y2="607.6801"
                      >
                        <stop offset="0" style={{ stopColor: "#A9B6B6" }} />
                        <stop offset="1" style={{ stopColor: "#838C8C" }} />
                      </linearGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000129183602539902343530000012703727229013810822_)",
                        }}
                        d="M441.3,512.5
          c9.7,4.8,9.4,16.7,0.1,22.1l-48,27.9c-9.3,5.4-24.5,5.4-33.8,0l-19.3-11.2c-9.3-5.4-9.4-16.7-0.1-22.1l48-25.4
          c9.3-5.4,24.5-5.4,33.8,0L441.3,512.5z M383.3,556.3l53.5-31.1c1.7-1,2.7-2.3,2.6-3.8c0-1.4-1-2.8-2.7-3.8l-25.2-14.3
          c-1.7-1-4-1.5-6.5-1.5c-2.5,0-4.8,0.5-6.5,1.5l-48,27.9c-1.7,1-7.3,4.6-6.1,8.7c0.4,1.4,4.4,4.3,6.2,5.3l19.3,11.2
          c1.7,1,4,1.5,6.5,1.5c2.5,0,4.8-0.5,6.5-1.5L383.3,556.3z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <linearGradient
                        id="SVGID_00000076588600244983493450000013821718660488732325_"
                        gradientUnits="userSpaceOnUse"
                        x1="318.2014"
                        y1="540.6081"
                        x2="350.4021"
                        y2="540.6081"
                      >
                        <stop offset="0" style={{ stopColor: "#FFFFFF" }} />
                        <stop offset="1" style={{ stopColor: "#74acdd" }} />
                      </linearGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000076588600244983493450000013821718660488732325_)",
                        }}
                        d="M348.4,548.9
          c-0.9-0.7-1.8-1.4-2.7-2.1c-1.6-1.7-2.8-3.6-3.4-5.9c-0.2-1.2-0.3-2.4-0.5-3.5c-0.1-1.8,0.3-3.5,1.1-5.1
          c0.5-1.6,1.4-3.1,2.7-4.3c1.2-1.3,2.6-2.2,4.3-2.7c1.3-0.7,2.8-1.1,4.3-1.1v-2.4l-14.2,7.5c-9.3,5.4-9.2,16.7,0.1,22.1
          l14.1,8.1v-8.8C352.2,550.5,350.2,550,348.4,548.9z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <linearGradient
                        id="SVGID_00000160152611302278654720000010062989096211302538_"
                        gradientUnits="userSpaceOnUse"
                        x1="362.9741"
                        y1="515.1058"
                        x2="416.1772"
                        y2="545.289"
                      >
                        <stop offset="0" style={{ stopColor: "#FFFFFF" }} />
                        <stop
                          offset="0.3429"
                          style={{ stopColor: "#D8DEDE" }}
                        />
                        <stop offset="0.375" style={{ stopColor: "#D6DCDC" }} />
                        <stop
                          offset="0.3865"
                          style={{ stopColor: "#CFD5D5" }}
                        />
                        <stop
                          offset="0.3947"
                          style={{ stopColor: "#C4CACA" }}
                        />
                        <stop
                          offset="0.4013"
                          style={{ stopColor: "#B3B9B9" }}
                        />
                        <stop
                          offset="0.4031"
                          style={{ stopColor: "#ADB3B3" }}
                        />
                        <stop
                          offset="0.6438"
                          style={{ stopColor: "#AAB0B0" }}
                        />
                        <stop
                          offset="0.8057"
                          style={{ stopColor: "#A1A8A8" }}
                        />
                        <stop offset="0.944" style={{ stopColor: "#929A9A" }} />
                        <stop
                          offset="0.9796"
                          style={{ stopColor: "#8D9595" }}
                        />
                        <stop
                          offset="0.9838"
                          style={{ stopColor: "#929A9A" }}
                        />
                        <stop offset="0.989" style={{ stopColor: "#A1A9A9" }} />
                        <stop
                          offset="0.9947"
                          style={{ stopColor: "#BAC1C1" }}
                        />
                        <stop offset="1" style={{ stopColor: "#D8DEDE" }} />
                      </linearGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000160152611302278654720000010062989096211302538_)",
                        }}
                        d="M441.3,512.5
          c9.7,4.8,9.4,14.5,0.1,19.9l-48,27.9c-9.3,5.4-24.5,5.4-33.8,0l-19.3-11.2c-9.3-5.4-9.4-14.4-0.1-19.8l48-25.4
          c9.3-5.4,24.5-5.4,33.8,0L441.3,512.5z M383.3,556.3l53.5-31.1c1.7-1,2.7-2.3,2.6-3.8c0-1.4-1-2.8-2.7-3.8l-25.2-14.3
          c-1.7-1-4-1.5-6.5-1.5c-2.5,0-4.8,0.5-6.5,1.5l-48,27.9c-1.7,1-7.3,4.6-6.1,8.7c0.4,1.4,4.4,4.3,6.2,5.3l19.3,11.2
          c1.7,1,4,1.5,6.5,1.5c2.5,0,4.8-0.5,6.5-1.5L383.3,556.3z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <linearGradient
                        id="SVGID_00000085251064124032115510000004461937976551738280_"
                        gradientUnits="userSpaceOnUse"
                        x1="383.2231"
                        y1="510.6426"
                        x2="398.7089"
                        y2="551.1732"
                      >
                        <stop
                          offset="0.1745"
                          style={{ stopColor: "#EAEDED" }}
                        />
                        <stop offset="1" style={{ stopColor: "#D3D6D6" }} />
                      </linearGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000085251064124032115510000004461937976551738280_)",
                        }}
                        d="M441.3,512.2
          c9.3,5.4,9.4,14.2,0.1,19.6l-48,27.9c-9.3,5.4-24.5,5.4-33.8,0l-19.3-11.2c-9.3-5.4-9.4-14.2-0.1-19.6l48-27.9
          c9.3-5.4,24.5-5.4,33.8,0L441.3,512.2z M383.1,553.6l47.9-27.8c1.7-1,2.7-2.3,2.6-3.8c0-1.4-1-2.8-2.7-3.8l-19.3-11.2
          c-1.7-1-4-1.5-6.5-1.5c-2.5,0-4.8,0.5-6.5,1.5l-48,27.9c-1.7,1-2.7,2.3-2.6,3.8c0,1.4,1,2.8,2.7,3.8l19.3,11.2
          c1.7,1,4,1.5,6.5,1.5c2.5,0,4.8-0.5,6.5-1.5L383.1,553.6z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="336.7,546.2 337.1,546.4 348.1,539.9 347.8,539.7 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st77"
                              points="336.7,546.1 337.1,546.3 348.1,539.8 347.8,539.7 								"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="364.3,561.9 364.7,562.1 376.2,555.5 375.8,555.3 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st77"
                              points="364.3,561.8 364.7,562 376.2,555.4 375.8,555.2 								"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="340.3,548.7 340.6,548.8 351,542.8 350.7,542.6 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="340.3,548.6 340.6,548.8 351,542.7 350.7,542.5 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="344.2,551 344.5,551.2 354.9,545.1 354.6,544.9 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="344.2,550.9 344.5,551.1 354.9,545 354.6,544.8 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="348.1,553.2 348.4,553.4 358.8,547.3 358.5,547.1 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="348.1,553.1 348.4,553.3 358.8,547.2 358.5,547 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="352,555.4 352.3,555.6 362.7,549.6 362.4,549.4 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="352,555.4 352.3,555.5 362.7,549.5 362.4,549.3 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="355.9,557.7 356.2,557.9 366.6,551.8 366.3,551.6 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="355.9,557.6 356.2,557.8 366.6,551.7 366.3,551.6 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="359.9,560 360.2,560.2 370.6,554.1 370.3,553.9 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="359.9,559.9 360.2,560.1 370.6,554 370.3,553.8 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="417.8,545.5 417.4,545.7 407,539.6 407.4,539.4 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="417.8,545.4 417.4,545.6 407,539.5 407.4,539.3 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="413.8,547.8 413.5,548 403.1,541.9 403.4,541.7 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="413.8,547.7 413.5,547.9 403.1,541.8 403.4,541.7 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="409.9,550 409.6,550.2 399.2,544.1 399.5,543.9 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="409.9,549.9 409.6,550.1 399.2,544 399.5,543.9 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="406,552.3 405.7,552.4 395.3,546.4 395.6,546.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="406,552.2 405.7,552.4 395.3,546.3 395.6,546.1 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="402.1,554.5 401.8,554.7 391.4,548.6 391.7,548.5 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="402.1,554.4 401.8,554.6 391.4,548.6 391.7,548.4 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="398.2,556.8 397.9,557 387.5,550.9 387.8,550.7 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="398.2,556.7 397.9,556.9 387.5,550.8 387.8,550.7 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="394.2,559.2 393.9,559.4 383.5,553.3 383.8,553.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="394.2,559.1 393.9,559.3 383.5,553.3 383.8,553.1 								"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="441.2,531.9 440.9,532.1 430.5,526 430.8,525.9 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="441.2,531.8 440.9,532 430.5,526 430.8,525.8 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="437.3,534.3 437,534.4 426.6,528.4 426.9,528.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="437.3,534.2 437,534.4 426.6,528.3 426.9,528.1 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="433.4,536.4 433.1,536.6 422.7,530.6 423,530.4 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="433.4,536.4 433.1,536.5 422.7,530.5 423,530.3 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="429.5,538.7 429.2,538.9 418.8,532.8 419.1,532.7 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="429.5,538.6 429.2,538.8 418.8,532.8 419.1,532.6 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="425.6,541 425.3,541.2 414.9,535.1 415.2,534.9 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="425.6,540.9 425.3,541.1 414.9,535 415.2,534.8 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="421.7,543.2 421.3,543.4 410.9,537.4 411.3,537.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="421.7,543.2 421.3,543.3 410.9,537.3 411.3,537.1 								"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g>
                      <g>
                        <polygon
                          class="st76"
                          points="389.4,561.7 389.1,561.9 377.9,555.4 378.3,555.2 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st77"
                          points="389.4,561.6 389.1,561.8 377.9,555.3 378.3,555.1 						"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <polygon
                          class="st76"
                          points="444.7,529.6 444.4,529.8 433.3,523.2 433.7,523 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st77"
                          points="444.7,529.5 444.4,529.7 433.3,523.1 433.7,522.9 						"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="375.3,520.5 375,520.7 364.6,514.6 364.9,514.5 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="375.3,520.4 375,520.6 364.6,514.6 364.9,514.4 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="371.4,522.9 371,523 360.6,517 361,516.8 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="371.4,522.8 371,523 360.6,516.9 361,516.7 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="367.5,525 367.1,525.2 356.7,519.2 357,519 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="367.5,525 367.1,525.1 356.7,519.1 357,518.9 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="363.5,527.3 363.2,527.5 352.8,521.4 353.1,521.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="363.5,527.2 363.2,527.4 352.8,521.3 353.1,521.2 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="359.6,529.6 359.3,529.8 348.9,523.7 349.2,523.5 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="359.6,529.5 359.3,529.7 348.9,523.6 349.2,523.4 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="355.7,531.8 355.4,532 345,526 345.3,525.8 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="355.7,531.8 355.4,531.9 345,525.9 345.3,525.7 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="351.8,534.3 351.4,534.5 341,528.4 341.4,528.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="351.8,534.2 351.4,534.4 341,528.3 341.4,528.1 								"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="398.8,507 398.4,507.2 388,501.1 388.4,500.9 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="398.8,506.9 398.4,507.1 388,501 388.4,500.8 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="394.8,509.3 394.5,509.5 384.1,503.4 384.4,503.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="394.8,509.2 394.5,509.4 384.1,503.3 384.4,503.2 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="390.9,511.5 390.6,511.7 380.2,505.6 380.5,505.4 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="390.9,511.4 390.6,511.6 380.2,505.5 380.5,505.4 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="387,513.8 386.7,513.9 376.3,507.9 376.6,507.7 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="387,513.7 386.7,513.9 376.3,507.8 376.6,507.6 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="383.1,516 382.8,516.2 372.4,510.2 372.7,510 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="383.1,515.9 382.8,516.1 372.4,510.1 372.7,509.9 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="379.2,518.3 378.9,518.5 368.5,512.4 368.8,512.2 								"
                            />
                          </g>
                          <g>
                            <polygon
                              class="st77"
                              points="379.2,518.2 378.9,518.4 368.5,512.3 368.8,512.2 								"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                    <g>
                      <g>
                        <polygon
                          class="st76"
                          points="348.1,537.5 348,537.8 336.9,531.3 337.2,531.1 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st77"
                          points="348.1,537.4 348,537.8 336.9,531.2 337.2,531 						"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <polygon
                          class="st76"
                          points="403.6,505.5 403.3,505.7 392.2,499.1 392.6,498.9 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st77"
                          points="403.6,505.4 403.3,505.6 392.2,499 392.6,498.9 						"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="406.8,505.5 407.2,505.6 418.2,499.2 417.9,499 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st77"
                              points="406.8,505.4 407.2,505.6 418.2,499.1 417.9,498.9 								"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <g>
                            <polygon
                              class="st76"
                              points="433.6,521.7 433.9,521.9 445.4,515.3 445.1,515.1 								"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <polygon
                              class="st77"
                              points="433.6,521.6 433.9,521.8 445.4,515.2 445.1,515 								"
                            />
                          </g>
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="411.8,507.1 412.1,507.3 422.5,501.2 422.2,501 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="411.8,507 412.1,507.2 422.5,501.1 422.2,500.9 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="415.7,509.4 416,509.6 426.4,503.5 426.1,503.4 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="415.7,509.3 416,509.5 426.4,503.5 426.1,503.3 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="419.6,511.6 419.9,511.8 430.3,505.7 430,505.6 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="419.6,511.5 419.9,511.7 430.3,505.6 430,505.5 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="423.5,513.9 423.8,514.1 434.2,508 433.9,507.8 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="423.5,513.8 423.8,514 434.2,507.9 433.9,507.7 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="427.4,516.1 427.7,516.3 438.1,510.3 437.8,510.1 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="427.4,516.1 427.7,516.2 438.1,510.2 437.8,510 							"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <polygon
                            class="st76"
                            points="431.4,518.4 431.7,518.6 442.1,512.5 441.8,512.4 							"
                          />
                        </g>
                        <g>
                          <polygon
                            class="st77"
                            points="431.4,518.3 431.7,518.5 442.1,512.5 441.8,512.3 							"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                  <path
                    class="st78"
                    d="M432.3,515.7L413,504.6c-2.2-1.2-5-1.9-8-1.9c-3,0-5.8,0.7-7.9,1.9l-48,27.9c-2.6,1.5-4.1,3.8-4.1,6.3
      c0,2.5,1.5,4.7,4.1,6.2l19.3,11.2c2.2,1.2,5,1.9,7.9,1.9h0c3,0,5.8-0.7,7.9-1.9l48-27.9c2.6-1.5,4.1-3.8,4.1-6.3
      C436.5,519.5,435,517.2,432.3,515.7z M431,525.8l-48,27.9c-1.7,1-4,1.5-6.5,1.5c-2.5,0-4.8-0.5-6.5-1.5l-19.3-11.2
      c-1.7-1-2.7-2.3-2.7-3.8c0-1.4,0.9-2.8,2.6-3.8l48-27.9c1.7-1,4-1.5,6.5-1.5c2.5,0,4.8,0.5,6.5,1.5l19.3,11.2
      c1.7,1,2.7,2.3,2.7,3.8C433.6,523.4,432.7,524.8,431,525.8z"
                  />

                  <linearGradient
                    id="SVGID_00000117667224220295626900000012659385312716364989_"
                    gradientUnits="userSpaceOnUse"
                    x1="393.3982"
                    y1="555.4394"
                    x2="402.32"
                    y2="546.7725"
                  >
                    <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                    <stop offset="1" style={{ stopColor: "#000000" }} />
                  </linearGradient>
                  <polygon
                    style={{
                      fill: "url(#SVGID_00000117667224220295626900000012659385312716364989_)",
                    }}
                    points="388.7,550.3 400.5,557.1 
      405.1,553.8 392.5,548.1 			"
                  />
                  <polygon
                    class="st80"
                    points="435.1,548.6 435.1,539.6 400,560 400,571.2 			"
                  />
                  <polygon
                    class="st81"
                    points="435.1,548.6 433.6,547.8 398.5,568.1 400,569 			"
                  />
                  <polygon
                    class="st82"
                    points="435.1,548.6 433.6,547.8 433.6,540.5 435.1,539.6 			"
                  />
                  <g>
                    <g>
                      <polygon
                        class="st83"
                        points="440.3,530.1 440.3,545.7 435.2,548.7 435.2,533.1 					"
                      />
                      <g>
                        <g>
                          <polygon
                            class="st20"
                            points="442.2,531.1 442.2,548.9 437,552 437,534.1 							"
                          />
                          <polygon
                            class="st84"
                            points="441.5,532.9 441.5,534.8 437.7,537.1 437.7,535.1 							"
                          />
                          <polygon
                            class="st85"
                            points="435.2,550.8 437,552 437,534.1 435.2,533.1 							"
                          />
                          <polygon
                            class="st86"
                            points="440.3,530.1 442.2,531.1 437,534.1 435.2,533.1 							"
                          />
                          <polygon
                            class="st87"
                            points="435.9,533.1 440.3,530.5 441.4,531.1 437,533.7 							"
                          />
                        </g>
                        <polygon
                          class="st83"
                          points="440.3,530.5 435.9,533.1 436.1,533.2 440.3,530.7 						"
                        />
                        <polygon
                          class="st85"
                          points="441.4,531.1 440.3,530.5 440.3,530.7 441.3,531.2 						"
                        />
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="441.5,532.9 441.5,534.8 441.4,534.7 441.4,533 					"
                      />
                      <polygon
                        class="st85"
                        points="437.7,537.1 441.5,534.8 441.4,534.7 437.7,536.9 					"
                      />
                      <polygon
                        class="st84"
                        points="441.4,533 437.7,535.1 437.7,536.9 441.4,534.7 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="441.5,535.8 441.5,537.7 441.4,537.6 441.4,535.9 					"
                      />
                      <polygon
                        class="st85"
                        points="437.7,540 441.5,537.7 441.4,537.6 437.7,539.8 					"
                      />
                      <polygon
                        class="st84"
                        points="441.4,535.9 437.7,538.1 437.7,539.8 441.4,537.6 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="441.5,538.8 441.5,540.7 441.4,540.6 441.4,538.9 					"
                      />
                      <polygon
                        class="st85"
                        points="437.7,542.9 441.5,540.7 441.4,540.6 437.7,542.8 					"
                      />
                      <polygon
                        class="st84"
                        points="441.4,538.9 437.7,541 437.7,542.8 441.4,540.6 					"
                      />
                    </g>
                  </g>
                  <g>
                    <polygon
                      class="st86"
                      points="435.2,535.9 437,538.2 401.9,558.5 400.1,556.1 				"
                    />
                    <polygon
                      class="st83"
                      points="401.9,559 437,538.7 437,538.2 401.9,558.5 				"
                    />
                  </g>
                  <polygon
                    class="st26"
                    points="437,538.7 437,552 401.9,572.2 401.9,559 			"
                  />
                  <polygon
                    class="st47"
                    points="437,538.7 437,544.2 401.9,564.5 401.9,559 			"
                  />
                  <g>
                    <g>
                      <polygon
                        class="st89"
                        points="403.1,571.5 403.1,558.3 403.3,558.2 403.3,571.4 					"
                      />
                      <polygon
                        class="st89"
                        points="404.3,570.8 404.3,557.6 404.4,557.6 404.4,570.7 					"
                      />
                      <polygon
                        class="st89"
                        points="405.4,570.2 405.4,557 405.6,556.9 405.6,570.1 					"
                      />
                      <polygon
                        class="st89"
                        points="406.5,569.6 406.5,556.4 406.7,556.3 406.7,569.5 					"
                      />
                      <polygon
                        class="st89"
                        points="407.7,568.9 407.7,555.7 407.8,555.6 407.8,568.8 					"
                      />
                      <polygon
                        class="st89"
                        points="408.8,568.3 408.8,555.1 409,555 409,568.2 					"
                      />
                      <polygon
                        class="st89"
                        points="409.9,567.6 409.9,554.4 410.1,554.3 410.1,567.5 					"
                      />
                      <polygon
                        class="st89"
                        points="411.1,566.9 411.1,553.8 411.2,553.7 411.2,566.8 					"
                      />
                      <polygon
                        class="st89"
                        points="412.2,566.3 412.2,553.1 412.4,553 412.4,566.2 					"
                      />
                      <polygon
                        class="st89"
                        points="413.3,565.6 413.3,552.5 413.5,552.4 413.5,565.6 					"
                      />
                      <polygon
                        class="st89"
                        points="414.5,565 414.5,551.8 414.6,551.7 414.6,564.9 					"
                      />
                      <polygon
                        class="st89"
                        points="415.6,564.3 415.6,551.2 415.8,551.1 415.8,564.2 					"
                      />
                      <polygon
                        class="st89"
                        points="416.7,563.7 416.7,550.5 416.9,550.4 416.9,563.6 					"
                      />
                      <polygon
                        class="st89"
                        points="417.8,563 417.8,549.8 418,549.8 418,562.9 					"
                      />
                      <polygon
                        class="st89"
                        points="419,562.4 419,549.2 419.1,549.1 419.1,562.3 					"
                      />
                      <polygon
                        class="st89"
                        points="420.1,561.7 420.1,548.5 420.3,548.4 420.3,561.6 					"
                      />
                      <polygon
                        class="st89"
                        points="421.2,561.1 421.2,547.9 421.4,547.8 421.4,561 					"
                      />
                      <polygon
                        class="st89"
                        points="422.4,560.4 422.4,547.2 422.5,547.1 422.5,560.3 					"
                      />
                      <polygon
                        class="st89"
                        points="423.5,559.8 423.5,546.6 423.7,546.5 423.7,559.7 					"
                      />
                      <polygon
                        class="st89"
                        points="424.6,559.1 424.6,545.9 424.8,545.8 424.8,559 					"
                      />
                      <polygon
                        class="st89"
                        points="425.8,558.5 425.8,545.3 425.9,545.2 425.9,558.4 					"
                      />
                      <polygon
                        class="st89"
                        points="426.9,557.8 426.9,544.6 427.1,544.5 427.1,557.7 					"
                      />
                      <polygon
                        class="st89"
                        points="428,557.2 428,544 428.2,543.9 428.2,557.1 					"
                      />
                      <polygon
                        class="st89"
                        points="429.2,556.5 429.2,543.3 429.3,543.2 429.3,556.4 					"
                      />
                      <polygon
                        class="st89"
                        points="430.3,555.9 430.3,542.7 430.5,542.6 430.5,555.8 					"
                      />
                      <polygon
                        class="st89"
                        points="431.4,555.2 431.4,542 431.6,541.9 431.6,555.1 					"
                      />
                      <polygon
                        class="st89"
                        points="432.6,554.5 432.6,541.4 432.7,541.3 432.7,554.4 					"
                      />
                      <polygon
                        class="st89"
                        points="433.7,553.9 433.7,540.7 433.8,540.6 433.8,553.8 					"
                      />
                      <polygon
                        class="st89"
                        points="434.8,553.2 434.8,540.1 435,540 435,553.1 					"
                      />
                      <polygon
                        class="st89"
                        points="435.9,552.6 435.9,539.4 436.1,539.3 436.1,552.5 					"
                      />
                    </g>
                    <polygon
                      class="st89"
                      points="401.9,559 437,538.7 437,538.9 401.9,559.2 				"
                    />
                    <polygon
                      class="st89"
                      points="401.9,562.6 437,542.3 437,542.5 401.9,562.8 				"
                    />
                    <polygon
                      class="st89"
                      points="401.9,566.3 437,546 437,546.2 401.9,566.5 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000108272559540657852940000010084480041885131964_"
                              class="st30"
                              d="M429.9,525.3c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C429.4,525.9,429.6,525.5,429.9,525.3z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000108272559540657852940000010084480041885131964_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000075159051221194537510000005418800760407408828_">
                            <use
                              xlinkHref="#SVGID_00000108272559540657852940000010084480041885131964_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000013175371315786675310000014433768791221258416_"
                        cx="9220.1113"
                        cy="525.9338"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000013175371315786675310000014433768791221258416_)",
                        }}
                        d="M429.6,525.8c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1C430.1,525.2,429.8,525.4,429.6,525.8z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000093873316640821640260000009389407180762174376_"
                              class="st30"
                              d="M428.7,526c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3S428.4,526.2,428.7,526z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000093873316640821640260000009389407180762174376_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000106855211328622498870000005036612799659797171_">
                            <use
                              xlinkHref="#SVGID_00000093873316640821640260000009389407180762174376_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000050625190010709597730000009234994492655772584_"
                        cx="9221.2949"
                        cy="526.6149"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000050625190010709597730000009234994492655772584_)",
                        }}
                        d="M428.4,526.4c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1S428.6,526.1,428.4,526.4z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000123429651309445162090000012128467488458393749_"
                              class="st30"
                              d="M427.5,526.7c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C427,527.3,427.2,526.9,427.5,526.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000123429651309445162090000012128467488458393749_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000107562729995357889370000012364195257944540580_">
                            <use
                              xlinkHref="#SVGID_00000123429651309445162090000012128467488458393749_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000171708920104448812360000009608340034175414163_"
                        cx="9222.4775"
                        cy="527.296"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000171708920104448812360000009608340034175414163_)",
                        }}
                        d="M427.2,527.1c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1C427.8,526.6,427.4,526.8,427.2,527.1z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000089570214227429933870000010939376824437245872_"
                              class="st30"
                              d="M426.3,527.4c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3S426.1,527.6,426.3,527.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000089570214227429933870000010939376824437245872_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000086669507779509212460000000379747759929063825_">
                            <use
                              xlinkHref="#SVGID_00000089570214227429933870000010939376824437245872_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000106122804585733664450000010509145899773618353_"
                        cx="9223.6602"
                        cy="527.9771"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000106122804585733664450000010509145899773618353_)",
                        }}
                        d="M426,527.8c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1C426.6,527.3,426.3,527.5,426,527.8z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000024002156556364235710000010689674646317455787_"
                              class="st30"
                              d="M425.2,528.1c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C424.6,528.6,424.9,528.2,425.2,528.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000024002156556364235710000010689674646317455787_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000030478204363917023200000003244343571028266663_">
                            <use
                              xlinkHref="#SVGID_00000024002156556364235710000010689674646317455787_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000183937007041957823310000002273305008514776474_"
                        cx="9224.8438"
                        cy="528.6581"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000183937007041957823310000002273305008514776474_)",
                        }}
                        d="M424.9,528.5c-0.2,0.4-0.2,0.7,0,0.9
          c0.2,0.1,0.8,0.1,1-0.3s0-0.9-0.3-1C425.4,528,425.1,528.1,424.9,528.5z"
                      />
                    </g>
                  </g>
                  <g>
                    <polygon
                      class="st95"
                      points="422.1,525.2 435.1,535.7 436.5,538.2 401.8,558.3 400.3,555.6 387.4,545.1 				"
                    />
                    <polygon
                      class="st26"
                      points="435.1,535.7 436.5,538.2 401.8,558.3 400.3,555.6 				"
                    />
                    <g>
                      <g>
                        <polygon
                          class="st89"
                          points="401.7,558.3 400.2,555.7 387.4,545.2 387.4,545.1 387.5,545 400.3,555.6 401.9,558.2 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="402.8,557.7 401.3,555 388.4,544.5 388.6,544.4 401.4,554.9 402.9,557.6 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="403.8,557.1 402.3,554.4 389.4,543.9 389.6,543.8 402.5,554.3 404,557 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="404.9,556.5 403.4,553.9 390.5,543.3 390.6,543.2 403.5,553.7 405,556.4 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="405.9,555.9 404.4,553.2 391.6,542.7 391.7,542.6 404.6,553.1 406.1,555.8 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="407,555.2 405.5,552.6 392.6,542.1 392.8,542 405.6,552.5 407.2,555.2 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="408,554.7 406.5,552 393.7,541.5 393.8,541.4 406.7,551.9 408.2,554.6 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="409.1,554.1 407.6,551.4 394.7,540.9 394.9,540.8 407.7,551.3 409.3,554 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="410.2,553.5 408.6,550.8 395.8,540.3 395.9,540.2 408.8,550.7 410.3,553.4 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="411.2,552.8 409.7,550.2 396.8,539.7 397,539.6 409.8,550.1 411.4,552.7 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="412.3,552.2 410.7,549.5 397.9,539.1 398.1,539 410.9,549.4 412.4,552.1 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="413.3,551.6 411.8,549 398.9,538.5 399.1,538.4 412,548.9 413.5,551.5 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="414.4,551 412.9,548.4 400,537.9 400.2,537.8 413,548.2 414.5,550.9 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="415.4,550.4 413.9,547.8 401.1,537.3 401.2,537.2 414.1,547.6 415.6,550.3 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="416.5,549.8 415,547.1 402.1,536.6 402.3,536.5 415.1,547 416.7,549.7 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="417.5,549.2 416,546.6 403.2,536 403.3,535.9 416.2,546.4 417.7,549.1 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="418.6,548.6 417.1,546 404.2,535.5 404.3,535.3 417.2,545.9 418.7,548.5 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="419.7,548 418.1,545.3 405.3,534.8 405.5,534.7 418.3,545.2 419.8,547.9 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="420.7,547.3 419.2,544.7 406.4,534.2 406.6,534.1 419.3,544.5 420.9,547.2 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="421.8,546.7 420.2,544 407.5,533.6 407.6,533.5 420.4,543.9 421.9,546.6 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="422.8,546.1 421.3,543.4 408.5,533 408.7,532.9 421.4,543.3 423,546 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="423.9,545.5 422.4,542.8 409.6,532.4 409.7,532.3 422.5,542.7 424,545.4 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="424.9,544.9 423.4,542.2 410.6,531.8 410.8,531.7 423.6,542.1 425.1,544.8 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="426,544.3 424.5,541.6 411.7,531.2 411.8,531.1 424.6,541.5 426.2,544.2 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="427,543.7 425.5,541 412.7,530.5 412.9,530.5 425.7,540.9 427.2,543.6 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="428.1,543.1 426.6,540.5 413.7,530 413.9,529.9 426.7,540.3 428.2,543 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="429.1,542.4 427.6,539.8 414.8,529.4 415,529.3 427.8,539.7 429.3,542.4 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="430.2,541.9 428.7,539.2 415.9,528.7 416.1,528.6 428.8,539.1 430.4,541.8 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="431.3,541.2 429.7,538.6 417,528.1 417.1,528 429.9,538.4 431.4,541.1 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="432.3,540.7 430.8,538 418,527.5 418.2,527.4 430.9,537.9 432.5,540.6 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="433.4,540 431.9,537.3 419.1,526.9 419.2,526.8 432,537.2 433.5,539.9 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="434.4,539.4 432.9,536.7 420.1,526.3 420.3,526.2 433.1,536.6 434.6,539.3 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st89"
                          points="435.5,538.8 434,536.1 421.2,525.7 421.4,525.6 434.1,536 435.6,538.7 						"
                        />
                      </g>
                    </g>
                    <polygon
                      class="st85"
                      points="387.4,545.1 400.3,555.6 401.8,558.3 401.3,558.2 400,555.8 387.4,545.5 				"
                    />
                  </g>
                  <polygon
                    class="st81"
                    points="411.2,566.8 411.2,557.5 428,547.7 428,557.1 			"
                  />

                  <linearGradient
                    id="SVGID_00000095331126029491879880000000215097363438892162_"
                    gradientUnits="userSpaceOnUse"
                    x1="423.3594"
                    y1="561.4224"
                    x2="410.0471"
                    y2="546.5935"
                  >
                    <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                    <stop offset="1" style={{ stopColor: "#000000" }} />
                  </linearGradient>
                  <polygon
                    style={{
                      fill: "url(#SVGID_00000095331126029491879880000000215097363438892162_)",
                    }}
                    points="411.2,566.8 411.2,557.5 
      428,547.7 428,557.1 			"
                  />
                  <polygon
                    class="st97"
                    points="428,557.1 419.8,552.5 425.5,549.2 428,547.7 			"
                  />
                  <g>
                    <defs>
                      <polygon
                        id="SVGID_00000028314422598004945750000003933599082402685347_"
                        points="411.2,566.8 411.2,557.5 428,547.7 
          428,557.1 					"
                      />
                    </defs>
                    <clipPath id="SVGID_00000092454187784283156180000009266525623071655062_">
                      <use
                        xlinkHref="#SVGID_00000028314422598004945750000003933599082402685347_"
                        style={{ overflow: "visible" }}
                      />
                    </clipPath>
                    <g
                      style={{
                        clipPath:
                          "url(#SVGID_00000092454187784283156180000009266525623071655062_)",
                      }}
                    >
                      <g>
                        <polygon
                          class="st99"
                          points="426.6,556.1 410.1,565.6 410.1,565.2 426.6,555.8 						"
                        />
                        <polygon
                          class="st14"
                          points="426.2,555.6 426.6,555.8 410.1,565.2 409.8,565 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st99"
                          points="426.2,555.6 409.8,565.1 409.8,564.7 426.2,555.3 						"
                        />
                        <polygon
                          class="st14"
                          points="425.9,555.1 426.2,555.3 409.8,564.7 409.5,564.5 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st99"
                          points="425.9,555.1 409.4,564.6 409.4,564.2 425.9,554.8 						"
                        />
                        <polygon
                          class="st14"
                          points="425.5,554.6 425.9,554.8 409.4,564.2 409.1,564 						"
                        />
                      </g>
                      <g>
                        <polygon
                          class="st99"
                          points="425.5,554.6 409.1,564.1 409.1,563.7 425.5,554.3 						"
                        />
                        <polygon
                          class="st14"
                          points="421,551.8 425.5,554.3 409.1,563.7 404.6,561.1 						"
                        />
                      </g>
                    </g>
                  </g>

                  <linearGradient
                    id="SVGID_00000111880964079599124730000000811922718178009755_"
                    gradientUnits="userSpaceOnUse"
                    x1="421.3923"
                    y1="560.2137"
                    x2="415.1822"
                    y2="549.8351"
                  >
                    <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                    <stop offset="1" style={{ stopColor: "#000000" }} />
                  </linearGradient>
                  <polygon
                    style={{
                      fill: "url(#SVGID_00000111880964079599124730000000811922718178009755_)",
                    }}
                    points="411.2,566.8 411.2,557.5 
      428,547.7 428,557.1 			"
                  />
                  <g>
                    <g>
                      <polygon
                        class="st83"
                        points="400,553.3 400,571.2 394.9,574.2 394.9,556.3 					"
                      />
                      <g>
                        <g>
                          <polygon
                            class="st20"
                            points="401.9,554.4 401.9,572.2 396.8,575.2 396.8,557.4 							"
                          />
                          <polygon
                            class="st84"
                            points="401.3,556.2 401.3,558.1 397.4,560.3 397.4,558.4 							"
                          />
                          <polygon
                            class="st85"
                            points="394.9,574.2 396.8,575.2 396.8,557.4 394.9,556.3 							"
                          />
                          <polygon
                            class="st86"
                            points="400,553.3 401.9,554.4 396.8,557.4 394.9,556.3 							"
                          />
                          <polygon
                            class="st87"
                            points="395.7,556.3 400.1,553.8 401.1,554.4 396.7,557 							"
                          />
                        </g>
                        <polygon
                          class="st83"
                          points="400.1,553.8 395.7,556.3 395.8,556.4 400,553.9 						"
                        />
                        <polygon
                          class="st85"
                          points="401.1,554.4 400.1,553.8 400.1,553.9 401,554.5 						"
                        />
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="401.3,556.2 401.3,558.1 401.1,558 401.1,556.2 					"
                      />
                      <polygon
                        class="st85"
                        points="397.4,560.3 401.3,558.1 401.1,558 397.4,560.1 					"
                      />
                      <polygon
                        class="st84"
                        points="401.1,556.2 397.4,558.4 397.4,560.1 401.1,558 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="401.3,559.1 401.3,561 401.1,560.9 401.1,559.2 					"
                      />
                      <polygon
                        class="st85"
                        points="397.4,563.3 401.3,561 401.1,560.9 397.4,563.1 					"
                      />
                      <polygon
                        class="st84"
                        points="401.1,559.2 397.4,561.3 397.4,563.1 401.1,560.9 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="401.3,562 401.3,563.9 401.1,563.9 401.1,562.1 					"
                      />
                      <polygon
                        class="st85"
                        points="397.4,566.2 401.3,563.9 401.1,563.9 397.4,566 					"
                      />
                      <polygon
                        class="st84"
                        points="401.1,562.1 397.4,564.3 397.4,566 401.1,563.9 					"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <polygon
                        class="st83"
                        points="442.2,531.1 442.2,546.8 437,549.8 437,534.1 					"
                      />
                      <g>
                        <g>
                          <polygon
                            class="st101"
                            points="444,532.2 444,550 438.9,553 438.9,535.2 							"
                          />
                          <polygon
                            class="st84"
                            points="443.4,534 443.4,535.9 439.5,538.1 439.5,536.2 							"
                          />
                          <polygon
                            class="st85"
                            points="437,551.9 438.9,553 438.9,535.2 437,534.1 							"
                          />
                          <polygon
                            class="st86"
                            points="442.2,531.1 444,532.2 438.9,535.2 437,534.1 							"
                          />
                          <polygon
                            class="st87"
                            points="437.8,534.1 442.2,531.6 443.3,532.2 438.9,534.8 							"
                          />
                        </g>
                        <polygon
                          class="st83"
                          points="442.2,531.6 437.8,534.1 438,534.2 442.2,531.7 						"
                        />
                        <polygon
                          class="st85"
                          points="443.3,532.2 442.2,531.6 442.2,531.7 443.1,532.3 						"
                        />
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="443.4,534 443.4,535.9 443.3,535.8 443.3,534 					"
                      />
                      <polygon
                        class="st85"
                        points="439.5,538.1 443.4,535.9 443.3,535.8 439.5,537.9 					"
                      />
                      <polygon
                        class="st84"
                        points="443.3,534 439.5,536.2 439.5,537.9 443.3,535.8 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="443.4,536.9 443.4,538.8 443.3,538.7 443.3,537 					"
                      />
                      <polygon
                        class="st85"
                        points="439.5,541.1 443.4,538.8 443.3,538.7 439.5,540.9 					"
                      />
                      <polygon
                        class="st84"
                        points="443.3,537 439.5,539.1 439.5,540.9 443.3,538.7 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="443.4,539.8 443.4,541.7 443.3,541.6 443.3,539.9 					"
                      />
                      <polygon
                        class="st85"
                        points="439.5,544 443.4,541.7 443.3,541.6 439.5,543.8 					"
                      />
                      <polygon
                        class="st84"
                        points="443.3,539.9 439.5,542.1 439.5,543.8 443.3,541.6 					"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <polygon
                        class="st83"
                        points="401.9,554.4 401.9,572.2 396.8,575.2 396.8,557.4 					"
                      />
                      <g>
                        <g>
                          <polygon
                            class="st101"
                            points="403.8,555.4 403.8,573.3 398.6,576.3 398.6,558.5 							"
                          />
                          <polygon
                            class="st84"
                            points="403.1,557.2 403.1,559.1 399.3,561.4 399.3,559.5 							"
                          />
                          <polygon
                            class="st85"
                            points="396.8,575.2 398.6,576.3 398.6,558.5 396.8,557.4 							"
                          />
                          <polygon
                            class="st86"
                            points="401.9,554.4 403.8,555.4 398.6,558.5 396.8,557.4 							"
                          />
                          <polygon
                            class="st87"
                            points="397.5,557.4 401.9,554.8 403,555.5 398.6,558 							"
                          />
                        </g>
                        <polygon
                          class="st83"
                          points="401.9,554.8 397.5,557.4 397.7,557.5 401.9,555 						"
                        />
                        <polygon
                          class="st85"
                          points="403,555.5 401.9,554.8 401.9,555 402.9,555.5 						"
                        />
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="403.1,557.2 403.1,559.1 403,559 403,557.3 					"
                      />
                      <polygon
                        class="st85"
                        points="399.3,561.4 403.1,559.1 403,559 399.3,561.2 					"
                      />
                      <polygon
                        class="st84"
                        points="403,557.3 399.3,559.5 399.3,561.2 403,559 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="403.1,560.2 403.1,562.1 403,562 403,560.2 					"
                      />
                      <polygon
                        class="st85"
                        points="399.3,564.3 403.1,562.1 403,562 399.3,564.1 					"
                      />
                      <polygon
                        class="st84"
                        points="403,560.2 399.3,562.4 399.3,564.1 403,562 					"
                      />
                    </g>
                    <g>
                      <polygon
                        class="st88"
                        points="403.1,563.1 403.1,565 403,564.9 403,563.2 					"
                      />
                      <polygon
                        class="st85"
                        points="399.3,567.3 403.1,565 403,564.9 399.3,567.1 					"
                      />
                      <polygon
                        class="st84"
                        points="403,563.2 399.3,565.3 399.3,567.1 403,564.9 					"
                      />
                    </g>
                  </g>
                  <g>
                    <path
                      class="st102"
                      d="M398.3,550L398.3,550c-0.1,0-0.1,0-0.1,0.1v5.2c0,0.1,0,0.1,0.1,0.1l0,0c0.1,0,0.1,0,0.1-0.1v-5.2
        C398.4,550,398.4,550,398.3,550z"
                    />
                    <path
                      class="st103"
                      d="M398.2,550.1c0,0-1.1-0.3-1.5,0.5c-0.4,0.8-1.6,0.8-1.6,0.8v2.6c0,0,1.2,0,1.6-0.8
        c0.4-0.8,1.5-0.5,1.5-0.5V550.1z"
                    />
                    <path
                      class="st104"
                      d="M396.7,550.6c-0.4,0.8-1.6,0.8-1.6,0.8v2.6c0,0,1.2,0,1.6-0.8V550.6z"
                    />
                  </g>
                  <g>
                    <path
                      class="st102"
                      d="M438.6,526.9L438.6,526.9c-0.1,0-0.1,0-0.1,0.1v5.2c0,0.1,0,0.1,0.1,0.1l0,0c0.1,0,0.1,0,0.1-0.1v-5.2
        C438.7,527,438.6,526.9,438.6,526.9z"
                    />
                    <path
                      class="st103"
                      d="M438.5,527c0,0-1.1-0.3-1.5,0.5c-0.4,0.8-1.6,0.8-1.6,0.8v2.6c0,0,1.2,0,1.6-0.8c0.4-0.8,1.5-0.5,1.5-0.5
        V527z"
                    />
                    <path
                      class="st104"
                      d="M437,527.6c-0.4,0.8-1.6,0.8-1.6,0.8v2.6c0,0,1.2,0,1.6-0.8V527.6z"
                    />
                  </g>
                  <g>
                    <g>
                      <path
                        d="M414.7,553.2c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0.1-0.1,0.1
          c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0
          c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0.1,0.1,0.3c0,0.1,0,0.2-0.1,0.4
          c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0
          c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.3l0.4-0.2c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0
          c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.2
          c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1
          c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0.1-0.3s0.1-0.2,0.2-0.3
          c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0.1
          c0,0.1,0.1,0.1,0.1,0.3L414.7,553.2z"
                      />
                      <path d="M415.8,553.9v-1.7l-0.6,0.4v-0.4l1.7-1v0.4l-0.6,0.4v1.7L415.8,553.9z" />
                      <path
                        d="M418.1,552.3l-1,0.6l-0.1,0.4l-0.4,0.3l1-2.6l0.2-0.1l0.9,1.5l-0.5,0.3L418.1,552.3z M417.3,552.5l0.7-0.4l-0.4-0.7
          L417.3,552.5z"
                      />
                      <path
                        d="M418.9,550.1l0.8-0.4c0.2-0.1,0.3-0.1,0.4-0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.2,0.2c0,0.1,0.1,0.2,0.1,0.3
          c0,0.1,0,0.3-0.1,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.4,0.3l-0.8,0.4V550.1z M419.6,551.4
          c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3
          c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0.1l-0.3,0.2v1.4L419.6,551.4z"
                      />
                      <path d="M421,551v-2.1l0.4-0.2v2.1L421,551z" />
                      <path
                        d="M423.1,547.7l0.4-0.2v1.3c0,0.3-0.1,0.5-0.2,0.8c-0.2,0.2-0.4,0.4-0.7,0.6c-0.3,0.2-0.5,0.2-0.7,0.2
          c-0.2-0.1-0.2-0.2-0.2-0.5v-1.2l0.4-0.2v1.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1
          c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.1-0.3,0.1-0.5V547.7z"
                      />
                      <path d="M425.6,548.3v-1.7l-0.6,2l-0.2,0.1l-0.6-1.3v1.7l-0.4,0.2v-2.1l0.6-0.4l0.5,1.2l0.5-1.7l0.6-0.3v2.1L425.6,548.3z" />
                    </g>
                    <g>
                      <path
                        class="st14"
                        d="M414.8,553.3c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0.1
          c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0.1-0.1,0.2s0,0.1,0,0.2c0,0.1,0,0.1,0,0.1c0,0,0.1,0,0.1,0
          c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0.1,0.1,0.3
          c0,0.1,0,0.2-0.1,0.4c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1
          c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.3l0.4-0.2c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0
          c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.1-0.1,0.1-0.2
          c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1
          c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.1-0.1-0.1-0.2
          c0-0.1,0-0.2,0.1-0.3s0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1
          c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0.1c0,0.1,0.1,0.1,0.1,0.3L414.8,553.3z"
                      />
                      <path
                        class="st14"
                        d="M416,554.1v-1.7l-0.6,0.4v-0.4l1.7-1v0.4l-0.6,0.4v1.7L416,554.1z"
                      />
                      <path
                        class="st14"
                        d="M418.3,552.5l-1,0.6l-0.1,0.4l-0.4,0.3l1-2.6l0.2-0.1l0.9,1.5l-0.5,0.3L418.3,552.5z M417.5,552.7
          l0.7-0.4l-0.4-0.7L417.5,552.7z"
                      />
                      <path
                        class="st14"
                        d="M419.1,550.3l0.8-0.4c0.2-0.1,0.3-0.1,0.4-0.2c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0.1,0.2,0.2
          c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.3-0.1,0.4c0,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.2-0.4,0.3
          l-0.8,0.4V550.3z M419.8,551.6c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.3s0.1-0.2,0.1-0.3
          c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0.1l-0.3,0.2v1.4L419.8,551.6z"
                      />
                      <path
                        class="st14"
                        d="M421.1,551.2v-2.1l0.4-0.2v2.1L421.1,551.2z"
                      />
                      <path
                        class="st14"
                        d="M423.3,547.9l0.4-0.2v1.3c0,0.3-0.1,0.5-0.2,0.8s-0.4,0.4-0.7,0.6c-0.3,0.2-0.5,0.2-0.7,0.2
          s-0.2-0.2-0.2-0.5v-1.2l0.4-0.2v1.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1
          c0.2-0.1,0.3-0.2,0.4-0.4c0.1-0.1,0.1-0.3,0.1-0.5V547.9z"
                      />
                      <path
                        class="st14"
                        d="M425.8,548.5v-1.7l-0.6,2l-0.2,0.1l-0.6-1.3v1.7l-0.4,0.2v-2.1l0.6-0.4l0.5,1.2l0.5-1.7l0.6-0.3v2.1
          L425.8,548.5z"
                      />
                    </g>
                  </g>
                  <g>
                    <radialGradient
                      id="SVGID_00000147927604115523680660000005412360131601445812_"
                      cx="391.5154"
                      cy="542.0687"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000147927604115523680660000005412360131601445812_)",
                      }}
                      d="M392.3,542.1c0,0.4-0.3,0.8-0.8,0.8
        s-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8S392.3,541.6,392.3,542.1z"
                    />

                    <radialGradient
                      id="SVGID_00000155862735231032710080000013703655703351162754_"
                      cx="392.8555"
                      cy="541.2961"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000155862735231032710080000013703655703351162754_)",
                      }}
                      d="M393.6,541.3c0,0.4-0.3,0.8-0.8,0.8
        s-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8S393.6,540.9,393.6,541.3z"
                    />

                    <radialGradient
                      id="SVGID_00000105416056341117509590000013671390980750127265_"
                      cx="394.1956"
                      cy="540.5236"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <circle
                      style={{
                        fill: "url(#SVGID_00000105416056341117509590000013671390980750127265_)",
                      }}
                      cx="394.2"
                      cy="540.5"
                      r="0.8"
                    />

                    <radialGradient
                      id="SVGID_00000124869618728969750240000000392182698968306615_"
                      cx="395.5358"
                      cy="539.751"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000124869618728969750240000000392182698968306615_)",
                      }}
                      d="M396.3,539.8c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8C396,539,396.3,539.3,396.3,539.8z"
                    />
                  </g>
                  <g>
                    <radialGradient
                      id="SVGID_00000082370718167279718060000001918331260824395158_"
                      cx="399.0223"
                      cy="537.8387"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000082370718167279718060000001918331260824395158_)",
                      }}
                      d="M399.8,537.8c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8C399.4,537.1,399.8,537.4,399.8,537.8z"
                    />

                    <radialGradient
                      id="SVGID_00000106847736906088268260000012632012819625810080_"
                      cx="400.3624"
                      cy="537.0662"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <circle
                      style={{
                        fill: "url(#SVGID_00000106847736906088268260000012632012819625810080_)",
                      }}
                      cx="400.4"
                      cy="537.1"
                      r="0.8"
                    />

                    <radialGradient
                      id="SVGID_00000009592404735890912710000000380870351989651343_"
                      cx="401.7026"
                      cy="536.2936"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000009592404735890912710000000380870351989651343_)",
                      }}
                      d="M402.5,536.3c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8C402.1,535.5,402.5,535.9,402.5,536.3z"
                    />

                    <radialGradient
                      id="SVGID_00000086660657862140296270000018224548055313030313_"
                      cx="403.0427"
                      cy="535.5211"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000086660657862140296270000018224548055313030313_)",
                      }}
                      d="M403.8,535.5c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8C403.5,534.8,403.8,535.1,403.8,535.5z"
                    />
                  </g>
                  <g>
                    <radialGradient
                      id="SVGID_00000031201846559836180080000007869889939613006259_"
                      cx="406.512"
                      cy="533.556"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000031201846559836180080000007869889939613006259_)",
                      }}
                      d="M407.3,533.6c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8C406.9,532.8,407.3,533.1,407.3,533.6z"
                    />

                    <radialGradient
                      id="SVGID_00000175299198959258516370000010096618861803745164_"
                      cx="407.8521"
                      cy="532.7834"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000175299198959258516370000010096618861803745164_)",
                      }}
                      d="M408.6,532.8c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8C408.3,532,408.6,532.4,408.6,532.8z"
                    />

                    <radialGradient
                      id="SVGID_00000093883488448851025800000002421786695674642051_"
                      cx="409.1923"
                      cy="532.0109"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <circle
                      style={{
                        fill: "url(#SVGID_00000093883488448851025800000002421786695674642051_)",
                      }}
                      cx="409.2"
                      cy="532"
                      r="0.8"
                    />

                    <radialGradient
                      id="SVGID_00000106107684757091199890000014716685642125963392_"
                      cx="410.5324"
                      cy="531.2383"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000106107684757091199890000014716685642125963392_)",
                      }}
                      d="M411.3,531.2c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8C411,530.5,411.3,530.8,411.3,531.2z"
                    />
                  </g>
                  <g>
                    <radialGradient
                      id="SVGID_00000046299355164782255200000006496438488471580319_"
                      cx="413.8117"
                      cy="529.2669"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000046299355164782255200000006496438488471580319_)",
                      }}
                      d="M414.6,529.3c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8C414.2,528.5,414.6,528.8,414.6,529.3z"
                    />

                    <radialGradient
                      id="SVGID_00000118355811758929507930000015700162364657068181_"
                      cx="415.1518"
                      cy="528.4943"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000118355811758929507930000015700162364657068181_)",
                      }}
                      d="M415.9,528.5c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8c0-0.4,0.3-0.8,0.8-0.8C415.6,527.7,415.9,528.1,415.9,528.5z"
                    />

                    <radialGradient
                      id="SVGID_00000077319088524827159880000006075862256966894518_"
                      cx="416.4919"
                      cy="527.7218"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <circle
                      style={{
                        fill: "url(#SVGID_00000077319088524827159880000006075862256966894518_)",
                      }}
                      cx="416.5"
                      cy="527.7"
                      r="0.8"
                    />

                    <radialGradient
                      id="SVGID_00000084500385205517713810000017810660066371354009_"
                      cx="417.8321"
                      cy="526.9492"
                      r="0.7611"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop offset="0.449" style={{ stopColor: "#D8DEDE" }} />
                      <stop offset="0.5012" style={{ stopColor: "#D0D6D6" }} />
                      <stop offset="0.5814" style={{ stopColor: "#BCC1C1" }} />
                      <stop offset="0.6794" style={{ stopColor: "#9A9E9E" }} />
                      <stop offset="0.7915" style={{ stopColor: "#6A6D6D" }} />
                      <stop offset="0.9139" style={{ stopColor: "#2E3030" }} />
                      <stop offset="1" style={{ stopColor: "#000000" }} />
                    </radialGradient>
                    <path
                      style={{
                        fill: "url(#SVGID_00000084500385205517713810000017810660066371354009_)",
                      }}
                      d="M418.6,526.9c0,0.4-0.3,0.8-0.8,0.8
        c-0.4,0-0.8-0.3-0.8-0.8s0.3-0.8,0.8-0.8C418.3,526.2,418.6,526.5,418.6,526.9z"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st121"
                      points="391.2,543 396.5,540 396.5,539.4 391.2,542.4 				"
                    />
                    <polygon
                      class="st85"
                      points="391.1,543 391.2,543 391.2,542.4 391.1,542.4 				"
                    />
                    <polygon
                      class="st122"
                      points="396.3,539.4 396.5,539.4 391.2,542.4 391.1,542.4 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st121"
                      points="398.6,538.8 403.9,535.8 403.9,535.2 398.6,538.2 				"
                    />
                    <polygon
                      class="st85"
                      points="398.5,538.7 398.6,538.8 398.6,538.2 398.5,538.2 				"
                    />
                    <polygon
                      class="st122"
                      points="403.7,535.1 403.9,535.2 398.6,538.2 398.5,538.2 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st121"
                      points="406.1,534.5 411.4,531.5 411.4,530.9 406.1,533.9 				"
                    />
                    <polygon
                      class="st85"
                      points="406,534.5 406.1,534.5 406.1,533.9 406,533.9 				"
                    />
                    <polygon
                      class="st122"
                      points="411.2,530.9 411.4,530.9 406.1,533.9 406,533.9 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st121"
                      points="413.5,530.4 418.7,527.3 418.7,526.8 413.5,529.8 				"
                    />
                    <polygon
                      class="st85"
                      points="413.4,530.3 413.5,530.4 413.5,529.8 413.4,529.7 				"
                    />
                    <polygon
                      class="st122"
                      points="418.6,526.7 418.7,526.8 413.5,529.8 413.4,529.7 				"
                    />
                  </g>
                  <g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000007396376543484393670000011371643327601104008_"
                          gradientUnits="userSpaceOnUse"
                          x1="351.8109"
                          y1="533.0259"
                          x2="351.0939"
                          y2="534.2932"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000007396376543484393670000011371643327601104008_)",
                          }}
                          d="M351.8,533c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C350.4,533,351.8,533,351.8,533z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000147940572322112716460000003070407573354444436_"
                              class="st30"
                              d="M351.6,533.1c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C351.1,533.7,351.3,533.3,351.6,533.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000147940572322112716460000003070407573354444436_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000031191792017082584150000009160629229136411058_">
                            <use
                              xlinkHref="#SVGID_00000147940572322112716460000003070407573354444436_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M351.6,533.3c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C351.3,533.7,351.4,533.4,351.6,533.3z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000177455918010879450020000009743403234718376351_"
                          gradientUnits="userSpaceOnUse"
                          x1="353.1492"
                          y1="532.2612"
                          x2="352.4322"
                          y2="533.5284"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000177455918010879450020000009743403234718376351_)",
                          }}
                          d="M353.1,532.2c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C351.8,532.2,353.1,532.2,353.1,532.2z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000049923919332792288720000015179983131442371483_"
                              class="st30"
                              d="M353,532.4c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3S352.7,532.5,353,532.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000049923919332792288720000015179983131442371483_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000096019344584077829900000009641121046666015875_">
                            <use
                              xlinkHref="#SVGID_00000049923919332792288720000015179983131442371483_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M353,532.5c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C352.6,532.9,352.8,532.6,353,532.5z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000176010389314056205590000003754644449242971319_"
                          gradientUnits="userSpaceOnUse"
                          x1="354.4874"
                          y1="531.4965"
                          x2="353.7704"
                          y2="532.7637"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000176010389314056205590000003754644449242971319_)",
                          }}
                          d="M354.4,531.4c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C353.1,531.5,354.4,531.4,354.4,531.4z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000083771633088027685410000001492169421626177450_"
                              class="st30"
                              d="M354.3,531.6c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C353.8,532.2,354,531.8,354.3,531.6z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000083771633088027685410000001492169421626177450_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000162332506609901064880000015065872884936133541_">
                            <use
                              xlinkHref="#SVGID_00000083771633088027685410000001492169421626177450_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M354.3,531.8c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C353.9,532.2,354.1,531.9,354.3,531.8z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000098918017766731063560000009878456840812915881_"
                          gradientUnits="userSpaceOnUse"
                          x1="355.8257"
                          y1="530.7318"
                          x2="355.1087"
                          y2="531.999"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000098918017766731063560000009878456840812915881_)",
                          }}
                          d="M355.8,530.7c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C354.4,530.7,355.8,530.7,355.8,530.7z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000145739962242425675070000013791821817840671149_"
                              class="st30"
                              d="M355.6,530.8c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C355.1,531.4,355.3,531,355.6,530.8z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000145739962242425675070000013791821817840671149_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000137124181856747135630000003685636199582982545_">
                            <use
                              xlinkHref="#SVGID_00000145739962242425675070000013791821817840671149_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M355.7,531c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C355.3,531.4,355.4,531.1,355.7,531z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000124148413971200649760000009215302381640644007_"
                          gradientUnits="userSpaceOnUse"
                          x1="357.164"
                          y1="529.967"
                          x2="356.447"
                          y2="531.2343"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000124148413971200649760000009215302381640644007_)",
                          }}
                          d="M357.1,529.9c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C355.8,529.9,357.1,529.9,357.1,529.9z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000179632606997265115100000002456188953721019321_"
                              class="st30"
                              d="M357,530.1c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C356.4,530.6,356.7,530.2,357,530.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000179632606997265115100000002456188953721019321_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000103257379663687441900000005003280949364679074_">
                            <use
                              xlinkHref="#SVGID_00000179632606997265115100000002456188953721019321_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M357,530.2c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C356.6,530.6,356.8,530.4,357,530.2z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000124854163833594846130000016388546554347305354_"
                          gradientUnits="userSpaceOnUse"
                          x1="362.3259"
                          y1="526.9081"
                          x2="361.6089"
                          y2="528.1754"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000124854163833594846130000016388546554347305354_)",
                          }}
                          d="M362.3,526.9c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C360.9,526.9,362.3,526.9,362.3,526.9z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000133520618893290230460000001003597066475269797_"
                              class="st30"
                              d="M362.1,527c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C361.6,527.6,361.8,527.2,362.1,527z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000133520618893290230460000001003597066475269797_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000161592473866766417960000006270858041215486101_">
                            <use
                              xlinkHref="#SVGID_00000133520618893290230460000001003597066475269797_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M362.2,527.2c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C361.8,527.6,361.9,527.3,362.2,527.2z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000176731300511132836570000011265968680569588355_"
                          gradientUnits="userSpaceOnUse"
                          x1="363.6642"
                          y1="526.1434"
                          x2="362.9472"
                          y2="527.4106"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000176731300511132836570000011265968680569588355_)",
                          }}
                          d="M363.6,526.1c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C362.3,526.1,363.6,526.1,363.6,526.1z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000069385121130808105070000003179564659323988899_"
                              class="st30"
                              d="M363.5,526.2c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C362.9,526.8,363.2,526.4,363.5,526.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000069385121130808105070000003179564659323988899_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000043446592614380945890000011171043553009572749_">
                            <use
                              xlinkHref="#SVGID_00000069385121130808105070000003179564659323988899_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M363.5,526.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C363.1,526.8,363.3,526.5,363.5,526.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000047041585015983268350000015754655403054724532_"
                          gradientUnits="userSpaceOnUse"
                          x1="365.0024"
                          y1="525.3787"
                          x2="364.2855"
                          y2="526.6459"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000047041585015983268350000015754655403054724532_)",
                          }}
                          d="M365,525.3c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C363.6,525.3,365,525.3,365,525.3z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000070089868961063856990000002301790963830902180_"
                              class="st30"
                              d="M364.8,525.5c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C364.3,526,364.5,525.6,364.8,525.5z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000070089868961063856990000002301790963830902180_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000165933287526849094250000017544070012485099948_">
                            <use
                              xlinkHref="#SVGID_00000070089868961063856990000002301790963830902180_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M364.8,525.6c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C364.5,526.1,364.6,525.8,364.8,525.6z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000047044948797881476510000006944675450097988489_"
                          gradientUnits="userSpaceOnUse"
                          x1="366.3407"
                          y1="524.614"
                          x2="365.6237"
                          y2="525.8812"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000047044948797881476510000006944675450097988489_)",
                          }}
                          d="M366.3,524.6c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C365,524.6,366.3,524.6,366.3,524.6z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000126295311052239635900000013632995883477910693_"
                              class="st30"
                              d="M366.1,524.7c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C365.6,525.3,365.9,524.9,366.1,524.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000126295311052239635900000013632995883477910693_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000114767630720589463910000007373646888608748174_">
                            <use
                              xlinkHref="#SVGID_00000126295311052239635900000013632995883477910693_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M366.2,524.9c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C365.8,525.3,366,525,366.2,524.9z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000059309147057517412020000002787879201268861090_"
                          gradientUnits="userSpaceOnUse"
                          x1="367.679"
                          y1="523.8492"
                          x2="366.962"
                          y2="525.1165"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000059309147057517412020000002787879201268861090_)",
                          }}
                          d="M367.6,523.8c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C366.3,523.8,367.6,523.8,367.6,523.8z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000070825549760006454020000006560100135390536332_"
                              class="st30"
                              d="M367.5,523.9c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C367,524.5,367.2,524.1,367.5,523.9z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000070825549760006454020000006560100135390536332_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000158709906154015571330000005988499662593834112_">
                            <use
                              xlinkHref="#SVGID_00000070825549760006454020000006560100135390536332_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M367.5,524.1c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C367.1,524.5,367.3,524.2,367.5,524.1z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000062158536792267052360000003342800277334178996_"
                          gradientUnits="userSpaceOnUse"
                          x1="383.5471"
                          y1="514.8636"
                          x2="382.8301"
                          y2="516.1309"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000062158536792267052360000003342800277334178996_)",
                          }}
                          d="M383.5,514.8c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C382.2,514.8,383.5,514.8,383.5,514.8z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000077308324715153037530000002811064631130697116_"
                              class="st30"
                              d="M383.4,515c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C382.8,515.5,383.1,515.1,383.4,515z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000077308324715153037530000002811064631130697116_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000026151684737440182890000005420922690786192513_">
                            <use
                              xlinkHref="#SVGID_00000077308324715153037530000002811064631130697116_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M383.4,515.1c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C383,515.5,383.2,515.3,383.4,515.1z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000031167094915193057130000017055917046680968364_"
                          gradientUnits="userSpaceOnUse"
                          x1="384.8854"
                          y1="514.0989"
                          x2="384.1684"
                          y2="515.3661"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000031167094915193057130000017055917046680968364_)",
                          }}
                          d="M384.8,514c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C383.5,514.1,384.8,514,384.8,514z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000099641826686167574450000002858787840469014957_"
                              class="st30"
                              d="M384.7,514.2c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3S384.4,514.4,384.7,514.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000099641826686167574450000002858787840469014957_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000141452799676248516870000018391786861465794438_">
                            <use
                              xlinkHref="#SVGID_00000099641826686167574450000002858787840469014957_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M384.7,514.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C384.3,514.8,384.5,514.5,384.7,514.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000013904921495634043080000003147124903168839298_"
                          gradientUnits="userSpaceOnUse"
                          x1="386.2236"
                          y1="513.3342"
                          x2="385.5067"
                          y2="514.6014"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000013904921495634043080000003147124903168839298_)",
                          }}
                          d="M386.2,513.3c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C384.8,513.3,386.2,513.3,386.2,513.3z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000112595559299733556520000006585107105422676912_"
                              class="st30"
                              d="M386,513.4c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C385.5,514,385.7,513.6,386,513.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000112595559299733556520000006585107105422676912_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000142859442205761192210000011985933783549272452_">
                            <use
                              xlinkHref="#SVGID_00000112595559299733556520000006585107105422676912_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M386.1,513.6c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C385.7,514,385.8,513.7,386.1,513.6z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000031928147266041244120000011028451017534740408_"
                          gradientUnits="userSpaceOnUse"
                          x1="387.5619"
                          y1="512.5695"
                          x2="386.8449"
                          y2="513.8367"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000031928147266041244120000011028451017534740408_)",
                          }}
                          d="M387.5,512.5c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C386.2,512.5,387.5,512.5,387.5,512.5z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000000211433381355617880000018253021131750418622_"
                              class="st30"
                              d="M387.4,512.7c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C386.8,513.2,387.1,512.8,387.4,512.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000000211433381355617880000018253021131750418622_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000174582686524438921170000014731378619943868856_">
                            <use
                              xlinkHref="#SVGID_00000000211433381355617880000018253021131750418622_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M387.4,512.8c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C387,513.2,387.2,513,387.4,512.8z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000000931255189316003880000016963825469401661887_"
                          gradientUnits="userSpaceOnUse"
                          x1="388.9002"
                          y1="511.8047"
                          x2="388.1832"
                          y2="513.072"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000000931255189316003880000016963825469401661887_)",
                          }}
                          d="M388.9,511.8c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C387.5,511.8,388.9,511.8,388.9,511.8z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000018919048461705251850000007482631204929527192_"
                              class="st30"
                              d="M388.7,511.9c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C388.2,512.5,388.4,512.1,388.7,511.9z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000018919048461705251850000007482631204929527192_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000144329611011572979980000011217907974150919843_">
                            <use
                              xlinkHref="#SVGID_00000018919048461705251850000007482631204929527192_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M388.7,512.1c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C388.4,512.5,388.5,512.2,388.7,512.1z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000092434665046179435060000005657798244539956156_"
                          gradientUnits="userSpaceOnUse"
                          x1="392.6114"
                          y1="509.1327"
                          x2="391.8944"
                          y2="510.3999"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000092434665046179435060000005657798244539956156_)",
                          }}
                          d="M392.6,509.1c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C391.2,509.1,392.6,509.1,392.6,509.1z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000097479767122864124990000007956215101845195953_"
                              class="st30"
                              d="M392.4,509.2c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C391.9,509.8,392.1,509.4,392.4,509.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000097479767122864124990000007956215101845195953_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000134946226836089943400000012490825501842770828_">
                            <use
                              xlinkHref="#SVGID_00000097479767122864124990000007956215101845195953_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M392.4,509.4c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C392.1,509.8,392.2,509.5,392.4,509.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000083066415030532462390000015000278960846514863_"
                          gradientUnits="userSpaceOnUse"
                          x1="393.9496"
                          y1="508.368"
                          x2="393.2326"
                          y2="509.6352"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000083066415030532462390000015000278960846514863_)",
                          }}
                          d="M393.9,508.3c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C392.6,508.3,393.9,508.3,393.9,508.3z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000054239166786348316080000013940238478837452952_"
                              class="st30"
                              d="M393.8,508.5c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C393.2,509,393.5,508.6,393.8,508.5z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000054239166786348316080000013940238478837452952_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000155861299540291597120000017113257869704586679_">
                            <use
                              xlinkHref="#SVGID_00000054239166786348316080000013940238478837452952_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M393.8,508.6c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C393.4,509,393.6,508.8,393.8,508.6z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000043433801819719343670000012161081940963791507_"
                          gradientUnits="userSpaceOnUse"
                          x1="395.2879"
                          y1="507.6032"
                          x2="394.5709"
                          y2="508.8705"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000043433801819719343670000012161081940963791507_)",
                          }}
                          d="M395.2,507.5c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C393.9,507.6,395.2,507.5,395.2,507.5z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000065052289975407064430000017636146057581533577_"
                              class="st30"
                              d="M395.1,507.7c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C394.6,508.3,394.8,507.9,395.1,507.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000065052289975407064430000017636146057581533577_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000072976069156034672160000015836277431534018200_">
                            <use
                              xlinkHref="#SVGID_00000065052289975407064430000017636146057581533577_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M395.1,507.9c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C394.7,508.3,394.9,508,395.1,507.9z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000036236952996443798940000009301817750564339365_"
                          gradientUnits="userSpaceOnUse"
                          x1="396.6262"
                          y1="506.8385"
                          x2="395.9092"
                          y2="508.1057"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000036236952996443798940000009301817750564339365_)",
                          }}
                          d="M396.6,506.8c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C395.2,506.8,396.6,506.8,396.6,506.8z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000044140810930728337750000006623523487265788046_"
                              class="st30"
                              d="M396.4,506.9c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C395.9,507.5,396.1,507.1,396.4,506.9z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000044140810930728337750000006623523487265788046_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000174563258817635975060000006021770281673451663_">
                            <use
                              xlinkHref="#SVGID_00000044140810930728337750000006623523487265788046_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M396.5,507.1c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C396.1,507.5,396.2,507.2,396.5,507.1z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000053530897980065897570000001007053882207285894_"
                          gradientUnits="userSpaceOnUse"
                          x1="397.9644"
                          y1="506.0738"
                          x2="397.2475"
                          y2="507.341"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000053530897980065897570000001007053882207285894_)",
                          }}
                          d="M397.9,506c0.3,0,0.5,0.3,0.3,0.6
            c-0.1,0.3-0.2,0.4-0.5,0.7c-0.2,0.2-0.4,0.2-0.6,0C396.6,506,397.9,506,397.9,506z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000082330320399359518800000008048795966953577131_"
                              class="st30"
                              d="M397.8,506.2c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C397.2,506.7,397.5,506.3,397.8,506.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000082330320399359518800000008048795966953577131_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000088092498238454706880000012648643532239414708_">
                            <use
                              xlinkHref="#SVGID_00000082330320399359518800000008048795966953577131_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M397.8,506.3c0.2-0.1,0.4,0,0.4,0.2c0,0.2-0.2,0.5-0.4,0.7c-0.2,0.1-0.4,0-0.4-0.2
            C397.4,506.8,397.6,506.5,397.8,506.3z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000003818762497681981240000009418798069449367971_"
                          gradientUnits="userSpaceOnUse"
                          x1="9802.3574"
                          y1="509.6709"
                          x2="9801.6396"
                          y2="510.9381"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000003818762497681981240000009418798069449367971_)",
                          }}
                          d="M418.4,510.9c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C417.7,509.6,419,509.6,418.4,510.9z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000108992894472744635400000017212616012661058701_"
                              class="st30"
                              d="M418.4,510.7c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C418.1,509.9,418.4,510.3,418.4,510.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000108992894472744635400000017212616012661058701_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000082351341258749112930000004674153941401401493_">
                            <use
                              xlinkHref="#SVGID_00000108992894472744635400000017212616012661058701_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M417.8,509.9c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C418.2,510.4,418,510.1,417.8,509.9z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000173856331195233436870000011944159196736013214_"
                          gradientUnits="userSpaceOnUse"
                          x1="9803.6953"
                          y1="508.9062"
                          x2="9802.9785"
                          y2="510.1734"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000173856331195233436870000011944159196736013214_)",
                          }}
                          d="M417.1,510.1c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C416.4,508.9,417.7,508.9,417.1,510.1z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000091717771547508183940000010090197404435473064_"
                              class="st30"
                              d="M417,509.9c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C416.8,509.2,417,509.6,417,509.9z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000091717771547508183940000010090197404435473064_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000029738804453214172290000012282414827847425974_">
                            <use
                              xlinkHref="#SVGID_00000091717771547508183940000010090197404435473064_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M416.5,509.2c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C416.9,509.6,416.7,509.3,416.5,509.2z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000078012065207308403690000007587272727562259629_"
                          gradientUnits="userSpaceOnUse"
                          x1="9805.0332"
                          y1="508.1415"
                          x2="9804.3164"
                          y2="509.4087"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000078012065207308403690000007587272727562259629_)",
                          }}
                          d="M415.7,509.4c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C415,508.1,416.4,508.1,415.7,509.4z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000097499465046545297920000007259669641729303995_"
                              class="st30"
                              d="M415.7,509.1c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C415.5,508.4,415.7,508.8,415.7,509.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000097499465046545297920000007259669641729303995_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000039825250359641530380000005195941683421547394_">
                            <use
                              xlinkHref="#SVGID_00000097499465046545297920000007259669641729303995_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M415.2,508.4c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C415.5,508.8,415.4,508.5,415.2,508.4z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000132806285039680956430000013638062278985238175_"
                          gradientUnits="userSpaceOnUse"
                          x1="9806.3721"
                          y1="507.3767"
                          x2="9805.6553"
                          y2="508.644"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000132806285039680956430000013638062278985238175_)",
                          }}
                          d="M414.4,508.6c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C413.7,507.3,415,507.3,414.4,508.6z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000072239327074053801010000001801535222765951642_"
                              class="st30"
                              d="M414.4,508.4c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C414.1,507.6,414.4,508,414.4,508.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000072239327074053801010000001801535222765951642_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000010286330257092474070000016133125952531837102_">
                            <use
                              xlinkHref="#SVGID_00000072239327074053801010000001801535222765951642_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M413.8,507.6c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C414.2,508.1,414,507.8,413.8,507.6z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000031166095654755485220000003538452673245770422_"
                          gradientUnits="userSpaceOnUse"
                          x1="9807.71"
                          y1="506.612"
                          x2="9806.9932"
                          y2="507.8792"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000031166095654755485220000003538452673245770422_)",
                          }}
                          d="M413,507.8c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C412.3,506.6,413.7,506.6,413,507.8z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000152974984360503062700000012334537133523968898_"
                              class="st30"
                              d="M413,507.6c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C412.8,506.9,413,507.3,413,507.6z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000152974984360503062700000012334537133523968898_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000099661842544269436500000001254311291401523602_">
                            <use
                              xlinkHref="#SVGID_00000152974984360503062700000012334537133523968898_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M412.5,506.9c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C412.9,507.3,412.7,507,412.5,506.9z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000160878593081281503400000016157641898230764202_"
                          gradientUnits="userSpaceOnUse"
                          x1="9789.3564"
                          y1="517.2226"
                          x2="9788.6396"
                          y2="518.4898"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000160878593081281503400000016157641898230764202_)",
                          }}
                          d="M431.4,518.5c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C430.7,517.2,432,517.2,431.4,518.5z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000031900241293585971370000003931756759177244320_"
                              class="st30"
                              d="M431.4,518.2c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C431.1,517.5,431.4,517.9,431.4,518.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000031900241293585971370000003931756759177244320_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000177466304045591101070000001773030098278230419_">
                            <use
                              xlinkHref="#SVGID_00000031900241293585971370000003931756759177244320_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M430.8,517.5c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C431.2,517.9,431,517.6,430.8,517.5z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000003103791124764011410000001334785708201094803_"
                          gradientUnits="userSpaceOnUse"
                          x1="9790.6953"
                          y1="516.4579"
                          x2="9789.9775"
                          y2="517.7251"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000003103791124764011410000001334785708201094803_)",
                          }}
                          d="M430.1,517.7c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C429.4,516.4,430.7,516.4,430.1,517.7z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000130649341223421165440000002161762737820245182_"
                              class="st30"
                              d="M430,517.4c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C429.8,516.7,430,517.1,430,517.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000130649341223421165440000002161762737820245182_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000064324006544003467950000000771819295299714238_">
                            <use
                              xlinkHref="#SVGID_00000130649341223421165440000002161762737820245182_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M429.5,516.7c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C429.9,517.1,429.7,516.8,429.5,516.7z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000040559380973105202570000004052968989144926088_"
                          gradientUnits="userSpaceOnUse"
                          x1="9792.0332"
                          y1="515.6932"
                          x2="9791.3164"
                          y2="516.9604"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000040559380973105202570000004052968989144926088_)",
                          }}
                          d="M428.7,516.9c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C428,515.6,429.4,515.7,428.7,516.9z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000062178226268015708490000003724142529264075911_"
                              class="st30"
                              d="M428.7,516.7c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C428.5,515.9,428.7,516.4,428.7,516.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000062178226268015708490000003724142529264075911_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000080927700207138229480000005054496314218298283_">
                            <use
                              xlinkHref="#SVGID_00000062178226268015708490000003724142529264075911_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M428.2,516c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C428.5,516.4,428.4,516.1,428.2,516z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000044882177703712824560000005086293887630476700_"
                          gradientUnits="userSpaceOnUse"
                          x1="9793.3711"
                          y1="514.9284"
                          x2="9792.6543"
                          y2="516.1956"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000044882177703712824560000005086293887630476700_)",
                          }}
                          d="M427.4,516.2c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C426.7,514.9,428,514.9,427.4,516.2z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000133510503834085808470000015214449698285187517_"
                              class="st30"
                              d="M427.4,515.9c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C427.1,515.2,427.4,515.6,427.4,515.9z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000133510503834085808470000015214449698285187517_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000082343481570050340620000005757026403847277230_">
                            <use
                              xlinkHref="#SVGID_00000133510503834085808470000015214449698285187517_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M426.8,515.2c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C427.2,515.6,427,515.3,426.8,515.2z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <linearGradient
                          id="SVGID_00000074418517688057397460000001702707115195531151_"
                          gradientUnits="userSpaceOnUse"
                          x1="9794.71"
                          y1="514.1637"
                          x2="9793.9932"
                          y2="515.4309"
                          gradientTransform="matrix(-1 0 0 1 10220.0166 0)"
                        >
                          <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                          <stop
                            offset="0.1482"
                            style={{ stopColor: "#D4DADA" }}
                          />
                          <stop
                            offset="0.2917"
                            style={{ stopColor: "#C8CFCF" }}
                          />
                          <stop
                            offset="0.433"
                            style={{ stopColor: "#B5BCBC" }}
                          />
                          <stop
                            offset="0.5255"
                            style={{ stopColor: "#A4ABAB" }}
                          />
                          <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                        </linearGradient>
                        <path
                          style={{
                            fill: "url(#SVGID_00000074418517688057397460000001702707115195531151_)",
                          }}
                          d="M426,515.4c-0.1,0.2-0.3,0.2-0.6,0
            c-0.3-0.2-0.4-0.4-0.5-0.7c-0.1-0.3,0.1-0.6,0.3-0.6C425.3,514.1,426.7,514.1,426,515.4z"
                        />
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000036944334707420969160000014497494957676783516_"
                              class="st30"
                              d="M426,515.2c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C425.8,514.4,426,514.8,426,515.2z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000036944334707420969160000014497494957676783516_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000075849458330773529200000013858234367886077872_">
                            <use
                              xlinkHref="#SVGID_00000036944334707420969160000014497494957676783516_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>
                      <g>
                        <path
                          class="st14"
                          d="M425.5,514.4c-0.2-0.1-0.4,0-0.4,0.2c0,0.2,0.2,0.5,0.4,0.7c0.2,0.1,0.4,0,0.4-0.2
            C425.9,514.8,425.7,514.6,425.5,514.4z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <polygon
                        class="st153"
                        points="370,518.1 370,524.4 381.1,518.1 381.1,511.7 					"
                      />
                      <polygon
                        class="st154"
                        points="370,524.4 369.5,524 369.5,517.8 370,518.1 					"
                      />
                      <polygon
                        class="st155"
                        points="381.1,511.7 370,518.1 369.5,517.8 380.7,511.5 					"
                      />
                    </g>
                    <g>
                      <g>
                        <path
                          class="st156"
                          d="M374.2,516.8C374.2,516.8,374.2,516.8,374.2,516.8C374.2,516.7,374.2,516.7,374.2,516.8
            c-0.1-0.1-0.1-0.1-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0s0,0,0,0
            c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0s0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1
            c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1l0.1-0.1
            c0,0,0,0,0,0s0,0,0,0c0,0,0,0,0.1,0s0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0s0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0
            c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0s0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1
            c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0
            c0,0,0,0,0,0.1L374.2,516.8z"
                        />
                        <path
                          class="st156"
                          d="M374.8,516.3c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1l-0.1,0.1
            c0,0,0,0,0-0.1c0,0,0,0,0,0C374.9,516.3,374.9,516.3,374.8,516.3c0.1,0.1,0,0.1,0,0.1c0,0-0.1,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1
            c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1
            c0,0,0,0,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0-0.1l0.1-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1
            c0,0-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2
            c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.1,0.1-0.1C374.7,516.3,374.7,516.3,374.8,516.3z"
                        />
                        <path
                          class="st156"
                          d="M375.5,516.6c-0.1,0-0.1,0-0.1,0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.1
            c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0.1-0.2s0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.1-0.1s0.1,0,0.1,0
            c0,0,0.1,0,0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2c0,0.1-0.1,0.1-0.1,0.1
            C375.6,516.5,375.6,516.5,375.5,516.6z M375.5,516.4C375.6,516.4,375.6,516.4,375.5,516.4c0.1-0.1,0.1-0.1,0.2-0.2
            c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1
            c0,0,0,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1C375.4,516.5,375.4,516.5,375.5,516.4
            C375.5,516.5,375.5,516.4,375.5,516.4z"
                        />
                        <path
                          class="st156"
                          d="M376.5,516C376.5,516,376.5,516,376.5,516C376.5,516,376.4,515.9,376.5,516c0-0.1,0-0.1,0-0.1
            c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0l-0.2,0.1v0.3l-0.1,0.1v-0.7l0.4-0.2c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0
            c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1
            c0,0,0,0,0,0L376.5,516z M376.1,515.6v0.2l0.2-0.1c0,0,0.1,0,0.1-0.1s0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
            c0,0,0,0,0,0L376.1,515.6z"
                        />
                        <path
                          class="st156"
                          d="M376.7,515.9v-0.7l0.5-0.3v0.1l-0.4,0.2v0.2l0.3-0.2v0.1l-0.3,0.2v0.2l0.4-0.2v0.1L376.7,515.9z"
                        />
                      </g>
                      <g>
                        <path
                          class="st156"
                          d="M372.9,522.2V522l-0.2,0.1v0.2l-0.1,0V522l0.1,0v0.2l0.2-0.1v-0.2l0.1,0L372.9,522.2L372.9,522.2z"
                        />
                        <path
                          class="st156"
                          d="M373.2,522C373.2,522,373.2,522.1,373.2,522c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0c0,0,0,0,0-0.1
            c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0,0s0,0,0,0.1
            c0,0,0,0.1,0,0.1s0,0.1,0,0.1C373.4,521.9,373.4,521.9,373.2,522C373.3,522,373.3,522,373.2,522z M373.2,522
            C373.3,521.9,373.3,521.9,373.2,522C373.3,521.9,373.3,521.9,373.2,522c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0,0,0-0.1c0,0,0,0,0-0.1
            s0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1
            C373.1,521.9,373.1,522,373.2,522C373.2,522,373.2,522,373.2,522C373.2,522,373.2,522,373.2,522z"
                        />
                        <path
                          class="st156"
                          d="M373.9,521.7v-0.3l-0.1,0.4l0,0l-0.1-0.3v0.3l-0.1,0v-0.4l0.1-0.1l0.1,0.2l0.1-0.3l0.1-0.1L373.9,521.7
            L373.9,521.7z"
                        />
                        <path
                          class="st156"
                          d="M374,521.6v-0.4l0.3-0.2v0.1l-0.2,0.1v0.1l0.2-0.1v0.1l-0.2,0.1v0.1l0.2-0.1v0.1L374,521.6z"
                        />
                      </g>
                      <g>
                        <path
                          class="st156"
                          d="M377.3,519.6l-0.2,0.1l0,0.1l-0.1,0.1l0.2-0.5l0,0l0.2,0.3L377.3,519.6L377.3,519.6z M377.1,519.7
            l0.1-0.1l-0.1-0.1L377.1,519.7z"
                        />
                        <path
                          class="st156"
                          d="M377.7,519.4l-0.1-0.3l-0.1,0.4l-0.1,0.1l-0.1-0.3l0.1,0l0.1,0.3l0.1-0.4l0.1,0l0.1,0.3l0.1-0.4l0.1,0
            L377.7,519.4L377.7,519.4z"
                        />
                        <path
                          class="st156"
                          d="M378.2,519.1l-0.2,0.1l0,0.1l-0.1,0.1l0.2-0.5l0,0l0.2,0.3L378.2,519.1L378.2,519.1z M378,519.1
            l0.1-0.1l-0.1-0.1L378,519.1z"
                        />
                        <path
                          class="st156"
                          d="M378.4,519.1v-0.2l-0.2-0.1l0.1-0.1l0.1,0.1l0.1-0.2l0.1,0l-0.2,0.3L378.4,519.1L378.4,519.1z"
                        />
                      </g>
                      <g>
                        <path
                          class="st156"
                          d="M373.5,520.7c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.3
            c0-0.1-0.1-0.3-0.1-0.5c0-0.2,0-0.4,0.1-0.5c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.2
            c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0,0.3-0.1,0.5
            c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.2,0.3-0.2,0.4C373.7,520.6,373.6,520.6,373.5,520.7z M373.5,520.4c0.1,0,0.1-0.1,0.2-0.1
            c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.4c0-0.1,0-0.3,0-0.3c0-0.1,0-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1
            s-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.4c0,0.3,0,0.4,0.1,0.5
            C373.3,520.4,373.4,520.4,373.5,520.4z"
                        />
                        <path
                          class="st156"
                          d="M375.3,518.9v-0.2l0.8-0.5v0.2L375.3,518.9z"
                        />
                        <path
                          class="st156"
                          d="M377.8,518.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.3
            c0-0.1-0.1-0.3-0.1-0.5s0-0.4,0.1-0.5c0-0.2,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.3-0.2
            c0.1-0.1,0.2-0.1,0.3-0.1s0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.3c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0,0.3-0.1,0.5s-0.1,0.3-0.2,0.5
            c-0.1,0.1-0.2,0.3-0.2,0.4C378.1,518.1,378,518.1,377.8,518.2z M377.9,517.9c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2
            c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.4c0-0.1,0-0.3,0-0.3s0-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1s-0.1,0-0.2,0
            c-0.1,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.4c0,0.3,0,0.4,0.1,0.5
            C377.6,517.9,377.7,517.9,377.9,517.9z"
                        />
                      </g>
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000002354812098055556560000016218657559756479134_"
                              class="st30"
                              d="M352,542.7c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C351.7,541.9,352,542.3,352,542.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000002354812098055556560000016218657559756479134_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000032607358779854790490000008832690802519549868_">
                            <use
                              xlinkHref="#SVGID_00000002354812098055556560000016218657559756479134_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000056414005348003088190000006651337205280437393_"
                        cx="351.3498"
                        cy="542.3635"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000056414005348003088190000006651337205280437393_)",
                        }}
                        d="M351.7,542.2c0.2,0.4,0.2,0.7,0,0.9
          c-0.2,0.1-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S351.5,541.8,351.7,542.2z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000152247346836146919810000013324150034415713709_"
                              class="st30"
                              d="M353.1,543.4c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C352.9,542.6,353.1,543,353.1,543.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000152247346836146919810000013324150034415713709_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000020382912104535766890000012008508488510555049_">
                            <use
                              xlinkHref="#SVGID_00000152247346836146919810000013324150034415713709_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000101797931598343977660000000023608787346899619_"
                        cx="352.5327"
                        cy="543.0446"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000101797931598343977660000000023608787346899619_)",
                        }}
                        d="M352.9,542.9c0.2,0.4,0.2,0.7,0,0.9
          s-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S352.7,542.5,352.9,542.9z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000154396891860631031590000002955526058080151741_"
                              class="st30"
                              d="M354.3,544c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C354.1,543.3,354.3,543.7,354.3,544z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000154396891860631031590000002955526058080151741_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000103233860701298490460000012893733134929262985_">
                            <use
                              xlinkHref="#SVGID_00000154396891860631031590000002955526058080151741_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000049206669618144137330000005326109884810847626_"
                        cx="353.7157"
                        cy="543.7256"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000049206669618144137330000005326109884810847626_)",
                        }}
                        d="M354.1,543.6c0.2,0.4,0.2,0.7,0,0.9
          c-0.2,0.1-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S353.9,543.2,354.1,543.6z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000056391915591464625290000011013355719899350447_"
                              class="st30"
                              d="M355.5,544.7c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C355.3,544,355.5,544.4,355.5,544.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000056391915591464625290000011013355719899350447_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000157280173875327571690000008516384867089728916_">
                            <use
                              xlinkHref="#SVGID_00000056391915591464625290000011013355719899350447_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000144335073029751092510000014653191764355382436_"
                        cx="354.8986"
                        cy="544.4067"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000144335073029751092510000014653191764355382436_)",
                        }}
                        d="M355.3,544.2c0.2,0.4,0.2,0.7,0,0.9
          s-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S355.1,543.9,355.3,544.2z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000068640561474317523700000007080074002685308332_"
                              class="st30"
                              d="M356.7,545.4c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C356.5,544.7,356.7,545.1,356.7,545.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000068640561474317523700000007080074002685308332_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000172433712153935405890000001147384382099348149_">
                            <use
                              xlinkHref="#SVGID_00000068640561474317523700000007080074002685308332_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000159437133550769351980000010826243406410871729_"
                        cx="356.0815"
                        cy="545.0878"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000159437133550769351980000010826243406410871729_)",
                        }}
                        d="M356.5,544.9c0.2,0.4,0.2,0.7,0,0.9
          c-0.2,0.1-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S356.3,544.6,356.5,544.9z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000036935950889028629730000011262878925153001405_"
                              class="st30"
                              d="M366.5,551.1c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C366.3,550.4,366.5,550.8,366.5,551.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000036935950889028629730000011262878925153001405_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000098928726488499946220000012074811602460468412_">
                            <use
                              xlinkHref="#SVGID_00000036935950889028629730000011262878925153001405_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000044173356056093075180000016636183914393661336_"
                        cx="365.8796"
                        cy="550.7755"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000044173356056093075180000016636183914393661336_)",
                        }}
                        d="M366.3,550.6c0.2,0.4,0.2,0.7,0,0.9
          s-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S366.1,550.3,366.3,550.6z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000116957578637945072660000017130758682936117648_"
                              class="st30"
                              d="M367.7,551.8c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9c0-0.3,0.2-0.5,0.5-0.3C367.4,551,367.7,551.4,367.7,551.8z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000116957578637945072660000017130758682936117648_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000093149505555320738110000002619612052301922732_">
                            <use
                              xlinkHref="#SVGID_00000116957578637945072660000017130758682936117648_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000087397656515311373460000009726899666991402161_"
                        cx="367.0626"
                        cy="551.4566"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000087397656515311373460000009726899666991402161_)",
                        }}
                        d="M367.4,551.3c0.2,0.4,0.2,0.7,0,0.9
          s-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1C366.9,550.8,367.2,550.9,367.4,551.3z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000142855344452516889400000000679672206156056196_"
                              class="st30"
                              d="M368.9,552.5c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C368.6,551.7,368.9,552.1,368.9,552.5z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000142855344452516889400000000679672206156056196_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000148633052348121215430000014604858428238856599_">
                            <use
                              xlinkHref="#SVGID_00000142855344452516889400000000679672206156056196_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000080916126603995489570000016605758265470505893_"
                        cx="368.2455"
                        cy="552.1377"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000080916126603995489570000016605758265470505893_)",
                        }}
                        d="M368.6,552c0.2,0.4,0.2,0.7,0,0.9
          c-0.2,0.1-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S368.4,551.6,368.6,552z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000161626575864905990550000014697746156019337367_"
                              class="st30"
                              d="M370,553.1c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C369.8,552.4,370,552.8,370,553.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000161626575864905990550000014697746156019337367_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000023978030553664666830000018246707501881842569_">
                            <use
                              xlinkHref="#SVGID_00000161626575864905990550000014697746156019337367_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000057830467759128487790000004621076744139740312_"
                        cx="369.4284"
                        cy="552.8188"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000057830467759128487790000004621076744139740312_)",
                        }}
                        d="M369.8,552.7c0.2,0.4,0.2,0.7,0,0.9
          c-0.2,0.1-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1C369.3,552.1,369.6,552.3,369.8,552.7z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000123426035335797879710000003793481465382259845_"
                              class="st30"
                              d="M371.2,553.8c0,0.3-0.2,0.5-0.5,0.3
                c-0.3-0.2-0.5-0.6-0.5-0.9s0.2-0.5,0.5-0.3C371,553.1,371.2,553.5,371.2,553.8z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000123426035335797879710000003793481465382259845_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000131357489233290890260000006284239903154917306_">
                            <use
                              xlinkHref="#SVGID_00000123426035335797879710000003793481465382259845_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000050658076290322406810000016919992083055574183_"
                        cx="370.6114"
                        cy="553.4999"
                        r="1.1442"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000050658076290322406810000016919992083055574183_)",
                        }}
                        d="M371,553.3c0.2,0.4,0.2,0.7,0,0.9
          s-0.8,0.1-1-0.3c-0.2-0.4,0-0.9,0.3-1S370.8,553,371,553.3z"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000121245129751721906090000017598231954228712582_"
                              class="st30"
                              d="M388.5,549.3c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3S388.2,549.5,388.5,549.3z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000121245129751721906090000017598231954228712582_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000029031409444560202830000005717646140750144949_">
                            <use
                              xlinkHref="#SVGID_00000121245129751721906090000017598231954228712582_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000042695572891545327400000013622934476139250342_"
                        cx="9261.4922"
                        cy="549.9275"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000042695572891545327400000013622934476139250342_)",
                        }}
                        d="M388.2,549.8c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1S388.4,549.4,388.2,549.8z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000010301239860531935860000000589164152819822739_"
                              class="st30"
                              d="M387.3,550c0.3-0.2,0.5,0,0.5,0.3
                s-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C386.8,550.6,387,550.2,387.3,550z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000010301239860531935860000000589164152819822739_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000121277089351366897630000000441607909275826050_">
                            <use
                              xlinkHref="#SVGID_00000010301239860531935860000000589164152819822739_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000089535308952862121080000000817680218158847898_"
                        cx="9262.6748"
                        cy="550.6086"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000089535308952862121080000000817680218158847898_)",
                        }}
                        d="M387,550.4c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1C387.6,549.9,387.2,550.1,387,550.4z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000106858901911305239760000001867051687932006076_"
                              class="st30"
                              d="M386.1,550.7c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C385.6,551.3,385.9,550.9,386.1,550.7z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000106858901911305239760000001867051687932006076_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000096048727349123057120000010865646875247808649_">
                            <use
                              xlinkHref="#SVGID_00000106858901911305239760000001867051687932006076_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000002361748554404094400000002589711710021350069_"
                        cx="9263.8584"
                        cy="551.2897"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000002361748554404094400000002589711710021350069_)",
                        }}
                        d="M385.8,551.1c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1S386.1,550.8,385.8,551.1z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000022559305813063640570000002704401771747585169_"
                              class="st30"
                              d="M385,551.4c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C384.4,552,384.7,551.5,385,551.4z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000022559305813063640570000002704401771747585169_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000013882578597627137180000004949679060210268345_">
                            <use
                              xlinkHref="#SVGID_00000022559305813063640570000002704401771747585169_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000014636628487724492750000001112940429933949098_"
                        cx="9265.041"
                        cy="551.9708"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000014636628487724492750000001112940429933949098_)",
                        }}
                        d="M384.7,551.8c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3s0-0.9-0.3-1C385.2,551.3,384.9,551.5,384.7,551.8z"
                      />
                    </g>
                    <g>
                      <g>
                        <g class="st30">
                          <defs>
                            <path
                              id="SVGID_00000106123771447067322790000002513303559813561512_"
                              class="st30"
                              d="M383.8,552.1c0.3-0.2,0.5,0,0.5,0.3
                c0,0.3-0.2,0.7-0.5,0.9c-0.3,0.2-0.5,0-0.5-0.3C383.3,552.6,383.5,552.2,383.8,552.1z"
                            />
                          </defs>
                          <use
                            xlinkHref="#SVGID_00000106123771447067322790000002513303559813561512_"
                            style={{ overflow: "visible", fill: "#F5F5F5" }}
                          />
                          <clipPath id="SVGID_00000001655756969584131240000016815257169550129577_">
                            <use
                              xlinkHref="#SVGID_00000106123771447067322790000002513303559813561512_"
                              style={{ overflow: "visible" }}
                            />
                          </clipPath>
                        </g>
                      </g>

                      <radialGradient
                        id="SVGID_00000108308206117226978340000001973222827239647380_"
                        cx="9266.2236"
                        cy="552.6519"
                        r="1.1442"
                        gradientTransform="matrix(-1 0 0 1 9650.0859 0)"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                        <stop
                          offset="0.1482"
                          style={{ stopColor: "#D4DADA" }}
                        />
                        <stop
                          offset="0.2917"
                          style={{ stopColor: "#C8CFCF" }}
                        />
                        <stop offset="0.433" style={{ stopColor: "#B5BCBC" }} />
                        <stop
                          offset="0.5255"
                          style={{ stopColor: "#A4ABAB" }}
                        />
                        <stop offset="1" style={{ stopColor: "#E3E6E6" }} />
                      </radialGradient>
                      <path
                        style={{
                          fill: "url(#SVGID_00000108308206117226978340000001973222827239647380_)",
                        }}
                        d="M383.5,552.5c-0.2,0.4-0.2,0.7,0,0.9
          s0.8,0.1,1-0.3c0.2-0.4,0-0.9-0.3-1S383.7,552.1,383.5,552.5z"
                      />
                    </g>
                  </g>
                  <g>
                    <polygon
                      class="st26"
                      points="340.4,557.7 344.4,560 344.4,557.2 340.3,554.8 				"
                    />
                    <polygon
                      class="st45"
                      points="340.3,554.8 340.3,557.7 340.8,557.5 340.8,555.1 				"
                    />
                    <polygon
                      class="st46"
                      points="344.4,560 340.3,557.7 340.8,557.5 344.4,559.5 				"
                    />
                    <polygon
                      class="st47"
                      points="340.8,555.1 340.8,556.5 344.4,558.5 344.4,557.2 				"
                    />
                  </g>
                  <polygon
                    class="st26"
                    points="364.3,572 364.3,573.6 362.2,574.8 362.2,574 			"
                  />
                  <path
                    class="st172"
                    d="M364.3,572c0,0-1.3-0.5-2-1l-23.4-13.5c0,0-1-0.7-1.1-0.9l-2,2.1l26.6,15.4L364.3,572z"
                  />
                  <g>
                    <polygon
                      class="st173"
                      points="340.8,560.7 340,560.2 340.6,559.4 341.4,559.9 				"
                    />
                    <polygon
                      class="st174"
                      points="340.7,560.6 339.9,560.2 340.6,559.4 341.4,559.9 				"
                    />
                  </g>
                  <polygon
                    class="st175"
                    points="335.6,559.4 362.2,574.8 362.2,574 335.6,558.7 			"
                  />
                  <polygon
                    class="st176"
                    points="335.6,561.9 362.2,577.2 362.7,576.9 336.1,561.6 			"
                  />
                  <polygon
                    class="st23"
                    points="364.3,573.6 362.2,574.8 362.2,578.2 364.3,577 			"
                  />
                  <polygon
                    class="st47"
                    points="364.3,573.6 362.2,574.8 362.2,576.2 364.3,575 			"
                  />
                  <polygon
                    class="st47"
                    points="362.2,576.2 335.6,561 335.6,559.4 362.2,574.8 			"
                  />
                  <polygon
                    class="st175"
                    points="362.2,578.2 335.6,563 335.6,561.9 362.2,577.2 			"
                  />
                  <g>
                    <polygon
                      class="st173"
                      points="346.5,563.9 345.7,563.4 346.3,562.7 347.2,563.2 				"
                    />
                    <polygon
                      class="st174"
                      points="346.5,563.9 345.6,563.4 346.3,562.7 347.1,563.1 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st173"
                      points="351.6,566.8 350.7,566.3 351.4,565.6 352.2,566 				"
                    />
                    <polygon
                      class="st174"
                      points="351.5,566.8 350.7,566.3 351.3,565.5 352.2,566 				"
                    />
                  </g>
                  <g>
                    <polygon
                      class="st173"
                      points="356.5,569.6 355.6,569.1 356.3,568.4 357.1,568.8 				"
                    />
                    <polygon
                      class="st174"
                      points="356.4,569.6 355.6,569.1 356.2,568.3 357.1,568.8 				"
                    />
                  </g>
                  <path
                    class="st177"
                    d="M369.8,570.1v2.5c1.2,0.2,13.6,2.7,23-3v-2.6C391.8,567.6,383.2,572.2,369.8,570.1z"
                  />
                  <path
                    class="st26"
                    d="M369.8,570.1v2c1.2,0.2,13.6,2.7,23-3v-2.1C391.8,567.6,383.2,572.2,369.8,570.1z"
                  />
                  <path
                    class="st47"
                    d="M369.8,570.1v1.4c1.2,0.2,13.6,2.7,23-3v-1.4C391.8,567.6,383.2,572.2,369.8,570.1z"
                  />
                  <path
                    class="st23"
                    d="M335.6,559.4v3.5l26.6,15.2v-3.4L335.6,559.4z M339.4,564.1l-0.7-0.4v-0.4c0,0,0-0.4,0.4-0.2
      c0.3,0.1,0.4,0.6,0.4,0.6V564.1z M344.7,567.1l-0.7-0.4v-0.4c0,0,0-0.4,0.4-0.2c0.3,0.1,0.4,0.6,0.4,0.6V567.1z M350,570.2
      l-0.7-0.4v-0.4c0,0,0-0.4,0.4-0.2s0.4,0.6,0.4,0.6V570.2z M355.2,573.1l-0.7-0.4v-0.4c0,0,0-0.4,0.4-0.2s0.4,0.6,0.4,0.6V573.1z
       M360.1,576l-0.7-0.4v-0.4c0,0,0-0.4,0.4-0.2c0.3,0.1,0.4,0.6,0.4,0.6V576z"
                  />
                  <polygon
                    class="st20"
                    points="392.8,567.1 392.8,569.7 392.4,569.4 392.4,567.3 			"
                  />
                  <path
                    class="st20"
                    d="M369.8,572.6l0.5-0.4l0-2.1l-0.5-0.1C369.8,570.1,369.8,572.6,369.8,572.6z"
                  />

                  <linearGradient
                    id="SVGID_00000069390778618038651350000000818778862010088094_"
                    gradientUnits="userSpaceOnUse"
                    x1="405.6639"
                    y1="568.3802"
                    x2="356.1482"
                    y2="565.4169"
                  >
                    <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                    <stop offset="1" style={{ stopColor: "#000000" }} />
                  </linearGradient>
                  <path
                    style={{
                      fill: "url(#SVGID_00000069390778618038651350000000818778862010088094_)",
                    }}
                    d="M394.9,574.2l3.7,2.1v-12l-3.7-4.9
      C394.9,559.4,394.9,574.2,394.9,574.2z"
                  />

                  <linearGradient
                    id="SVGID_00000081648622523959476950000011690098803458545064_"
                    gradientUnits="userSpaceOnUse"
                    x1="443.1517"
                    y1="545.9123"
                    x2="414.2503"
                    y2="544.1827"
                  >
                    <stop offset="0" style={{ stopColor: "#D8DEDE" }} />
                    <stop offset="1" style={{ stopColor: "#000000" }} />
                  </linearGradient>
                  <path
                    style={{
                      fill: "url(#SVGID_00000081648622523959476950000011690098803458545064_)",
                    }}
                    d="M437,551.9l1.9,1.1v-12.4l-1.9-2.5
      C437,538.2,437,551.9,437,551.9z"
                  />
                </g>
              </g>
              {/* blue layer on outdoor das */}
              {/* <path
                style={{
                  clipPath:
                    "url(#SVGID_00000095320102106307571670000005137112670900025759_)",
                  fill: "#437BAC",
                }}
                d="M448.4,522.7
  c0.2-2.6-0.8-5.2-3.1-7.4l0.1,0l-0.1,0l0.1,0l-0.3-0.2l0,0c0,0,0,0,0,0c-0.9-0.8-1.9-1.6-3-2.4l0.1-0.1l-0.1,0l0.1,0l-0.3-0.2
  l-0.2,0.1c-0.1-0.1-0.2-0.1-0.3-0.2l-3.2-1.9l0.1-0.1l-0.1,0l0.1,0l-0.3-0.2l-0.2,0.1l-3.5-2l0.1-0.1l-0.1,0l0.1,0l-0.3-0.2
  l-0.2,0.1l-3.5-2l0.1-0.1l-0.1,0l0.1,0l-0.3-0.2l-0.2,0.1l-3.5-2l0,0l-0.1,0l0.1,0l-0.3-0.2l-0.1,0.1l-3.6-2.1l0.1-0.1l-0.1,0
  l0.1,0l-0.3-0.2L422,501l0,0c-1.2-0.7-2.5-1.3-3.8-1.8l0.1,0l-0.1,0l0.1,0l-0.3-0.2l-0.2,0.1c-7.6-2.7-17.3-2.8-24.9-0.1l-0.2-0.1
  l-0.3,0.2l0.1,0l0,0c-1.4,0.5-2.7,1.1-3.9,1.8l-0.1,0L388,501l0,0l-3.7,2.1l0,0l-0.3,0.2l0,0l-0.9,0.6V500l1.1-0.6
  c0.1-0.1,0.2-0.2,0.2-0.3v-0.3v-3.4v-0.1c0-0.2-0.3-0.4-0.8-0.5c-0.1,0-0.2,0-0.3,0.1l-7.3,4.2c-0.1,0.1-0.2,0.2-0.2,0.3v3.7
  c0,0.2,0.4,0.5,0.8,0.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0l1-0.6v3.9l-1.3,0.8l-0.1,0l-0.3,0.2l0.1,0l-0.1,0l0,0
  l-3.5,2.1l-0.1,0l-0.3,0.2l0.1,0l-0.1,0l0,0l-3.5,2.1l-0.1-0.1l-0.3,0.2l0.1,0l-0.1,0l0,0l-3.5,2l-0.1-0.1l-0.3,0.2l0.1,0l-0.1,0
  l0.1,0l-3.6,2.1l-0.1,0l-0.3,0.2l0.1,0l-0.1,0l0,0l-3.5,2l-0.2-0.1l-0.3,0.2l0.1,0l-0.1,0l0.1,0l-3.5,2l-0.2-0.1l-0.3,0.2l0.1,0
  l-0.1,0l0.1,0l-1.3,0.8v-4l1.1-0.6c0.1-0.1,0.2-0.2,0.2-0.3V517v-3.4v-0.1c0-0.2-0.3-0.4-0.8-0.5c-0.1,0-0.2,0-0.3,0.1l-7.3,4.2
  c-0.1,0.1-0.2,0.2-0.2,0.3v3.7c0,0.2,0.4,0.5,0.8,0.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l0,0c0,0,0,0,0,0l1-0.6v4l-1,0.6l-0.2-0.1
  l-0.3,0.2l0.1,0l-0.1,0l0.1,0.1l-3.7,2.1l-0.1,0l-0.3,0.2l0.1,0l-1,0.6c-1.1,0.6-2.1,1.3-2.9,2.1l0,0l-0.3,0.2l0.1,0l-0.1,0l0,0
  c-2.5,2.3-3.8,5-3.7,7.7c0,0.1,0,0.2,0,0.3c0,0.2,0,0.3,0,0.5c-0.1,1.4,0.1,2.8,0.6,4.1l0.1,4.5c-0.1,1.6,0.2,3.3,1,4.8v0.7
  c-0.1,1.5,0.3,3,1.1,4.4l-0.4,0.4v0.8v0.1v1.5v0.8v1.1l26.6,15.2l2-1.2l0.7-0.4v0c0,0,0,0,0,0l0,0c0,0,0.1,0,0.2,0.1
  c4.1,1.6,8.9,2.3,13.6,2.2c0.1,0,0.2,0,0.3,0c0.3,0,0.7,0,1,0c0.5,0,0.9-0.1,1.4-0.1c0.3,0,0.6-0.1,0.9-0.1c0.2,0,0.4-0.1,0.6-0.1
  c3.2-0.5,6.3-1.4,8.9-2.7c0.9-0.4,1.9-0.9,2.8-1.5v0l0.1-0.1c0,0,0,0,0,0l1.9,1.1v0l1.9,1.1l5.2-3v-2.1l2.8-1.6v0l0.2-0.1v0l1-0.6
  v0l0.2-0.1v0l1-0.6v0l0.2-0.1v0l1-0.6v0l0.2-0.1v0l0.6-0.4l10.7,6.4l17-9.9l-0.4-0.2l0.4-0.2l-10.4-6.1l0,0v0l0.2-0.1v0l2.1-1.2v0
  l0.2-0.1v0l1-0.6v0l0.2-0.1v0l1-0.6v0l0.2-0.1v0l2.1-1.2v0l0.1,0l1.1-0.6v0l0.2-0.1v0l0.9-0.5l0,0l1.7,1l0.1,0.1l5.2-3v-3.5
  c1.9-1.9,2.9-4.1,2.9-6.3c0,0,0-0.2,0-0.5c0.9-1.3,1.3-2.6,1.3-4.3v-5.9c0,0,0,0,0,0c0-0.4-0.1-1.3-0.6-2.4
  C448.3,525.7,448.5,524.2,448.4,522.7z M338.7,563.2c0-0.1,0.1-0.2,0.3-0.1c0.2,0.1,0.3,0.4,0.3,0.5L338.7,563.2z M344,566.2
  c0-0.1,0.1-0.2,0.3-0.1c0.2,0.1,0.3,0.4,0.3,0.5L344,566.2z M349.3,569.2c0-0.1,0.1-0.2,0.3-0.1c0.2,0.1,0.3,0.4,0.3,0.5
  L349.3,569.2z M350.9,522.6l-1.5,0.9l-0.2-0.1l-0.3,0.2l0.1,0l-0.1,0l0.1,0.1l-1.9,1.1v-4l3.8-2.2V522.6z M354.5,572.2
  c0-0.1,0.1-0.2,0.3-0.1c0.2,0.1,0.3,0.4,0.3,0.5L354.5,572.2z M359.4,575.1c0-0.1,0.1-0.2,0.3-0.1c0.2,0.1,0.3,0.4,0.3,0.5
  L359.4,575.1z M382.5,504.3l-1.9,1.1l-0.1,0l-0.3,0.2l0.1,0l-1.6,0.9v-3.9l3.8-2.2V504.3z M447,530.3
  C447,530.3,447,530.3,447,530.3L447,530.3C447,530.3,447,530.3,447,530.3z"
              /> */}
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000095320102106307571670000005137112670900025759_)",
                }}
              >
                <circle class="st181" cx="389.2" cy="531.5" r="59.2" />
              </g>
              
            </g>
{/* end */}

            <g className="hexagon-from-top-1">
              <defs>
                <polygon
                  id="SVGID_00000008846083118298562540000000877861472701142186_"
                  // className="hexagon-from-top"
                  points="329.1,173.1 329.1,105.2 270.3,71.2 
    211.5,105.2 211.5,173.1 270.3,207 		"
                />
              </defs>
              <clipPath id="SVGID_00000177456793405552278670000012651188507244180636_">
                <use
                  xlinkHref="#SVGID_00000008846083118298562540000000877861472701142186_"
                  style={{ overflow: "visible" }}
                />
              </clipPath>
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000177456793405552278670000012651188507244180636_)",
                }}
              >
                <circle class="st0" cx="270.3" cy="148.4" r="93.5" />
                <path
                  class="st183"
                  d="M180.2,170.5c10.9,39.6,47.1,68.7,90.1,68.7c42.7,0,78.7-28.6,89.9-67.8c-22.4-19.2-54.7-31.3-90.5-31.3
    C234.3,140.1,202.5,151.8,180.2,170.5z"
                />
                <g>
                  <polygon
                    class="st1"
                    points="270.3,186.2 247.6,176.4 247.6,172.4 270.3,182.2 			"
                  />
                  <polygon
                    class="st10"
                    points="293,176.4 270.3,186.2 270.3,182.2 293,172.4 			"
                  />
                  <polygon
                    class="st184"
                    points="270.3,182.2 247.6,172.4 270.3,162.5 293,172.4 			"
                  />
                  <g>
                    <ellipse
                      class="st1"
                      cx="270.3"
                      cy="171.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st185"
                      cx="270.3"
                      cy="171.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st186"
                      cx="270.3"
                      cy="171.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st187"
                      cx="270.3"
                      cy="171.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st188"
                      cx="270.3"
                      cy="171.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st189"
                      cx="270.3"
                      cy="171.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st190"
                      cx="270.3"
                      cy="171.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st190"
                      cx="270.3"
                      cy="171"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st191"
                      cx="270.3"
                      cy="171"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st192"
                      cx="270.3"
                      cy="170.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st193"
                      cx="270.3"
                      cy="170.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st194"
                      cx="270.3"
                      cy="170.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st195"
                      cx="270.3"
                      cy="170.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st196"
                      cx="270.3"
                      cy="170.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st197"
                      cx="270.3"
                      cy="170.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st197"
                      cx="270.3"
                      cy="170.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st198"
                      cx="270.3"
                      cy="170.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st199"
                      cx="270.3"
                      cy="170.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st200"
                      cx="270.3"
                      cy="170.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st201"
                      cx="270.3"
                      cy="170.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st201"
                      cx="270.3"
                      cy="170.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st202"
                      cx="270.3"
                      cy="170.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st203"
                      cx="270.3"
                      cy="170.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st204"
                      cx="270.3"
                      cy="170"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st205"
                      cx="270.3"
                      cy="170"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st206"
                      cx="270.3"
                      cy="169.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st207"
                      cx="270.3"
                      cy="169.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st208"
                      cx="270.3"
                      cy="169.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st208"
                      cx="270.3"
                      cy="169.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st209"
                      cx="270.3"
                      cy="169.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st210"
                      cx="270.3"
                      cy="169.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st211"
                      cx="270.3"
                      cy="169.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st212"
                      cx="270.3"
                      cy="169.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st212"
                      cx="270.3"
                      cy="169.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st213"
                      cx="270.3"
                      cy="169.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st213"
                      cx="270.3"
                      cy="169.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st214"
                      cx="270.3"
                      cy="169.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st215"
                      cx="270.3"
                      cy="169.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st216"
                      cx="270.3"
                      cy="169.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st217"
                      cx="270.3"
                      cy="169"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st218"
                      cx="270.3"
                      cy="168.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st219"
                      cx="270.3"
                      cy="168.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st220"
                      cx="270.3"
                      cy="168.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st220"
                      cx="270.3"
                      cy="168.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st221"
                      cx="270.3"
                      cy="168.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st222"
                      cx="270.3"
                      cy="168.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st222"
                      cx="270.3"
                      cy="168.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st223"
                      cx="270.3"
                      cy="168.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st223"
                      cx="270.3"
                      cy="168.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st224"
                      cx="270.3"
                      cy="168.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st225"
                      cx="270.3"
                      cy="168.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st226"
                      cx="270.3"
                      cy="168.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st227"
                      cx="270.3"
                      cy="168.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st228"
                      cx="270.3"
                      cy="168.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st228"
                      cx="270.3"
                      cy="168.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st229"
                      cx="270.3"
                      cy="168"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st229"
                      cx="270.3"
                      cy="167.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st230"
                      cx="270.3"
                      cy="167.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st231"
                      cx="270.3"
                      cy="167.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st231"
                      cx="270.3"
                      cy="167.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st232"
                      cx="270.3"
                      cy="167.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st233"
                      cx="270.3"
                      cy="167.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st234"
                      cx="270.3"
                      cy="167.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st235"
                      cx="270.3"
                      cy="167.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st236"
                      cx="270.3"
                      cy="167.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st237"
                      cx="270.3"
                      cy="167.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st238"
                      cx="270.3"
                      cy="167.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st238"
                      cx="270.3"
                      cy="167.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st239"
                      cx="270.3"
                      cy="167.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st239"
                      cx="270.3"
                      cy="167.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st240"
                      cx="270.3"
                      cy="167.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st241"
                      cx="270.3"
                      cy="167"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st242"
                      cx="270.3"
                      cy="166.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st243"
                      cx="270.3"
                      cy="166.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st243"
                      cx="270.3"
                      cy="166.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st244"
                      cx="270.3"
                      cy="166.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st245"
                      cx="270.3"
                      cy="166.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st246"
                      cx="270.3"
                      cy="166.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st247"
                      cx="270.3"
                      cy="166.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st248"
                      cx="270.3"
                      cy="166.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st249"
                      cx="270.3"
                      cy="166.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st250"
                      cx="270.3"
                      cy="166.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st250"
                      cx="270.3"
                      cy="166.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st251"
                      cx="270.3"
                      cy="166.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st252"
                      cx="270.3"
                      cy="166.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st253"
                      cx="270.3"
                      cy="166.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st254"
                      cx="270.3"
                      cy="166.1"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st254"
                      cx="270.3"
                      cy="166"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st255"
                      cx="270.3"
                      cy="165.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st256"
                      cx="270.3"
                      cy="165.9"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st257"
                      cx="270.3"
                      cy="165.8"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st258"
                      cx="270.3"
                      cy="165.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st259"
                      cx="270.3"
                      cy="165.7"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st260"
                      cx="270.3"
                      cy="165.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st261"
                      cx="270.3"
                      cy="165.6"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st261"
                      cx="270.3"
                      cy="165.5"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st262"
                      cx="270.3"
                      cy="165.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st263"
                      cx="270.3"
                      cy="165.4"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st264"
                      cx="270.3"
                      cy="165.3"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st265"
                      cx="270.3"
                      cy="165.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st266"
                      cx="270.3"
                      cy="165.2"
                      rx="9.6"
                      ry="3.5"
                    />
                    <ellipse
                      class="st183"
                      cx="270.3"
                      cy="165.1"
                      rx="9.6"
                      ry="3.5"
                    />
                  </g>
                  <ellipse
                    class="st184"
                    cx="270.3"
                    cy="165.1"
                    rx="9.6"
                    ry="3.5"
                  />
                  <path
                    class="st14"
                    d="M276.1,122.5c0-0.2-0.2-0.3-0.3-0.3c-0.2,0-0.3,0.2-0.3,0.3l0.8,8.1l-5.7-2.5v-3.7c0-0.2-0.1-0.3-0.3-0.3
      c-0.2,0-0.3,0.1-0.3,0.3v3.7l-5.7,2.5l0.8-8.1c0-0.2-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3l-0.8,8.6c0,0,0,0,0,0c0,0,0,0,0,0
      l-0.6,6.8c0,0,0,0,0,0c0,0,0,0,0,0l-0.6,6.8c0,0,0,0,0,0c0,0,0,0,0,0l-0.6,6.7c0,0,0,0,0,0c0,0,0,0,0,0l-0.6,6.7c0,0,0,0,0,0.1
      c0,0,0,0,0,0l-0.7,7c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0c0.1,0,0.3-0.1,0.3-0.3l0.6-6.6l8.3,3.6v6.3c0,0.2,0.1,0.3,0.3,0.3
      c0.2,0,0.3-0.1,0.3-0.3v-6.3l8.4-3.6l0.6,6.6c0,0.2,0.1,0.3,0.3,0.3c0,0,0,0,0,0c0.2,0,0.3-0.2,0.3-0.3L276.1,122.5z
       M277.6,144.3l-7-3v-0.1l6.4-2.8L277.6,144.3z M270,147.6l-6.6-2.8l6.6-2.8V147.6z M270.6,141.9l6.6,2.8l-6.6,2.8V141.9z
       M270.6,140.5v-5.1l5.9,2.6L270.6,140.5z M270,140.5l-5.9-2.6l5.9-2.6V140.5z M270,141.1v0.1l-7,3l0.6-5.9L270,141.1z M269.5,148
      l-7.1,3.1l0.6-5.9L269.5,148z M270,148.4v5.9l-0.4,0.2l-6.8-2.9L270,148.4z M270.6,154.3v-5.9l7.2,3.1l-6.8,2.9L270.6,154.3z
       M271.1,148l6.6-2.8l0.6,5.9L271.1,148z M276.9,137.5l-6.3-2.7v-0.7l5.8-2.5L276.9,137.5z M275.9,131.1l-5.3,2.3v-4.6
      L275.9,131.1z M270,128.8v4.6l-5.3-2.3L270,128.8z M270,134.1v0.7l-6.3,2.7l0.6-5.9L270,134.1z M262.3,152l6.5,2.8l-7.1,3.1
      L262.3,152z M262.1,158.4l7.5-3.2l0.4,0.2v6.5L262.1,158.4z M270.6,161.8v-6.5l0.4-0.2l7.5,3.2L270.6,161.8z M271.8,154.8
      l6.6-2.8l0.6,5.9L271.8,154.8z"
                  />
                  <g id="uZYL1A_5_">
                    <g>
                      <path
                        class="st10"
                        d="M256.5,122.2C256.5,122.2,256.4,122.2,256.5,122.2c-0.2,0.2-0.5,0.2-0.6,0c-4.2-4.3-4.4-11.8,0-16.5
          c0.2-0.2,0.5-0.2,0.6,0l0,0c0.2,0.2,0.2,0.4,0,0.6c-1.9,2.1-3,4.7-3,7.6c0,2.9,1,5.5,3,7.6C256.6,121.8,256.6,122,256.5,122.2z
          "
                      />
                      <path
                        class="st10"
                        d="M284.2,122.2C284.2,122.2,284.2,122.2,284.2,122.2c-0.2-0.2-0.2-0.5,0-0.6c1.9-2.1,3-4.7,3-7.6
          c0-2.9-1-5.5-3-7.6c-0.2-0.2-0.1-0.4,0-0.6c0,0,0,0,0,0c0.2-0.2,0.5-0.2,0.6,0c4.2,4.4,4.4,11.8,0,16.5
          C284.6,122.4,284.4,122.4,284.2,122.2z"
                      />
                      <path
                        class="st10"
                        d="M258.5,107.8C258.5,107.8,258.5,107.8,258.5,107.8c0.2,0.2,0.2,0.5,0,0.6c-1.4,1.6-2.1,3.4-2.1,5.6
          c0,2.1,0.7,4,2.1,5.6c0.2,0.2,0.1,0.4,0,0.6c0,0,0,0,0,0c-0.2,0.2-0.5,0.2-0.6,0c-3.2-3.4-3.2-9,0-12.4
          C258,107.6,258.3,107.6,258.5,107.8z"
                      />
                      <path
                        class="st10"
                        d="M282.1,120.2C282.1,120.2,282.1,120.2,282.1,120.2c-0.2-0.2-0.2-0.4,0-0.6c2.9-3.2,2.7-8.1,0-11.1
          c-0.2-0.2-0.1-0.5,0-0.6c0,0,0,0,0,0c0.2-0.1,0.4-0.1,0.6,0c3,3.1,3.3,8.8,0,12.4C282.6,120.4,282.3,120.4,282.1,120.2z"
                      />
                      <path
                        class="st10"
                        d="M280.2,118.3C280.2,118.3,280.2,118.3,280.2,118.3c-0.2-0.2-0.2-0.5-0.1-0.6c0.9-1,1.3-2.2,1.4-3.6
          c0-1.4-0.5-2.6-1.3-3.6c-0.2-0.2-0.1-0.5,0.1-0.6c0,0,0,0,0,0c0.2-0.2,0.4-0.1,0.6,0c2,2.1,2.2,6,0,8.5
          C280.7,118.4,280.4,118.4,280.2,118.3z"
                      />
                      <path
                        class="st10"
                        d="M260.4,109.7C260.4,109.7,260.4,109.7,260.4,109.7c0.2,0.2,0.2,0.4,0.1,0.6c-1.8,2.4-1.8,4.9,0,7.4
          c0.1,0.2,0.1,0.4,0,0.6c0,0,0,0,0,0c-0.2,0.2-0.5,0.2-0.6,0c-2-2.2-2.2-6,0-8.5C260,109.5,260.2,109.5,260.4,109.7z"
                      />
                    </g>
                  </g>
                  <g>
                    <ellipse
                      class="st201"
                      cx="270.3"
                      cy="124"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st267"
                      cx="270.3"
                      cy="124"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st205"
                      cx="270.3"
                      cy="124"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st207"
                      cx="270.3"
                      cy="124"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st208"
                      cx="270.3"
                      cy="123.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st211"
                      cx="270.3"
                      cy="123.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st212"
                      cx="270.3"
                      cy="123.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st213"
                      cx="270.3"
                      cy="123.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st268"
                      cx="270.3"
                      cy="123.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st217"
                      cx="270.3"
                      cy="123.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st219"
                      cx="270.3"
                      cy="123.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st269"
                      cx="270.3"
                      cy="123.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st270"
                      cx="270.3"
                      cy="123.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st271"
                      cx="270.3"
                      cy="123.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st272"
                      cx="270.3"
                      cy="123.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st273"
                      cx="270.3"
                      cy="123.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st274"
                      cx="270.3"
                      cy="123.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st275"
                      cx="270.3"
                      cy="123.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st276"
                      cx="270.3"
                      cy="123.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st277"
                      cx="270.3"
                      cy="123.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st278"
                      cx="270.3"
                      cy="123.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st279"
                      cx="270.3"
                      cy="123.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st280"
                      cx="270.3"
                      cy="123.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st281"
                      cx="270.3"
                      cy="123.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st282"
                      cx="270.3"
                      cy="123.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st283"
                      cx="270.3"
                      cy="123.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st284"
                      cx="270.3"
                      cy="123.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st285"
                      cx="270.3"
                      cy="123.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st286"
                      cx="270.3"
                      cy="123.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st287"
                      cx="270.3"
                      cy="123.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st288"
                      cx="270.3"
                      cy="123.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st289"
                      cx="270.3"
                      cy="123.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st290"
                      cx="270.3"
                      cy="123.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st291"
                      cx="270.3"
                      cy="123.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st292"
                      cx="270.3"
                      cy="123.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st293"
                      cx="270.3"
                      cy="123.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st294"
                      cx="270.3"
                      cy="123.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st295"
                      cx="270.3"
                      cy="123.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st296"
                      cx="270.3"
                      cy="123.4"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st297"
                      cx="270.3"
                      cy="123.4"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st298"
                      cx="270.3"
                      cy="123.4"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st299"
                      cx="270.3"
                      cy="123.4"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st300"
                      cx="270.3"
                      cy="123.4"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st301"
                      cx="270.3"
                      cy="123.4"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st302"
                      cx="270.3"
                      cy="123.4"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st303"
                      cx="270.3"
                      cy="123.3"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st304"
                      cx="270.3"
                      cy="123.3"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st305"
                      cx="270.3"
                      cy="123.3"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st306"
                      cx="270.3"
                      cy="123.3"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st307"
                      cx="270.3"
                      cy="123.3"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st308"
                      cx="270.3"
                      cy="123.3"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st309"
                      cx="270.3"
                      cy="123.3"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st310"
                      cx="270.3"
                      cy="123.2"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st311"
                      cx="270.3"
                      cy="123.2"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st312"
                      cx="270.3"
                      cy="123.2"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st313"
                      cx="270.3"
                      cy="123.2"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st314"
                      cx="270.3"
                      cy="123.2"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st315"
                      cx="270.3"
                      cy="123.2"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st316"
                      cx="270.3"
                      cy="123.2"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st317"
                      cx="270.3"
                      cy="123.1"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st318"
                      cx="270.3"
                      cy="123.1"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st319"
                      cx="270.3"
                      cy="123.1"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st320"
                      cx="270.3"
                      cy="123.1"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st321"
                      cx="270.3"
                      cy="123.1"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st322"
                      cx="270.3"
                      cy="123.1"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st323"
                      cx="270.3"
                      cy="123.1"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st324"
                      cx="270.3"
                      cy="123"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st325"
                      cx="270.3"
                      cy="123"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st326"
                      cx="270.3"
                      cy="123"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st327"
                      cx="270.3"
                      cy="123"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st328"
                      cx="270.3"
                      cy="123"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st329"
                      cx="270.3"
                      cy="123"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st330"
                      cx="270.3"
                      cy="123"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st331"
                      cx="270.3"
                      cy="122.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st332"
                      cx="270.3"
                      cy="122.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st333"
                      cx="270.3"
                      cy="122.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st334"
                      cx="270.3"
                      cy="122.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st335"
                      cx="270.3"
                      cy="122.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st336"
                      cx="270.3"
                      cy="122.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st337"
                      cx="270.3"
                      cy="122.9"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st338"
                      cx="270.3"
                      cy="122.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st339"
                      cx="270.3"
                      cy="122.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st340"
                      cx="270.3"
                      cy="122.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st341"
                      cx="270.3"
                      cy="122.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st342"
                      cx="270.3"
                      cy="122.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st343"
                      cx="270.3"
                      cy="122.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st344"
                      cx="270.3"
                      cy="122.8"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st345"
                      cx="270.3"
                      cy="122.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st346"
                      cx="270.3"
                      cy="122.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st347"
                      cx="270.3"
                      cy="122.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st348"
                      cx="270.3"
                      cy="122.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st349"
                      cx="270.3"
                      cy="122.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st350"
                      cx="270.3"
                      cy="122.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st351"
                      cx="270.3"
                      cy="122.7"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st352"
                      cx="270.3"
                      cy="122.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st353"
                      cx="270.3"
                      cy="122.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st354"
                      cx="270.3"
                      cy="122.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st355"
                      cx="270.3"
                      cy="122.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st356"
                      cx="270.3"
                      cy="122.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st357"
                      cx="270.3"
                      cy="122.6"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st358"
                      cx="270.3"
                      cy="122.5"
                      rx="5.5"
                      ry="2"
                    />
                    <ellipse
                      class="st184"
                      cx="270.3"
                      cy="122.5"
                      rx="5.5"
                      ry="2"
                    />
                  </g>
                  <ellipse
                    class="st184"
                    cx="270.3"
                    cy="122.5"
                    rx="5.5"
                    ry="2"
                  />
                  <line
                    class="st359"
                    x1="270.3"
                    y1="122.5"
                    x2="270.3"
                    y2="114.2"
                  />
                  <circle class="st10" cx="270.3" cy="114" r="1.3" />
                </g>
              </g>
            </g>
            <g className="hexagon-from-top-2">
              <defs>
                <polygon
                  id="SVGID_00000152231892148137137010000015534603842604220862_"
                  points="567,173.1 567,105.2 508.2,71.2 449.4,105.2 
    449.4,173.1 508.2,207 		"
                />
              </defs>
              <clipPath id="SVGID_00000026876514164453065720000016121517295384502416_">
                <use
                  xlinkHref="#SVGID_00000152231892148137137010000015534603842604220862_"
                  style={{ overflow: "visible" }}
                />
              </clipPath>
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000026876514164453065720000016121517295384502416_)",
                }}
              >
                <circle class="st361" cx="508.2" cy="140.6" r="69.3" />
                <g>
                  <defs>
                    <circle
                      id="SVGID_00000107583699191371055270000006463472771711937444_"
                      cx="508.2"
                      cy="140.6"
                      r="69.3"
                    />
                  </defs>
                  <clipPath id="SVGID_00000145043499497021126000000014874122748611274150_">
                    <use
                      xlinkHref="#SVGID_00000107583699191371055270000006463472771711937444_"
                      style={{ overflow: "visible" }}
                    />
                  </clipPath>
                  <g
                    style={{
                      clipPath:
                        "url(#SVGID_00000145043499497021126000000014874122748611274150_)",
                    }}
                  >
                    <path
                      class="st1"
                      d="M488.7,110.2h-44.5v0.1c-5.6,1.3-10,14.3-10,30.2c0,15.9,4.4,28.9,10,30.2v0.1h44.5
        c6,0,10.9-13.6,10.9-30.3C499.6,123.8,494.7,110.2,488.7,110.2z"
                    />
                    <ellipse
                      class="st363"
                      cx="488.7"
                      cy="140.6"
                      rx="10.9"
                      ry="30.3"
                    />
                    <path
                      class="st15"
                      d="M435,129.3h43.6c0.7-4.6,1.7-8.7,3.1-11.8H438C436.7,120.7,435.6,124.7,435,129.3z"
                    />
                    <path
                      class="st184"
                      d="M525.9,140.6c0-13.4-3.9-24.2-8.7-24.2h-24.8c-4.8,0-8.7,10.8-8.7,24.2c0,13.4,3.9,24.2,8.7,24.2h24.8
        C522,164.8,525.9,153.9,525.9,140.6z"
                    />
                    <ellipse
                      class="st364"
                      cx="517.2"
                      cy="140.6"
                      rx="8.7"
                      ry="24.2"
                    />
                    <path
                      class="st365"
                      d="M519.1,159.5c-0.8,1.4-2.9,1.4-3.7,0c-1.7-3-3.7-9.2-3.7-18.9c0-9.7,2-15.9,3.7-18.9
        c0.8-1.4,2.9-1.4,3.7,0c1.7,3,3.7,9.2,3.7,18.9C522.7,150.3,520.7,156.5,519.1,159.5z"
                    />
                    <path
                      class="st366"
                      d="M512.6,130.4h36.9v-5.2h-35.6C513.4,126.6,513,128.4,512.6,130.4z"
                    />
                    <path
                      class="st366"
                      d="M511.8,138.4h23.8v-5.2h-23.4C512,134.8,511.9,136.5,511.8,138.4z"
                    />
                    <path
                      class="st366"
                      d="M512,146.5h45v-5.2h-45.2C511.8,143.1,511.9,144.9,512,146.5z"
                    />
                    <path
                      class="st366"
                      d="M513.4,154.5h30.4v-5.2h-31.5C512.7,151.3,513,153,513.4,154.5z"
                    />
                    <path
                      class="st367"
                      d="M484.1,133.2h24.8c0.4-3.7,1.2-7.1,2.2-9.8h-24.8C485.3,126.1,484.6,129.5,484.1,133.2z"
                    />
                    <path
                      class="st10"
                      d="M488.7,170.9c-3,0-5.8-3.4-7.7-9h-43.6c1.8,5,4.2,8.2,6.8,8.8v0.1H488.7z"
                    />
                    <path
                      class="st183"
                      d="M511,157.6h-24.8c1.6,4.4,3.8,7.2,6.2,7.2h24.8C514.8,164.8,512.6,162,511,157.6z"
                    />
                    <path
                      class="st368"
                      d="M552.4,133.2h-5.8c-1.4,0-2.5-1.1-2.5-2.5v-5.8c0-1.4,1.1-2.5,2.5-2.5h5.8c1.4,0,2.5,1.1,2.5,2.5v5.8
        C554.9,132.1,553.8,133.2,552.4,133.2z"
                    />
                    <path
                      class="st368"
                      d="M538.5,141.3h-5.8c-1.4,0-2.5-1.1-2.5-2.5v-5.8c0-1.4,1.1-2.5,2.5-2.5h5.8c1.4,0,2.5,1.1,2.5,2.5v5.8
        C541,140.1,539.9,141.3,538.5,141.3z"
                    />
                    <path
                      class="st368"
                      d="M557.8,149.3H552c-1.4,0-2.5-1.1-2.5-2.5V141c0-1.4,1.1-2.5,2.5-2.5h5.8c1.4,0,2.5,1.1,2.5,2.5v5.8
        C560.4,148.2,559.2,149.3,557.8,149.3z"
                    />
                    <path
                      class="st368"
                      d="M546.5,157.3h-5.8c-1.4,0-2.5-1.1-2.5-2.5V149c0-1.4,1.1-2.5,2.5-2.5h5.8c1.4,0,2.5,1.1,2.5,2.5v5.8
        C549.1,156.2,547.9,157.3,546.5,157.3z"
                    />
                    <g>
                      <path
                        class="st361"
                        d="M517.2,127.8c0-1.4,1.2-2.6,2.6-2.6h-5.9c-0.5,1.4-0.9,3.2-1.3,5.2h7.2
          C518.4,130.4,517.2,129.2,517.2,127.8z"
                      />
                    </g>
                    <path
                      class="st361"
                      d="M514.3,135.8c0-1.4,1.2-2.6,2.6-2.6h-4.8c-0.2,1.6-0.3,3.3-0.4,5.2l5.1,0
        C515.5,138.4,514.3,137.3,514.3,135.8z"
                    />
                    <g>
                      <path
                        class="st361"
                        d="M516.9,143.9c0-1.4,1.2-2.6,2.6-2.6h-7.8c0,1.9,0.1,3.6,0.3,5.2h7.5
          C518.1,146.5,516.9,145.3,516.9,143.9z"
                      />
                    </g>
                    <g>
                      <path
                        class="st361"
                        d="M514.9,151.9c0-1.4,1.2-2.6,2.6-2.6h-5.2c0.3,2,0.7,3.7,1.1,5.2h4.1
          C516.1,154.5,514.9,153.3,514.9,151.9z"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g className="hexagon-from-top-3">
              <defs>
                <polygon
                  id="SVGID_00000062149859957537740840000014795508620973230213_"
                  points="804.8,173.1 804.8,105.2 746,71.2 687.2,105.2 
    687.2,173.1 746,207 		"
                />
              </defs>
              <clipPath id="SVGID_00000018954087454570350930000001668972853614904247_">
                <use
                  xlinkHref="#SVGID_00000062149859957537740840000014795508620973230213_"
                  style={{ overflow: "visible" }}
                />
              </clipPath>
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000018954087454570350930000001668972853614904247_)",
                }}
              >
                <circle class="st361" cx="746" cy="138.9" r="71.1" />
                <g>
                  <defs>
                    <circle
                      id="SVGID_00000165944007419771148220000001536871341034412438_"
                      cx="746"
                      cy="138.9"
                      r="71.1"
                    />
                  </defs>
                  <clipPath id="SVGID_00000064343035050314534940000010199066758834399110_">
                    <use
                      xlinkHref="#SVGID_00000165944007419771148220000001536871341034412438_"
                      style={{ overflow: "visible" }}
                    />
                  </clipPath>
                  <g
                    style={{
                      clipPath:
                        "url(#SVGID_00000064343035050314534940000010199066758834399110_)",
                    }}
                  >
                    <polygon
                      class="st361"
                      points="741.2,203.9 643.9,158.8 764.3,103.2 861.7,148.2 				"
                    />
                    <polygon
                      class="st0"
                      points="643.9,158.8 643.9,103 764.3,47.4 861.7,92.5 861.7,148.2 764.3,103.2 				"
                    />
                    <g>
                      <polygon
                        class="st1"
                        points="731,137.7 718.2,131.7 718.2,112.8 731,118.7 					"
                      />
                      <polygon
                        class="st15"
                        points="759.2,93.9 718.2,112.8 731,118.7 772,99.8 					"
                      />
                      <polygon
                        class="st10"
                        points="772,99.8 772,118.7 731,137.7 731,118.7 					"
                      />
                      <polygon
                        class="st183"
                        points="769.4,103.3 764.3,105.7 764.3,119.9 769.4,117.5 					"
                      />
                      <polygon
                        class="st183"
                        points="761.7,106.9 756.6,109.2 756.6,123.5 761.7,121.1 					"
                      />
                      <polygon
                        class="st183"
                        points="754,110.4 748.9,112.8 748.9,127 754,124.6 					"
                      />
                      <polygon
                        class="st183"
                        points="746.3,114 741.2,116.4 741.2,130.6 746.3,128.2 					"
                      />
                      <polygon
                        class="st183"
                        points="738.7,117.5 733.5,119.9 733.5,134.1 738.7,131.7 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="769.4,116.7 769.4,103.3 768.4,103.8 768.4,117.2 769.4,117.5 						"
                        />
                        <polygon
                          class="st1"
                          points="768.4,117.2 768.4,117.2 764.3,119.1 764.3,119.9 769.4,117.5 769.4,117.5 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M764.7,106l3.1-1.4v0.4l-3.1,1.4V106z M764.7,107l3.1-1.4v-0.4l-3.1,1.4V107z M764.7,107.7l3.1-1.4v-0.4
            l-3.1,1.4V107.7z M764.7,108.3l3.1-1.4v-0.4l-3.1,1.4V108.3z M764.7,108.9l3.1-1.4v-0.4l-3.1,1.4V108.9z M764.7,109.5l3.1-1.4
            v-0.4l-3.1,1.4V109.5z M764.7,110.2l3.1-1.4v-0.4l-3.1,1.4V110.2z"
                        />
                        <polygon
                          class="st1"
                          points="764.7,112 767.8,110.6 767.8,110.2 764.7,111.6 						"
                        />
                        <polygon
                          class="st1"
                          points="764.7,112.6 767.8,111.2 767.8,110.8 764.7,112.3 						"
                        />
                        <polygon
                          class="st1"
                          points="764.7,113.3 767.8,111.8 767.8,111.4 764.7,112.9 						"
                        />
                        <polygon
                          class="st1"
                          points="764.7,113.9 767.8,112.4 767.8,112.1 764.7,113.5 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="767.8,106.8 767.8,106.5 767.4,106.7 767.4,107 							"
                          />
                          <polygon
                            class="st14"
                            points="767.8,107.5 767.8,107.1 767.4,107.3 767.4,107.7 							"
                          />
                          <polygon
                            class="st14"
                            points="767.8,105.2 767.4,105.4 767.4,105.8 767.8,105.6 							"
                          />
                          <polygon
                            class="st14"
                            points="767.8,106.2 767.8,105.8 767.4,106.1 767.4,106.4 							"
                          />
                          <polygon
                            class="st14"
                            points="767.8,108.1 767.8,107.7 767.4,107.9 767.4,108.3 							"
                          />
                          <polygon
                            class="st14"
                            points="767.4,105.2 767.8,105 767.8,104.6 767.4,104.8 							"
                          />
                          <polygon
                            class="st14"
                            points="767.8,108.7 767.8,108.3 767.4,108.5 767.4,108.9 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="761.7,120.3 761.7,106.9 760.7,107.4 760.7,120.8 761.7,121.1 						"
                        />
                        <polygon
                          class="st1"
                          points="760.7,120.8 760.7,120.8 756.6,122.7 756.6,123.5 761.7,121.1 761.7,121.1 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M757,109.6l3.1-1.4v0.4L757,110V109.6z M757,110.6l3.1-1.4v-0.4l-3.1,1.4V110.6z M757,111.2l3.1-1.4v-0.4
            l-3.1,1.4V111.2z M757,111.8l3.1-1.4V110l-3.1,1.4V111.8z M757,112.5l3.1-1.4v-0.4l-3.1,1.4V112.5z M757,113.1l3.1-1.4v-0.4
            l-3.1,1.4V113.1z M757,113.7l3.1-1.4v-0.4l-3.1,1.4V113.7z"
                        />
                        <polygon
                          class="st1"
                          points="757,115.6 760.1,114.1 760.1,113.8 757,115.2 						"
                        />
                        <polygon
                          class="st1"
                          points="757,116.2 760.1,114.7 760.1,114.4 757,115.8 						"
                        />
                        <polygon
                          class="st1"
                          points="757,116.8 760.1,115.4 760.1,115 757,116.4 						"
                        />
                        <polygon
                          class="st1"
                          points="757,117.4 760.1,116 760.1,115.6 757,117.1 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="760.1,110.4 760.1,110 759.7,110.2 759.7,110.6 							"
                          />
                          <polygon
                            class="st14"
                            points="760.1,111 760.1,110.6 759.7,110.8 759.7,111.2 							"
                          />
                          <polygon
                            class="st14"
                            points="760.1,108.8 759.7,109 759.7,109.4 760.1,109.1 							"
                          />
                          <polygon
                            class="st14"
                            points="760.1,109.8 760.1,109.4 759.7,109.6 759.7,110 							"
                          />
                          <polygon
                            class="st14"
                            points="760.1,111.6 760.1,111.3 759.7,111.5 759.7,111.8 							"
                          />
                          <polygon
                            class="st14"
                            points="759.7,108.7 760.1,108.5 760.1,108.2 759.7,108.4 							"
                          />
                          <polygon
                            class="st14"
                            points="760.1,112.3 760.1,111.9 759.7,112.1 759.7,112.5 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="754,123.8 754,110.4 753,110.9 753,124.3 754,124.6 						"
                        />
                        <polygon
                          class="st1"
                          points="753,124.3 753,124.3 748.9,126.2 748.9,127 754,124.6 754,124.6 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M749.3,113.2l3.1-1.4v0.4l-3.1,1.4V113.2z M749.3,114.1l3.1-1.4v-0.4l-3.1,1.4V114.1z M749.3,114.8
            l3.1-1.4v-0.4l-3.1,1.4V114.8z M749.3,115.4l3.1-1.4v-0.4l-3.1,1.4V115.4z M749.3,116l3.1-1.4v-0.4l-3.1,1.4V116z
             M749.3,116.6l3.1-1.4v-0.4l-3.1,1.4V116.6z M749.3,117.3l3.1-1.4v-0.4l-3.1,1.4V117.3z"
                        />
                        <polygon
                          class="st1"
                          points="749.3,119.1 752.4,117.7 752.4,117.3 749.3,118.8 						"
                        />
                        <polygon
                          class="st1"
                          points="749.3,119.7 752.4,118.3 752.4,117.9 749.3,119.4 						"
                        />
                        <polygon
                          class="st1"
                          points="749.3,120.4 752.4,118.9 752.4,118.5 749.3,120 						"
                        />
                        <polygon
                          class="st1"
                          points="749.3,121 752.4,119.5 752.4,119.2 749.3,120.6 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="752.4,113.9 752.4,113.6 752,113.8 752,114.2 							"
                          />
                          <polygon
                            class="st14"
                            points="752.4,114.6 752.4,114.2 752,114.4 752,114.8 							"
                          />
                          <polygon
                            class="st14"
                            points="752.4,112.3 752,112.5 752,112.9 752.4,112.7 							"
                          />
                          <polygon
                            class="st14"
                            points="752.4,113.3 752.4,112.9 752,113.2 752,113.5 							"
                          />
                          <polygon
                            class="st14"
                            points="752.4,115.2 752.4,114.8 752,115 752,115.4 							"
                          />
                          <polygon
                            class="st14"
                            points="752,112.3 752.4,112.1 752.4,111.7 752,111.9 							"
                          />
                          <polygon
                            class="st14"
                            points="752.4,115.8 752.4,115.4 752,115.6 752,116 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="746.3,127.4 746.3,114 745.3,114.5 745.3,127.9 746.3,128.2 						"
                        />
                        <polygon
                          class="st1"
                          points="745.3,127.9 745.3,127.9 741.2,129.8 741.2,130.6 746.3,128.2 746.3,128.2 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M741.6,116.7l3.1-1.4v0.4l-3.1,1.4V116.7z M741.6,117.7l3.1-1.4v-0.4l-3.1,1.4V117.7z M741.6,118.3
            l3.1-1.4v-0.4l-3.1,1.4V118.3z M741.6,118.9l3.1-1.4v-0.4l-3.1,1.4V118.9z M741.6,119.6l3.1-1.4v-0.4l-3.1,1.4V119.6z
             M741.6,120.2l3.1-1.4v-0.4l-3.1,1.4V120.2z M741.6,120.8l3.1-1.4V119l-3.1,1.4V120.8z"
                        />
                        <polygon
                          class="st1"
                          points="741.6,122.7 744.8,121.2 744.8,120.9 741.6,122.3 						"
                        />
                        <polygon
                          class="st1"
                          points="741.6,123.3 744.8,121.9 744.8,121.5 741.6,122.9 						"
                        />
                        <polygon
                          class="st1"
                          points="741.6,123.9 744.8,122.5 744.8,122.1 741.6,123.5 						"
                        />
                        <polygon
                          class="st1"
                          points="741.6,124.5 744.8,123.1 744.8,122.7 741.6,124.2 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="744.8,117.5 744.8,117.1 744.3,117.3 744.3,117.7 							"
                          />
                          <polygon
                            class="st14"
                            points="744.8,118.1 744.8,117.7 744.3,118 744.3,118.3 							"
                          />
                          <polygon
                            class="st14"
                            points="744.8,115.9 744.3,116.1 744.3,116.5 744.8,116.3 							"
                          />
                          <polygon
                            class="st14"
                            points="744.8,116.9 744.8,116.5 744.3,116.7 744.3,117.1 							"
                          />
                          <polygon
                            class="st14"
                            points="744.8,118.7 744.8,118.4 744.3,118.6 744.3,118.9 							"
                          />
                          <polygon
                            class="st14"
                            points="744.3,115.8 744.8,115.6 744.8,115.3 744.3,115.5 							"
                          />
                          <polygon
                            class="st14"
                            points="744.8,119.4 744.8,119 744.3,119.2 744.3,119.6 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="738.7,130.9 738.7,117.5 737.6,118 737.6,131.4 738.7,131.7 						"
                        />
                        <polygon
                          class="st1"
                          points="737.6,131.4 737.6,131.4 733.5,133.3 733.5,134.1 738.7,131.7 738.7,131.7 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M733.9,120.3l3.1-1.4v0.4l-3.1,1.4V120.3z M733.9,121.3l3.1-1.4v-0.4l-3.1,1.4V121.3z M733.9,121.9
            l3.1-1.4v-0.4l-3.1,1.4V121.9z M733.9,122.5l3.1-1.4v-0.4l-3.1,1.4V122.5z M733.9,123.1l3.1-1.4v-0.4l-3.1,1.4V123.1z
             M733.9,123.7l3.1-1.4v-0.4l-3.1,1.4V123.7z M733.9,124.4l3.1-1.4v-0.4l-3.1,1.4V124.4z"
                        />
                        <polygon
                          class="st1"
                          points="733.9,126.2 737.1,124.8 737.1,124.4 733.9,125.9 						"
                        />
                        <polygon
                          class="st1"
                          points="733.9,126.9 737.1,125.4 737.1,125 733.9,126.5 						"
                        />
                        <polygon
                          class="st1"
                          points="733.9,127.5 737.1,126 737.1,125.7 733.9,127.1 						"
                        />
                        <polygon
                          class="st1"
                          points="733.9,128.1 737.1,126.6 737.1,126.3 733.9,127.7 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="737.1,121 737.1,120.7 736.6,120.9 736.6,121.3 							"
                          />
                          <polygon
                            class="st14"
                            points="737.1,121.7 737.1,121.3 736.6,121.5 736.6,121.9 							"
                          />
                          <polygon
                            class="st14"
                            points="737.1,119.4 736.6,119.6 736.6,120 737.1,119.8 							"
                          />
                          <polygon
                            class="st14"
                            points="737.1,120.4 737.1,120.1 736.6,120.3 736.6,120.6 							"
                          />
                          <polygon
                            class="st14"
                            points="737.1,122.3 737.1,121.9 736.6,122.1 736.6,122.5 							"
                          />
                          <polygon
                            class="st14"
                            points="736.6,119.4 737.1,119.2 737.1,118.8 736.6,119 							"
                          />
                          <polygon
                            class="st14"
                            points="737.1,122.9 737.1,122.5 736.6,122.7 736.6,123.1 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st1"
                        points="672,164.8 659.2,158.9 659.2,140 672,145.9 					"
                      />
                      <polygon
                        class="st15"
                        points="700.2,121 659.2,140 672,145.9 713,126.9 					"
                      />
                      <polygon
                        class="st10"
                        points="713,126.9 713,145.9 672,164.8 672,145.9 					"
                      />
                      <polygon
                        class="st183"
                        points="710.5,130.5 705.3,132.9 705.3,147.1 710.5,144.7 					"
                      />
                      <polygon
                        class="st183"
                        points="702.8,134.1 697.7,136.4 697.7,150.6 702.8,148.3 					"
                      />
                      <polygon
                        class="st183"
                        points="695.1,137.6 690,140 690,154.2 695.1,151.8 					"
                      />
                      <polygon
                        class="st183"
                        points="687.4,141.2 682.3,143.5 682.3,157.7 687.4,155.4 					"
                      />
                      <polygon
                        class="st183"
                        points="679.7,144.7 674.6,147.1 674.6,161.3 679.7,158.9 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="710.5,143.9 710.5,130.5 709.4,131 709.4,144.4 710.5,144.7 						"
                        />
                        <polygon
                          class="st1"
                          points="709.4,144.4 709.4,144.4 705.3,146.3 705.3,147.1 710.5,144.7 710.5,144.7 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M705.7,133.2l3.1-1.4v0.4l-3.1,1.4V133.2z M705.7,134.2l3.1-1.4v-0.4l-3.1,1.4V134.2z M705.7,134.8
            l3.1-1.4V133l-3.1,1.4V134.8z M705.7,135.5l3.1-1.4v-0.4l-3.1,1.4V135.5z M705.7,136.1l3.1-1.4v-0.4l-3.1,1.4V136.1z
             M705.7,136.7l3.1-1.4v-0.4l-3.1,1.4V136.7z M705.7,137.3l3.1-1.4v-0.4l-3.1,1.4V137.3z"
                        />
                        <polygon
                          class="st1"
                          points="705.7,139.2 708.9,137.7 708.9,137.4 705.7,138.8 						"
                        />
                        <polygon
                          class="st1"
                          points="705.7,139.8 708.9,138.4 708.9,138 705.7,139.4 						"
                        />
                        <polygon
                          class="st1"
                          points="705.7,140.4 708.9,139 708.9,138.6 705.7,140.1 						"
                        />
                        <polygon
                          class="st1"
                          points="705.7,141.1 708.9,139.6 708.9,139.2 705.7,140.7 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="708.9,134 708.9,133.6 708.4,133.8 708.4,134.2 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,134.6 708.9,134.3 708.4,134.5 708.4,134.8 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,132.4 708.4,132.6 708.4,133 708.9,132.8 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,133.4 708.9,133 708.4,133.2 708.4,133.6 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,135.3 708.9,134.9 708.4,135.1 708.4,135.5 							"
                          />
                          <polygon
                            class="st14"
                            points="708.4,132.4 708.9,132.1 708.9,131.8 708.4,132 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,135.9 708.9,135.5 708.4,135.7 708.4,136.1 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="702.8,147.5 702.8,134.1 701.7,134.5 701.7,147.9 702.8,148.3 						"
                        />
                        <polygon
                          class="st1"
                          points="701.7,147.9 701.7,147.9 697.7,149.8 697.7,150.6 702.8,148.3 702.8,148.3 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M698.1,136.8l3.1-1.4v0.4l-3.1,1.4V136.8z M698.1,137.8l3.1-1.4v-0.4l-3.1,1.4V137.8z M698.1,138.4
            l3.1-1.4v-0.4l-3.1,1.4V138.4z M698.1,139l3.1-1.4v-0.4l-3.1,1.4V139z M698.1,139.6l3.1-1.4v-0.4l-3.1,1.4V139.6z
             M698.1,140.3l3.1-1.4v-0.4l-3.1,1.4V140.3z M698.1,140.9l3.1-1.4v-0.4l-3.1,1.4V140.9z"
                        />
                        <polygon
                          class="st1"
                          points="698.1,142.7 701.2,141.3 701.2,140.9 698.1,142.4 						"
                        />
                        <polygon
                          class="st1"
                          points="698.1,143.4 701.2,141.9 701.2,141.5 698.1,143 						"
                        />
                        <polygon
                          class="st1"
                          points="698.1,144 701.2,142.5 701.2,142.2 698.1,143.6 						"
                        />
                        <polygon
                          class="st1"
                          points="698.1,144.6 701.2,143.2 701.2,142.8 698.1,144.2 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="701.2,137.6 701.2,137.2 700.7,137.4 700.7,137.8 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,138.2 701.2,137.8 700.7,138 700.7,138.4 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,135.9 700.7,136.2 700.7,136.5 701.2,136.3 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,136.9 701.2,136.6 700.7,136.8 700.7,137.1 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,138.8 701.2,138.4 700.7,138.6 700.7,139 							"
                          />
                          <polygon
                            class="st14"
                            points="700.7,135.9 701.2,135.7 701.2,135.3 700.7,135.5 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,139.4 701.2,139.1 700.7,139.3 700.7,139.6 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="695.1,151 695.1,137.6 694,138.1 694,151.5 695.1,151.8 						"
                        />
                        <polygon
                          class="st1"
                          points="694,151.5 694,151.5 690,153.4 690,154.2 695.1,151.8 695.1,151.8 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M690.4,140.3l3.1-1.4v0.4l-3.1,1.4V140.3z M690.4,141.3l3.1-1.4v-0.4l-3.1,1.4V141.3z M690.4,141.9
            l3.1-1.4v-0.4l-3.1,1.4V141.9z M690.4,142.6l3.1-1.4v-0.4l-3.1,1.4V142.6z M690.4,143.2l3.1-1.4v-0.4l-3.1,1.4V143.2z
             M690.4,143.8l3.1-1.4V142l-3.1,1.4V143.8z M690.4,144.4l3.1-1.4v-0.4l-3.1,1.4V144.4z"
                        />
                        <polygon
                          class="st1"
                          points="690.4,146.3 693.5,144.8 693.5,144.5 690.4,145.9 						"
                        />
                        <polygon
                          class="st1"
                          points="690.4,146.9 693.5,145.5 693.5,145.1 690.4,146.5 						"
                        />
                        <polygon
                          class="st1"
                          points="690.4,147.5 693.5,146.1 693.5,145.7 690.4,147.2 						"
                        />
                        <polygon
                          class="st1"
                          points="690.4,148.2 693.5,146.7 693.5,146.3 690.4,147.8 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="693.5,141.1 693.5,140.7 693.1,140.9 693.1,141.3 							"
                          />
                          <polygon
                            class="st14"
                            points="693.5,141.7 693.5,141.4 693.1,141.6 693.1,141.9 							"
                          />
                          <polygon
                            class="st14"
                            points="693.5,139.5 693.1,139.7 693.1,140.1 693.5,139.9 							"
                          />
                          <polygon
                            class="st14"
                            points="693.5,140.5 693.5,140.1 693.1,140.3 693.1,140.7 							"
                          />
                          <polygon
                            class="st14"
                            points="693.5,142.4 693.5,142 693.1,142.2 693.1,142.6 							"
                          />
                          <polygon
                            class="st14"
                            points="693.1,139.5 693.5,139.2 693.5,138.9 693.1,139.1 							"
                          />
                          <polygon
                            class="st14"
                            points="693.5,143 693.5,142.6 693.1,142.8 693.1,143.2 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="687.4,154.6 687.4,141.2 686.4,141.6 686.4,155 687.4,155.4 						"
                        />
                        <polygon
                          class="st1"
                          points="686.4,155 686.4,155 682.3,156.9 682.3,157.7 687.4,155.4 687.4,155.4 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M682.7,143.9l3.1-1.4v0.4l-3.1,1.4V143.9z M682.7,144.9l3.1-1.4V143l-3.1,1.4V144.9z M682.7,145.5
            l3.1-1.4v-0.4l-3.1,1.4V145.5z M682.7,146.1l3.1-1.4v-0.4l-3.1,1.4V146.1z M682.7,146.7l3.1-1.4v-0.4l-3.1,1.4V146.7z
             M682.7,147.4l3.1-1.4v-0.4l-3.1,1.4V147.4z M682.7,148l3.1-1.4v-0.4l-3.1,1.4V148z"
                        />
                        <polygon
                          class="st1"
                          points="682.7,149.8 685.8,148.4 685.8,148 682.7,149.5 						"
                        />
                        <polygon
                          class="st1"
                          points="682.7,150.5 685.8,149 685.8,148.6 682.7,150.1 						"
                        />
                        <polygon
                          class="st1"
                          points="682.7,151.1 685.8,149.6 685.8,149.3 682.7,150.7 						"
                        />
                        <polygon
                          class="st1"
                          points="682.7,151.7 685.8,150.3 685.8,149.9 682.7,151.3 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="685.8,144.7 685.8,144.3 685.4,144.5 685.4,144.9 							"
                          />
                          <polygon
                            class="st14"
                            points="685.8,145.3 685.8,144.9 685.4,145.1 685.4,145.5 							"
                          />
                          <polygon
                            class="st14"
                            points="685.8,143 685.4,143.3 685.4,143.6 685.8,143.4 							"
                          />
                          <polygon
                            class="st14"
                            points="685.8,144 685.8,143.7 685.4,143.9 685.4,144.3 							"
                          />
                          <polygon
                            class="st14"
                            points="685.8,145.9 685.8,145.5 685.4,145.7 685.4,146.1 							"
                          />
                          <polygon
                            class="st14"
                            points="685.4,143 685.8,142.8 685.8,142.4 685.4,142.6 							"
                          />
                          <polygon
                            class="st14"
                            points="685.8,146.5 685.8,146.2 685.4,146.4 685.4,146.7 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="679.7,158.1 679.7,144.7 678.7,145.2 678.7,158.6 679.7,158.9 						"
                        />
                        <polygon
                          class="st1"
                          points="678.7,158.6 678.7,158.6 674.6,160.5 674.6,161.3 679.7,158.9 679.7,158.9 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M675,147.4l3.1-1.4v0.4l-3.1,1.4V147.4z M675,148.4l3.1-1.4v-0.4L675,148V148.4z M675,149l3.1-1.4v-0.4
            l-3.1,1.4V149z M675,149.7l3.1-1.4v-0.4l-3.1,1.4V149.7z M675,150.3l3.1-1.4v-0.4l-3.1,1.4V150.3z M675,150.9l3.1-1.4v-0.4
            l-3.1,1.4V150.9z M675,151.5l3.1-1.4v-0.4l-3.1,1.4V151.5z"
                        />
                        <polygon
                          class="st1"
                          points="675,153.4 678.1,152 678.1,151.6 675,153 						"
                        />
                        <polygon
                          class="st1"
                          points="675,154 678.1,152.6 678.1,152.2 675,153.6 						"
                        />
                        <polygon
                          class="st1"
                          points="675,154.6 678.1,153.2 678.1,152.8 675,154.3 						"
                        />
                        <polygon
                          class="st1"
                          points="675,155.3 678.1,153.8 678.1,153.4 675,154.9 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="678.1,148.2 678.1,147.8 677.7,148.1 677.7,148.4 							"
                          />
                          <polygon
                            class="st14"
                            points="678.1,148.8 678.1,148.5 677.7,148.7 677.7,149 							"
                          />
                          <polygon
                            class="st14"
                            points="678.1,146.6 677.7,146.8 677.7,147.2 678.1,147 							"
                          />
                          <polygon
                            class="st14"
                            points="678.1,147.6 678.1,147.2 677.7,147.4 677.7,147.8 							"
                          />
                          <polygon
                            class="st14"
                            points="678.1,149.5 678.1,149.1 677.7,149.3 677.7,149.7 							"
                          />
                          <polygon
                            class="st14"
                            points="677.7,146.6 678.1,146.4 678.1,146 677.7,146.2 							"
                          />
                          <polygon
                            class="st14"
                            points="678.1,150.1 678.1,149.7 677.7,149.9 677.7,150.3 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st1"
                        points="754.1,148.2 741.2,142.2 741.2,123.3 754.1,129.2 					"
                      />
                      <polygon
                        class="st15"
                        points="782.3,104.4 741.2,123.3 754.1,129.2 795.1,110.3 					"
                      />
                      <polygon
                        class="st10"
                        points="795.1,110.3 795.1,129.2 754.1,148.2 754.1,129.2 					"
                      />
                      <polygon
                        class="st183"
                        points="792.5,113.8 787.4,116.2 787.4,130.4 792.5,128 					"
                      />
                      <polygon
                        class="st183"
                        points="784.8,117.4 779.7,119.8 779.7,134 784.8,131.6 					"
                      />
                      <polygon
                        class="st183"
                        points="777.1,120.9 772,123.3 772,137.5 777.1,135.1 					"
                      />
                      <polygon
                        class="st183"
                        points="769.4,124.5 764.3,126.9 764.3,141.1 769.4,138.7 					"
                      />
                      <polygon
                        class="st183"
                        points="761.8,128 756.6,130.4 756.6,144.6 761.8,142.2 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="792.5,127.2 792.5,113.8 791.5,114.3 791.5,127.7 792.5,128 						"
                        />
                        <polygon
                          class="st1"
                          points="791.5,127.7 791.5,127.7 787.4,129.6 787.4,130.4 792.5,128 792.5,128 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M787.8,116.6l3.1-1.4v0.4l-3.1,1.4V116.6z M787.8,117.5l3.1-1.4v-0.4l-3.1,1.4V117.5z M787.8,118.2
            l3.1-1.4v-0.4l-3.1,1.4V118.2z M787.8,118.8l3.1-1.4V117l-3.1,1.4V118.8z M787.8,119.4l3.1-1.4v-0.4l-3.1,1.4V119.4z
             M787.8,120l3.1-1.4v-0.4l-3.1,1.4V120z M787.8,120.7l3.1-1.4v-0.4l-3.1,1.4V120.7z"
                        />
                        <polygon
                          class="st1"
                          points="787.8,122.5 790.9,121.1 790.9,120.7 787.8,122.2 						"
                        />
                        <polygon
                          class="st1"
                          points="787.8,123.1 790.9,121.7 790.9,121.3 787.8,122.8 						"
                        />
                        <polygon
                          class="st1"
                          points="787.8,123.8 790.9,122.3 790.9,122 787.8,123.4 						"
                        />
                        <polygon
                          class="st1"
                          points="787.8,124.4 790.9,122.9 790.9,122.6 787.8,124 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="790.9,117.3 790.9,117 790.5,117.2 790.5,117.6 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,118 790.9,117.6 790.5,117.8 790.5,118.2 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,115.7 790.5,115.9 790.5,116.3 790.9,116.1 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,116.7 790.9,116.4 790.5,116.6 790.5,116.9 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,118.6 790.9,118.2 790.5,118.4 790.5,118.8 							"
                          />
                          <polygon
                            class="st14"
                            points="790.5,115.7 790.9,115.5 790.9,115.1 790.5,115.3 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,119.2 790.9,118.8 790.5,119 790.5,119.4 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="784.8,130.8 784.8,117.4 783.8,117.9 783.8,131.3 784.8,131.6 						"
                        />
                        <polygon
                          class="st1"
                          points="783.8,131.3 783.8,131.3 779.7,133.2 779.7,134 784.8,131.6 784.8,131.6 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M780.1,120.1l3.1-1.4v0.4l-3.1,1.4V120.1z M780.1,121.1l3.1-1.4v-0.4l-3.1,1.4V121.1z M780.1,121.7
            l3.1-1.4v-0.4l-3.1,1.4V121.7z M780.1,122.3l3.1-1.4v-0.4l-3.1,1.4V122.3z M780.1,123l3.1-1.4v-0.4l-3.1,1.4V123z
             M780.1,123.6l3.1-1.4v-0.4l-3.1,1.4V123.6z M780.1,124.2l3.1-1.4v-0.4l-3.1,1.4V124.2z"
                        />
                        <polygon
                          class="st1"
                          points="780.1,126.1 783.2,124.6 783.2,124.3 780.1,125.7 						"
                        />
                        <polygon
                          class="st1"
                          points="780.1,126.7 783.2,125.3 783.2,124.9 780.1,126.3 						"
                        />
                        <polygon
                          class="st1"
                          points="780.1,127.3 783.2,125.9 783.2,125.5 780.1,126.9 						"
                        />
                        <polygon
                          class="st1"
                          points="780.1,127.9 783.2,126.5 783.2,126.1 780.1,127.6 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="783.2,120.9 783.2,120.5 782.8,120.7 782.8,121.1 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,121.5 783.2,121.1 782.8,121.4 782.8,121.7 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,119.3 782.8,119.5 782.8,119.9 783.2,119.7 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,120.3 783.2,119.9 782.8,120.1 782.8,120.5 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,122.1 783.2,121.8 782.8,122 782.8,122.4 							"
                          />
                          <polygon
                            class="st14"
                            points="782.8,119.2 783.2,119 783.2,118.7 782.8,118.9 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,122.8 783.2,122.4 782.8,122.6 782.8,123 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="777.1,134.3 777.1,120.9 776.1,121.4 776.1,134.8 777.1,135.1 						"
                        />
                        <polygon
                          class="st1"
                          points="776.1,134.8 776.1,134.8 772,136.7 772,137.5 777.1,135.1 777.1,135.1 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M772.4,123.7l3.1-1.4v0.4l-3.1,1.4V123.7z M772.4,124.7l3.1-1.4v-0.4l-3.1,1.4V124.7z M772.4,125.3
            l3.1-1.4v-0.4l-3.1,1.4V125.3z M772.4,125.9l3.1-1.4v-0.4l-3.1,1.4V125.9z M772.4,126.5l3.1-1.4v-0.4l-3.1,1.4V126.5z
             M772.4,127.1l3.1-1.4v-0.4l-3.1,1.4V127.1z M772.4,127.8l3.1-1.4v-0.4l-3.1,1.4V127.8z"
                        />
                        <polygon
                          class="st1"
                          points="772.4,129.6 775.5,128.2 775.5,127.8 772.4,129.3 						"
                        />
                        <polygon
                          class="st1"
                          points="772.4,130.3 775.5,128.8 775.5,128.4 772.4,129.9 						"
                        />
                        <polygon
                          class="st1"
                          points="772.4,130.9 775.5,129.4 775.5,129.1 772.4,130.5 						"
                        />
                        <polygon
                          class="st1"
                          points="772.4,131.5 775.5,130.1 775.5,129.7 772.4,131.1 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="775.5,124.5 775.5,124.1 775.1,124.3 775.1,124.7 							"
                          />
                          <polygon
                            class="st14"
                            points="775.5,125.1 775.5,124.7 775.1,124.9 775.1,125.3 							"
                          />
                          <polygon
                            class="st14"
                            points="775.5,122.8 775.1,123 775.1,123.4 775.5,123.2 							"
                          />
                          <polygon
                            class="st14"
                            points="775.5,123.8 775.5,123.5 775.1,123.7 775.1,124 							"
                          />
                          <polygon
                            class="st14"
                            points="775.5,125.7 775.5,125.3 775.1,125.5 775.1,125.9 							"
                          />
                          <polygon
                            class="st14"
                            points="775.1,122.8 775.5,122.6 775.5,122.2 775.1,122.4 							"
                          />
                          <polygon
                            class="st14"
                            points="775.5,126.3 775.5,125.9 775.1,126.2 775.1,126.5 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="769.4,137.9 769.4,124.5 768.4,125 768.4,138.4 769.4,138.7 						"
                        />
                        <polygon
                          class="st1"
                          points="768.4,138.4 768.4,138.4 764.3,140.3 764.3,141.1 769.4,138.7 769.4,138.7 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M764.7,127.2l3.1-1.4v0.4l-3.1,1.4V127.2z M764.7,128.2l3.1-1.4v-0.4l-3.1,1.4V128.2z M764.7,128.8
            l3.1-1.4V127l-3.1,1.4V128.8z M764.7,129.4l3.1-1.4v-0.4l-3.1,1.4V129.4z M764.7,130.1l3.1-1.4v-0.4l-3.1,1.4V130.1z
             M764.7,130.7l3.1-1.4v-0.4l-3.1,1.4V130.7z M764.7,131.3l3.1-1.4v-0.4l-3.1,1.4V131.3z"
                        />
                        <polygon
                          class="st1"
                          points="764.7,133.2 767.9,131.7 767.9,131.4 764.7,132.8 						"
                        />
                        <polygon
                          class="st1"
                          points="764.7,133.8 767.9,132.4 767.9,132 764.7,133.4 						"
                        />
                        <polygon
                          class="st1"
                          points="764.7,134.4 767.9,133 767.9,132.6 764.7,134.1 						"
                        />
                        <polygon
                          class="st1"
                          points="764.7,135 767.9,133.6 767.9,133.2 764.7,134.7 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="767.9,128 767.9,127.6 767.4,127.8 767.4,128.2 							"
                          />
                          <polygon
                            class="st14"
                            points="767.9,128.6 767.9,128.2 767.4,128.5 767.4,128.8 							"
                          />
                          <polygon
                            class="st14"
                            points="767.9,126.4 767.4,126.6 767.4,127 767.9,126.8 							"
                          />
                          <polygon
                            class="st14"
                            points="767.9,127.4 767.9,127 767.4,127.2 767.4,127.6 							"
                          />
                          <polygon
                            class="st14"
                            points="767.9,129.2 767.9,128.9 767.4,129.1 767.4,129.5 							"
                          />
                          <polygon
                            class="st14"
                            points="767.4,126.3 767.9,126.1 767.9,125.8 767.4,126 							"
                          />
                          <polygon
                            class="st14"
                            points="767.9,129.9 767.9,129.5 767.4,129.7 767.4,130.1 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="761.8,141.4 761.8,128 760.7,128.5 760.7,141.9 761.8,142.2 						"
                        />
                        <polygon
                          class="st1"
                          points="760.7,141.9 760.7,141.9 756.6,143.8 756.6,144.6 761.8,142.2 761.8,142.2 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M757,130.8l3.1-1.4v0.4l-3.1,1.4V130.8z M757,131.8l3.1-1.4v-0.4l-3.1,1.4V131.8z M757,132.4l3.1-1.4
            v-0.4L757,132V132.4z M757,133l3.1-1.4v-0.4l-3.1,1.4V133z M757,133.6l3.1-1.4v-0.4l-3.1,1.4V133.6z M757,134.2l3.1-1.4v-0.4
            l-3.1,1.4V134.2z M757,134.9l3.1-1.4V133l-3.1,1.4V134.9z"
                        />
                        <polygon
                          class="st1"
                          points="757,136.7 760.2,135.3 760.2,134.9 757,136.4 						"
                        />
                        <polygon
                          class="st1"
                          points="757,137.4 760.2,135.9 760.2,135.5 757,137 						"
                        />
                        <polygon
                          class="st1"
                          points="757,138 760.2,136.5 760.2,136.2 757,137.6 						"
                        />
                        <polygon
                          class="st1"
                          points="757,138.6 760.2,137.2 760.2,136.8 757,138.2 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="760.2,131.6 760.2,131.2 759.7,131.4 759.7,131.8 							"
                          />
                          <polygon
                            class="st14"
                            points="760.2,132.2 760.2,131.8 759.7,132 759.7,132.4 							"
                          />
                          <polygon
                            class="st14"
                            points="760.2,129.9 759.7,130.1 759.7,130.5 760.2,130.3 							"
                          />
                          <polygon
                            class="st14"
                            points="760.2,130.9 760.2,130.6 759.7,130.8 759.7,131.1 							"
                          />
                          <polygon
                            class="st14"
                            points="760.2,132.8 760.2,132.4 759.7,132.6 759.7,133 							"
                          />
                          <polygon
                            class="st14"
                            points="759.7,129.9 760.2,129.7 760.2,129.3 759.7,129.5 							"
                          />
                          <polygon
                            class="st14"
                            points="760.2,133.4 760.2,133 759.7,133.3 759.7,133.6 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st1"
                        points="695.1,175.3 682.3,169.4 682.3,150.5 695.1,156.4 					"
                      />
                      <polygon
                        class="st15"
                        points="723.3,131.5 682.3,150.5 695.1,156.4 736.1,137.5 					"
                      />
                      <polygon
                        class="st10"
                        points="736.1,137.5 736.1,156.4 695.1,175.3 695.1,156.4 					"
                      />
                      <polygon
                        class="st183"
                        points="733.6,141 728.4,143.4 728.4,157.6 733.6,155.2 					"
                      />
                      <polygon
                        class="st183"
                        points="725.9,144.6 720.7,146.9 720.7,161.1 725.9,158.8 					"
                      />
                      <polygon
                        class="st183"
                        points="718.2,148.1 713.1,150.5 713.1,164.7 718.2,162.3 					"
                      />
                      <polygon
                        class="st183"
                        points="710.5,151.7 705.4,154 705.4,168.2 710.5,165.9 					"
                      />
                      <polygon
                        class="st183"
                        points="702.8,155.2 697.7,157.6 697.7,171.8 702.8,169.4 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="733.6,154.4 733.6,141 732.5,141.5 732.5,154.9 733.6,155.2 						"
                        />
                        <polygon
                          class="st1"
                          points="732.5,154.9 732.5,154.9 728.4,156.8 728.4,157.6 733.6,155.2 733.6,155.2 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M728.8,143.7l3.1-1.4v0.4l-3.1,1.4V143.7z M728.8,144.7l3.1-1.4v-0.4l-3.1,1.4V144.7z M728.8,145.3
            l3.1-1.4v-0.4l-3.1,1.4V145.3z M728.8,146l3.1-1.4v-0.4l-3.1,1.4V146z M728.8,146.6l3.1-1.4v-0.4l-3.1,1.4V146.6z
             M728.8,147.2l3.1-1.4v-0.4l-3.1,1.4V147.2z M728.8,147.8l3.1-1.4V146l-3.1,1.4V147.8z"
                        />
                        <polygon
                          class="st1"
                          points="728.8,149.7 732,148.2 732,147.9 728.8,149.3 						"
                        />
                        <polygon
                          class="st1"
                          points="728.8,150.3 732,148.9 732,148.5 728.8,149.9 						"
                        />
                        <polygon
                          class="st1"
                          points="728.8,150.9 732,149.5 732,149.1 728.8,150.6 						"
                        />
                        <polygon
                          class="st1"
                          points="728.8,151.6 732,150.1 732,149.7 728.8,151.2 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="732,144.5 732,144.1 731.5,144.3 731.5,144.7 							"
                          />
                          <polygon
                            class="st14"
                            points="732,145.1 732,144.8 731.5,145 731.5,145.3 							"
                          />
                          <polygon
                            class="st14"
                            points="732,142.9 731.5,143.1 731.5,143.5 732,143.3 							"
                          />
                          <polygon
                            class="st14"
                            points="732,143.9 732,143.5 731.5,143.7 731.5,144.1 							"
                          />
                          <polygon
                            class="st14"
                            points="732,145.8 732,145.4 731.5,145.6 731.5,146 							"
                          />
                          <polygon
                            class="st14"
                            points="731.5,142.9 732,142.6 732,142.3 731.5,142.5 							"
                          />
                          <polygon
                            class="st14"
                            points="732,146.4 732,146 731.5,146.2 731.5,146.6 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="725.9,158 725.9,144.6 724.8,145 724.8,158.4 725.9,158.8 						"
                        />
                        <polygon
                          class="st1"
                          points="724.8,158.4 724.8,158.4 720.7,160.3 720.7,161.1 725.9,158.8 725.9,158.8 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M721.2,147.3l3.1-1.4v0.4l-3.1,1.4V147.3z M721.2,148.3l3.1-1.4v-0.4l-3.1,1.4V148.3z M721.2,148.9
            l3.1-1.4v-0.4l-3.1,1.4V148.9z M721.2,149.5l3.1-1.4v-0.4l-3.1,1.4V149.5z M721.2,150.1l3.1-1.4v-0.4l-3.1,1.4V150.1z
             M721.2,150.8l3.1-1.4v-0.4l-3.1,1.4V150.8z M721.2,151.4l3.1-1.4v-0.4l-3.1,1.4V151.4z"
                        />
                        <polygon
                          class="st1"
                          points="721.2,153.2 724.3,151.8 724.3,151.4 721.2,152.9 						"
                        />
                        <polygon
                          class="st1"
                          points="721.2,153.9 724.3,152.4 724.3,152 721.2,153.5 						"
                        />
                        <polygon
                          class="st1"
                          points="721.2,154.5 724.3,153 724.3,152.7 721.2,154.1 						"
                        />
                        <polygon
                          class="st1"
                          points="721.2,155.1 724.3,153.7 724.3,153.3 721.2,154.7 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="724.3,148.1 724.3,147.7 723.8,147.9 723.8,148.3 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,148.7 724.3,148.3 723.8,148.5 723.8,148.9 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,146.4 723.8,146.7 723.8,147 724.3,146.8 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,147.4 724.3,147.1 723.8,147.3 723.8,147.7 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,149.3 724.3,148.9 723.8,149.1 723.8,149.5 							"
                          />
                          <polygon
                            class="st14"
                            points="723.8,146.4 724.3,146.2 724.3,145.8 723.8,146 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,149.9 724.3,149.6 723.8,149.8 723.8,150.1 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="718.2,161.5 718.2,148.1 717.1,148.6 717.1,162 718.2,162.3 						"
                        />
                        <polygon
                          class="st1"
                          points="717.1,162 717.1,162 713.1,163.9 713.1,164.7 718.2,162.3 718.2,162.3 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M713.5,150.8l3.1-1.4v0.4l-3.1,1.4V150.8z M713.5,151.8l3.1-1.4V150l-3.1,1.4V151.8z M713.5,152.4
            l3.1-1.4v-0.4l-3.1,1.4V152.4z M713.5,153.1l3.1-1.4v-0.4l-3.1,1.4V153.1z M713.5,153.7l3.1-1.4v-0.4l-3.1,1.4V153.7z
             M713.5,154.3l3.1-1.4v-0.4l-3.1,1.4V154.3z M713.5,154.9l3.1-1.4v-0.4l-3.1,1.4V154.9z"
                        />
                        <polygon
                          class="st1"
                          points="713.5,156.8 716.6,155.4 716.6,155 713.5,156.4 						"
                        />
                        <polygon
                          class="st1"
                          points="713.5,157.4 716.6,156 716.6,155.6 713.5,157 						"
                        />
                        <polygon
                          class="st1"
                          points="713.5,158 716.6,156.6 716.6,156.2 713.5,157.7 						"
                        />
                        <polygon
                          class="st1"
                          points="713.5,158.7 716.6,157.2 716.6,156.8 713.5,158.3 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="716.6,151.6 716.6,151.2 716.1,151.5 716.1,151.8 							"
                          />
                          <polygon
                            class="st14"
                            points="716.6,152.2 716.6,151.9 716.1,152.1 716.1,152.4 							"
                          />
                          <polygon
                            class="st14"
                            points="716.6,150 716.1,150.2 716.1,150.6 716.6,150.4 							"
                          />
                          <polygon
                            class="st14"
                            points="716.6,151 716.6,150.6 716.1,150.8 716.1,151.2 							"
                          />
                          <polygon
                            class="st14"
                            points="716.6,152.9 716.6,152.5 716.1,152.7 716.1,153.1 							"
                          />
                          <polygon
                            class="st14"
                            points="716.1,150 716.6,149.8 716.6,149.4 716.1,149.6 							"
                          />
                          <polygon
                            class="st14"
                            points="716.6,153.5 716.6,153.1 716.1,153.3 716.1,153.7 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="710.5,165.1 710.5,151.7 709.4,152.1 709.4,165.5 710.5,165.9 						"
                        />
                        <polygon
                          class="st1"
                          points="709.4,165.5 709.4,165.5 705.4,167.4 705.4,168.2 710.5,165.9 710.5,165.9 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M705.8,154.4l3.1-1.4v0.4l-3.1,1.4V154.4z M705.8,155.4l3.1-1.4v-0.4l-3.1,1.4V155.4z M705.8,156l3.1-1.4
            v-0.4l-3.1,1.4V156z M705.8,156.6l3.1-1.4v-0.4l-3.1,1.4V156.6z M705.8,157.2l3.1-1.4v-0.4l-3.1,1.4V157.2z M705.8,157.9
            l3.1-1.4V156l-3.1,1.4V157.9z M705.8,158.5l3.1-1.4v-0.4l-3.1,1.4V158.5z"
                        />
                        <polygon
                          class="st1"
                          points="705.8,160.4 708.9,158.9 708.9,158.5 705.8,160 						"
                        />
                        <polygon
                          class="st1"
                          points="705.8,161 708.9,159.5 708.9,159.2 705.8,160.6 						"
                        />
                        <polygon
                          class="st1"
                          points="705.8,161.6 708.9,160.1 708.9,159.8 705.8,161.2 						"
                        />
                        <polygon
                          class="st1"
                          points="705.8,162.2 708.9,160.8 708.9,160.4 705.8,161.8 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="708.9,155.2 708.9,154.8 708.5,155 708.5,155.4 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,155.8 708.9,155.4 708.5,155.6 708.5,156 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,153.6 708.5,153.8 708.5,154.1 708.9,153.9 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,154.5 708.9,154.2 708.5,154.4 708.5,154.8 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,156.4 708.9,156 708.5,156.2 708.5,156.6 							"
                          />
                          <polygon
                            class="st14"
                            points="708.5,153.5 708.9,153.3 708.9,152.9 708.5,153.1 							"
                          />
                          <polygon
                            class="st14"
                            points="708.9,157 708.9,156.7 708.5,156.9 708.5,157.2 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="702.8,168.6 702.8,155.2 701.8,155.7 701.8,169.1 702.8,169.4 						"
                        />
                        <polygon
                          class="st1"
                          points="701.8,169.1 701.8,169.1 697.7,171 697.7,171.8 702.8,169.4 702.8,169.4 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M698.1,157.9l3.1-1.4v0.4l-3.1,1.4V157.9z M698.1,158.9l3.1-1.4v-0.4l-3.1,1.4V158.9z M698.1,159.5
            l3.1-1.4v-0.4l-3.1,1.4V159.5z M698.1,160.2l3.1-1.4v-0.4l-3.1,1.4V160.2z M698.1,160.8l3.1-1.4V159l-3.1,1.4V160.8z
             M698.1,161.4l3.1-1.4v-0.4l-3.1,1.4V161.4z M698.1,162l3.1-1.4v-0.4l-3.1,1.4V162z"
                        />
                        <polygon
                          class="st1"
                          points="698.1,163.9 701.2,162.5 701.2,162.1 698.1,163.5 						"
                        />
                        <polygon
                          class="st1"
                          points="698.1,164.5 701.2,163.1 701.2,162.7 698.1,164.2 						"
                        />
                        <polygon
                          class="st1"
                          points="698.1,165.1 701.2,163.7 701.2,163.3 698.1,164.8 						"
                        />
                        <polygon
                          class="st1"
                          points="698.1,165.8 701.2,164.3 701.2,163.9 698.1,165.4 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="701.2,158.7 701.2,158.3 700.8,158.6 700.8,158.9 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,159.3 701.2,159 700.8,159.2 700.8,159.6 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,157.1 700.8,157.3 700.8,157.7 701.2,157.5 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,158.1 701.2,157.7 700.8,157.9 700.8,158.3 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,160 701.2,159.6 700.8,159.8 700.8,160.2 							"
                          />
                          <polygon
                            class="st14"
                            points="700.8,157.1 701.2,156.9 701.2,156.5 700.8,156.7 							"
                          />
                          <polygon
                            class="st14"
                            points="701.2,160.6 701.2,160.2 700.8,160.4 700.8,160.8 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st1"
                        points="777.1,159 764.3,153 764.3,134.1 777.1,140 					"
                      />
                      <polygon
                        class="st15"
                        points="805.3,115.2 764.3,134.1 777.1,140 818.1,121.1 					"
                      />
                      <polygon
                        class="st10"
                        points="818.1,121.1 818.1,140 777.1,159 777.1,140 					"
                      />
                      <polygon
                        class="st183"
                        points="815.6,124.6 810.4,127 810.4,141.2 815.6,138.8 					"
                      />
                      <polygon
                        class="st183"
                        points="807.9,128.2 802.8,130.6 802.8,144.8 807.9,142.4 					"
                      />
                      <polygon
                        class="st183"
                        points="800.2,131.7 795.1,134.1 795.1,148.3 800.2,145.9 					"
                      />
                      <polygon
                        class="st183"
                        points="792.5,135.3 787.4,137.7 787.4,151.9 792.5,149.5 					"
                      />
                      <polygon
                        class="st183"
                        points="784.8,138.8 779.7,141.2 779.7,155.4 784.8,153 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="815.6,138 815.6,124.6 814.5,125.1 814.5,138.5 815.6,138.8 						"
                        />
                        <polygon
                          class="st1"
                          points="814.5,138.5 814.5,138.5 810.5,140.4 810.5,141.2 815.6,138.8 815.6,138.8 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M810.9,127.3l3.1-1.4v0.4l-3.1,1.4V127.3z M810.9,128.3l3.1-1.4v-0.4l-3.1,1.4V128.3z M810.9,129l3.1-1.4
            v-0.4l-3.1,1.4V129z M810.9,129.6l3.1-1.4v-0.4l-3.1,1.4V129.6z M810.9,130.2l3.1-1.4v-0.4l-3.1,1.4V130.2z M810.9,130.8
            l3.1-1.4V129l-3.1,1.4V130.8z M810.9,131.5l3.1-1.4v-0.4l-3.1,1.4V131.5z"
                        />
                        <polygon
                          class="st1"
                          points="810.9,133.3 814,131.9 814,131.5 810.9,132.9 						"
                        />
                        <polygon
                          class="st1"
                          points="810.9,133.9 814,132.5 814,132.1 810.9,133.6 						"
                        />
                        <polygon
                          class="st1"
                          points="810.9,134.6 814,133.1 814,132.7 810.9,134.2 						"
                        />
                        <polygon
                          class="st1"
                          points="810.9,135.2 814,133.7 814,133.4 810.9,134.8 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="814,128.1 814,127.8 813.5,128 813.5,128.4 							"
                          />
                          <polygon
                            class="st14"
                            points="814,128.8 814,128.4 813.5,128.6 813.5,129 							"
                          />
                          <polygon
                            class="st14"
                            points="814,126.5 813.5,126.7 813.5,127.1 814,126.9 							"
                          />
                          <polygon
                            class="st14"
                            points="814,127.5 814,127.1 813.5,127.4 813.5,127.7 							"
                          />
                          <polygon
                            class="st14"
                            points="814,129.4 814,129 813.5,129.2 813.5,129.6 							"
                          />
                          <polygon
                            class="st14"
                            points="813.5,126.5 814,126.3 814,125.9 813.5,126.1 							"
                          />
                          <polygon
                            class="st14"
                            points="814,130 814,129.6 813.5,129.8 813.5,130.2 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="807.9,141.6 807.9,128.2 806.8,128.7 806.8,142.1 807.9,142.4 						"
                        />
                        <polygon
                          class="st1"
                          points="806.8,142.1 806.8,142.1 802.8,144 802.8,144.8 807.9,142.4 807.9,142.4 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M803.2,130.9l3.1-1.4v0.4l-3.1,1.4V130.9z M803.2,131.9l3.1-1.4v-0.4l-3.1,1.4V131.9z M803.2,132.5
            l3.1-1.4v-0.4l-3.1,1.4V132.5z M803.2,133.1l3.1-1.4v-0.4l-3.1,1.4V133.1z M803.2,133.8l3.1-1.4v-0.4l-3.1,1.4V133.8z
             M803.2,134.4l3.1-1.4v-0.4l-3.1,1.4V134.4z M803.2,135l3.1-1.4v-0.4l-3.1,1.4V135z"
                        />
                        <polygon
                          class="st1"
                          points="803.2,136.9 806.3,135.4 806.3,135.1 803.2,136.5 						"
                        />
                        <polygon
                          class="st1"
                          points="803.2,137.5 806.3,136.1 806.3,135.7 803.2,137.1 						"
                        />
                        <polygon
                          class="st1"
                          points="803.2,138.1 806.3,136.7 806.3,136.3 803.2,137.7 						"
                        />
                        <polygon
                          class="st1"
                          points="803.2,138.7 806.3,137.3 806.3,136.9 803.2,138.4 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="806.3,131.7 806.3,131.3 805.9,131.5 805.9,131.9 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,132.3 806.3,131.9 805.9,132.2 805.9,132.5 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,130.1 805.9,130.3 805.9,130.7 806.3,130.5 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,131.1 806.3,130.7 805.9,130.9 805.9,131.3 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,132.9 806.3,132.6 805.9,132.8 805.9,133.1 							"
                          />
                          <polygon
                            class="st14"
                            points="805.9,130 806.3,129.8 806.3,129.5 805.9,129.7 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,133.6 806.3,133.2 805.9,133.4 805.9,133.8 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="800.2,145.1 800.2,131.7 799.2,132.2 799.2,145.6 800.2,145.9 						"
                        />
                        <polygon
                          class="st1"
                          points="799.2,145.6 799.2,145.6 795.1,147.5 795.1,148.3 800.2,145.9 800.2,145.9 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M795.5,134.5l3.1-1.4v0.4l-3.1,1.4V134.5z M795.5,135.4l3.1-1.4v-0.4l-3.1,1.4V135.4z M795.5,136.1
            l3.1-1.4v-0.4l-3.1,1.4V136.1z M795.5,136.7l3.1-1.4v-0.4l-3.1,1.4V136.7z M795.5,137.3l3.1-1.4v-0.4l-3.1,1.4V137.3z
             M795.5,137.9l3.1-1.4v-0.4l-3.1,1.4V137.9z M795.5,138.6l3.1-1.4v-0.4l-3.1,1.4V138.6z"
                        />
                        <polygon
                          class="st1"
                          points="795.5,140.4 798.6,139 798.6,138.6 795.5,140.1 						"
                        />
                        <polygon
                          class="st1"
                          points="795.5,141 798.6,139.6 798.6,139.2 795.5,140.7 						"
                        />
                        <polygon
                          class="st1"
                          points="795.5,141.7 798.6,140.2 798.6,139.9 795.5,141.3 						"
                        />
                        <polygon
                          class="st1"
                          points="795.5,142.3 798.6,140.8 798.6,140.5 795.5,141.9 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="798.6,135.2 798.6,134.9 798.2,135.1 798.2,135.5 							"
                          />
                          <polygon
                            class="st14"
                            points="798.6,135.9 798.6,135.5 798.2,135.7 798.2,136.1 							"
                          />
                          <polygon
                            class="st14"
                            points="798.6,133.6 798.2,133.8 798.2,134.2 798.6,134 							"
                          />
                          <polygon
                            class="st14"
                            points="798.6,134.6 798.6,134.2 798.2,134.5 798.2,134.8 							"
                          />
                          <polygon
                            class="st14"
                            points="798.6,136.5 798.6,136.1 798.2,136.3 798.2,136.7 							"
                          />
                          <polygon
                            class="st14"
                            points="798.2,133.6 798.6,133.4 798.6,133 798.2,133.2 							"
                          />
                          <polygon
                            class="st14"
                            points="798.6,137.1 798.6,136.7 798.2,136.9 798.2,137.3 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="792.5,148.7 792.5,135.3 791.5,135.8 791.5,149.2 792.5,149.5 						"
                        />
                        <polygon
                          class="st1"
                          points="791.5,149.2 791.5,149.2 787.4,151.1 787.4,151.9 792.5,149.5 792.5,149.5 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M787.8,138l3.1-1.4v0.4l-3.1,1.4V138z M787.8,139l3.1-1.4v-0.4l-3.1,1.4V139z M787.8,139.6l3.1-1.4v-0.4
            l-3.1,1.4V139.6z M787.8,140.2l3.1-1.4v-0.4l-3.1,1.4V140.2z M787.8,140.9l3.1-1.4V139l-3.1,1.4V140.9z M787.8,141.5l3.1-1.4
            v-0.4l-3.1,1.4V141.5z M787.8,142.1l3.1-1.4v-0.4l-3.1,1.4V142.1z"
                        />
                        <polygon
                          class="st1"
                          points="787.8,144 790.9,142.5 790.9,142.2 787.8,143.6 						"
                        />
                        <polygon
                          class="st1"
                          points="787.8,144.6 790.9,143.2 790.9,142.8 787.8,144.2 						"
                        />
                        <polygon
                          class="st1"
                          points="787.8,145.2 790.9,143.8 790.9,143.4 787.8,144.8 						"
                        />
                        <polygon
                          class="st1"
                          points="787.8,145.8 790.9,144.4 790.9,144 787.8,145.5 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="790.9,138.8 790.9,138.4 790.5,138.6 790.5,139 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,139.4 790.9,139 790.5,139.3 790.5,139.6 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,137.2 790.5,137.4 790.5,137.8 790.9,137.6 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,138.2 790.9,137.8 790.5,138 790.5,138.4 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,140 790.9,139.7 790.5,139.9 790.5,140.3 							"
                          />
                          <polygon
                            class="st14"
                            points="790.5,137.1 790.9,136.9 790.9,136.6 790.5,136.8 							"
                          />
                          <polygon
                            class="st14"
                            points="790.9,140.7 790.9,140.3 790.5,140.5 790.5,140.9 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="784.8,152.2 784.8,138.8 783.8,139.3 783.8,152.7 784.8,153 						"
                        />
                        <polygon
                          class="st1"
                          points="783.8,152.7 783.8,152.7 779.7,154.6 779.7,155.4 784.8,153 784.8,153 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M780.1,141.6l3.1-1.4v0.4l-3.1,1.4V141.6z M780.1,142.6l3.1-1.4v-0.4l-3.1,1.4V142.6z M780.1,143.2
            l3.1-1.4v-0.4l-3.1,1.4V143.2z M780.1,143.8l3.1-1.4V142l-3.1,1.4V143.8z M780.1,144.4l3.1-1.4v-0.4l-3.1,1.4V144.4z
             M780.1,145l3.1-1.4v-0.4l-3.1,1.4V145z M780.1,145.7l3.1-1.4v-0.4l-3.1,1.4V145.7z"
                        />
                        <polygon
                          class="st1"
                          points="780.1,147.5 783.2,146.1 783.2,145.7 780.1,147.2 						"
                        />
                        <polygon
                          class="st1"
                          points="780.1,148.2 783.2,146.7 783.2,146.3 780.1,147.8 						"
                        />
                        <polygon
                          class="st1"
                          points="780.1,148.8 783.2,147.3 783.2,147 780.1,148.4 						"
                        />
                        <polygon
                          class="st1"
                          points="780.1,149.4 783.2,148 783.2,147.6 780.1,149 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="783.2,142.3 783.2,142 782.8,142.2 782.8,142.6 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,143 783.2,142.6 782.8,142.8 782.8,143.2 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,140.7 782.8,140.9 782.8,141.3 783.2,141.1 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,141.7 783.2,141.4 782.8,141.6 782.8,141.9 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,143.6 783.2,143.2 782.8,143.4 782.8,143.8 							"
                          />
                          <polygon
                            class="st14"
                            points="782.8,140.7 783.2,140.5 783.2,140.1 782.8,140.3 							"
                          />
                          <polygon
                            class="st14"
                            points="783.2,144.2 783.2,143.8 782.8,144 782.8,144.4 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st1"
                        points="718.2,186.1 705.4,180.2 705.4,161.3 718.2,167.2 					"
                      />
                      <polygon
                        class="st15"
                        points="746.4,142.3 705.4,161.3 718.2,167.2 759.2,148.2 					"
                      />
                      <polygon
                        class="st10"
                        points="759.2,148.2 759.2,167.2 718.2,186.1 718.2,167.2 					"
                      />
                      <polygon
                        class="st183"
                        points="756.6,151.8 751.5,154.2 751.5,168.4 756.6,166 					"
                      />
                      <polygon
                        class="st183"
                        points="748.9,155.4 743.8,157.7 743.8,171.9 748.9,169.6 					"
                      />
                      <polygon
                        class="st183"
                        points="741.2,158.9 736.1,161.3 736.1,175.5 741.2,173.1 					"
                      />
                      <polygon
                        class="st183"
                        points="733.6,162.5 728.4,164.8 728.4,179 733.6,176.7 					"
                      />
                      <polygon
                        class="st183"
                        points="725.9,166 720.7,168.4 720.7,182.6 725.9,180.2 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="756.6,165.2 756.6,151.8 755.6,152.3 755.6,165.7 756.6,166 						"
                        />
                        <polygon
                          class="st1"
                          points="755.6,165.7 755.6,165.7 751.5,167.6 751.5,168.4 756.6,166 756.6,166 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M751.9,154.5l3.1-1.4v0.4l-3.1,1.4V154.5z M751.9,155.5l3.1-1.4v-0.4l-3.1,1.4V155.5z M751.9,156.1
            l3.1-1.4v-0.4l-3.1,1.4V156.1z M751.9,156.8l3.1-1.4v-0.4l-3.1,1.4V156.8z M751.9,157.4l3.1-1.4v-0.4l-3.1,1.4V157.4z
             M751.9,158l3.1-1.4v-0.4l-3.1,1.4V158z M751.9,158.6l3.1-1.4v-0.4l-3.1,1.4V158.6z"
                        />
                        <polygon
                          class="st1"
                          points="751.9,160.5 755,159 755,158.7 751.9,160.1 						"
                        />
                        <polygon
                          class="st1"
                          points="751.9,161.1 755,159.7 755,159.3 751.9,160.7 						"
                        />
                        <polygon
                          class="st1"
                          points="751.9,161.7 755,160.3 755,159.9 751.9,161.4 						"
                        />
                        <polygon
                          class="st1"
                          points="751.9,162.4 755,160.9 755,160.5 751.9,162 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="755,155.3 755,154.9 754.6,155.1 754.6,155.5 							"
                          />
                          <polygon
                            class="st14"
                            points="755,155.9 755,155.6 754.6,155.8 754.6,156.1 							"
                          />
                          <polygon
                            class="st14"
                            points="755,153.7 754.6,153.9 754.6,154.3 755,154.1 							"
                          />
                          <polygon
                            class="st14"
                            points="755,154.7 755,154.3 754.6,154.5 754.6,154.9 							"
                          />
                          <polygon
                            class="st14"
                            points="755,156.6 755,156.2 754.6,156.4 754.6,156.8 							"
                          />
                          <polygon
                            class="st14"
                            points="754.6,153.7 755,153.4 755,153.1 754.6,153.3 							"
                          />
                          <polygon
                            class="st14"
                            points="755,157.2 755,156.8 754.6,157 754.6,157.4 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="748.9,168.8 748.9,155.4 747.9,155.8 747.9,169.2 748.9,169.6 						"
                        />
                        <polygon
                          class="st1"
                          points="747.9,169.2 747.9,169.2 743.8,171.1 743.8,171.9 748.9,169.6 748.9,169.6 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M744.2,158.1l3.1-1.4v0.4l-3.1,1.4V158.1z M744.2,159.1l3.1-1.4v-0.4l-3.1,1.4V159.1z M744.2,159.7
            l3.1-1.4v-0.4l-3.1,1.4V159.7z M744.2,160.3l3.1-1.4v-0.4l-3.1,1.4V160.3z M744.2,160.9l3.1-1.4v-0.4l-3.1,1.4V160.9z
             M744.2,161.6l3.1-1.4v-0.4l-3.1,1.4V161.6z M744.2,162.2l3.1-1.4v-0.4l-3.1,1.4V162.2z"
                        />
                        <polygon
                          class="st1"
                          points="744.2,164 747.4,162.6 747.4,162.2 744.2,163.7 						"
                        />
                        <polygon
                          class="st1"
                          points="744.2,164.7 747.4,163.2 747.4,162.8 744.2,164.3 						"
                        />
                        <polygon
                          class="st1"
                          points="744.2,165.3 747.4,163.8 747.4,163.5 744.2,164.9 						"
                        />
                        <polygon
                          class="st1"
                          points="744.2,165.9 747.4,164.5 747.4,164.1 744.2,165.5 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="747.4,158.9 747.4,158.5 746.9,158.7 746.9,159.1 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,159.5 747.4,159.1 746.9,159.3 746.9,159.7 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,157.2 746.9,157.5 746.9,157.8 747.4,157.6 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,158.2 747.4,157.9 746.9,158.1 746.9,158.4 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,160.1 747.4,159.7 746.9,159.9 746.9,160.3 							"
                          />
                          <polygon
                            class="st14"
                            points="746.9,157.2 747.4,157 747.4,156.6 746.9,156.8 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,160.7 747.4,160.4 746.9,160.6 746.9,160.9 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="741.2,172.3 741.2,158.9 740.2,159.4 740.2,172.8 741.2,173.1 						"
                        />
                        <polygon
                          class="st1"
                          points="740.2,172.8 740.2,172.8 736.1,174.7 736.1,175.5 741.2,173.1 741.2,173.1 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M736.5,161.6l3.1-1.4v0.4l-3.1,1.4V161.6z M736.5,162.6l3.1-1.4v-0.4l-3.1,1.4V162.6z M736.5,163.2
            l3.1-1.4v-0.4l-3.1,1.4V163.2z M736.5,163.9l3.1-1.4V162l-3.1,1.4V163.9z M736.5,164.5l3.1-1.4v-0.4l-3.1,1.4V164.5z
             M736.5,165.1l3.1-1.4v-0.4l-3.1,1.4V165.1z M736.5,165.7l3.1-1.4v-0.4l-3.1,1.4V165.7z"
                        />
                        <polygon
                          class="st1"
                          points="736.5,167.6 739.7,166.1 739.7,165.8 736.5,167.2 						"
                        />
                        <polygon
                          class="st1"
                          points="736.5,168.2 739.7,166.8 739.7,166.4 736.5,167.8 						"
                        />
                        <polygon
                          class="st1"
                          points="736.5,168.8 739.7,167.4 739.7,167 736.5,168.5 						"
                        />
                        <polygon
                          class="st1"
                          points="736.5,169.5 739.7,168 739.7,167.6 736.5,169.1 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="739.7,162.4 739.7,162 739.2,162.2 739.2,162.6 							"
                          />
                          <polygon
                            class="st14"
                            points="739.7,163 739.7,162.7 739.2,162.9 739.2,163.2 							"
                          />
                          <polygon
                            class="st14"
                            points="739.7,160.8 739.2,161 739.2,161.4 739.7,161.2 							"
                          />
                          <polygon
                            class="st14"
                            points="739.7,161.8 739.7,161.4 739.2,161.6 739.2,162 							"
                          />
                          <polygon
                            class="st14"
                            points="739.7,163.7 739.7,163.3 739.2,163.5 739.2,163.9 							"
                          />
                          <polygon
                            class="st14"
                            points="739.2,160.8 739.7,160.5 739.7,160.2 739.2,160.4 							"
                          />
                          <polygon
                            class="st14"
                            points="739.7,164.3 739.7,163.9 739.2,164.1 739.2,164.5 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="733.6,175.9 733.6,162.5 732.5,162.9 732.5,176.3 733.6,176.7 						"
                        />
                        <polygon
                          class="st1"
                          points="732.5,176.3 732.5,176.3 728.4,178.2 728.4,179 733.6,176.7 733.6,176.7 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M728.8,165.2l3.1-1.4v0.4l-3.1,1.4V165.2z M728.8,166.2l3.1-1.4v-0.4l-3.1,1.4V166.2z M728.8,166.8
            l3.1-1.4V165l-3.1,1.4V166.8z M728.8,167.4l3.1-1.4v-0.4l-3.1,1.4V167.4z M728.8,168l3.1-1.4v-0.4l-3.1,1.4V168z M728.8,168.7
            l3.1-1.4v-0.4l-3.1,1.4V168.7z M728.8,169.3l3.1-1.4v-0.4l-3.1,1.4V169.3z"
                        />
                        <polygon
                          class="st1"
                          points="728.8,171.1 732,169.7 732,169.3 728.8,170.8 						"
                        />
                        <polygon
                          class="st1"
                          points="728.8,171.8 732,170.3 732,169.9 728.8,171.4 						"
                        />
                        <polygon
                          class="st1"
                          points="728.8,172.4 732,170.9 732,170.6 728.8,172 						"
                        />
                        <polygon
                          class="st1"
                          points="728.8,173 732,171.6 732,171.2 728.8,172.6 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="732,166 732,165.6 731.5,165.8 731.5,166.2 							"
                          />
                          <polygon
                            class="st14"
                            points="732,166.6 732,166.2 731.5,166.4 731.5,166.8 							"
                          />
                          <polygon
                            class="st14"
                            points="732,164.3 731.5,164.6 731.5,164.9 732,164.7 							"
                          />
                          <polygon
                            class="st14"
                            points="732,165.3 732,165 731.5,165.2 731.5,165.6 							"
                          />
                          <polygon
                            class="st14"
                            points="732,167.2 732,166.8 731.5,167 731.5,167.4 							"
                          />
                          <polygon
                            class="st14"
                            points="731.5,164.3 732,164.1 732,163.7 731.5,163.9 							"
                          />
                          <polygon
                            class="st14"
                            points="732,167.8 732,167.5 731.5,167.7 731.5,168 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="725.9,179.4 725.9,166 724.8,166.5 724.8,179.9 725.9,180.2 						"
                        />
                        <polygon
                          class="st1"
                          points="724.8,179.9 724.8,179.9 720.7,181.8 720.7,182.6 725.9,180.2 725.9,180.2 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M721.2,168.7l3.1-1.4v0.4l-3.1,1.4V168.7z M721.2,169.7l3.1-1.4v-0.4l-3.1,1.4V169.7z M721.2,170.3
            l3.1-1.4v-0.4l-3.1,1.4V170.3z M721.2,171l3.1-1.4v-0.4l-3.1,1.4V171z M721.2,171.6l3.1-1.4v-0.4l-3.1,1.4V171.6z
             M721.2,172.2l3.1-1.4v-0.4l-3.1,1.4V172.2z M721.2,172.8l3.1-1.4V171l-3.1,1.4V172.8z"
                        />
                        <polygon
                          class="st1"
                          points="721.2,174.7 724.3,173.3 724.3,172.9 721.2,174.3 						"
                        />
                        <polygon
                          class="st1"
                          points="721.2,175.3 724.3,173.9 724.3,173.5 721.2,174.9 						"
                        />
                        <polygon
                          class="st1"
                          points="721.2,175.9 724.3,174.5 724.3,174.1 721.2,175.6 						"
                        />
                        <polygon
                          class="st1"
                          points="721.2,176.6 724.3,175.1 724.3,174.7 721.2,176.2 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="724.3,169.5 724.3,169.1 723.8,169.4 723.8,169.7 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,170.1 724.3,169.8 723.8,170 723.8,170.3 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,167.9 723.8,168.1 723.8,168.5 724.3,168.3 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,168.9 724.3,168.5 723.8,168.7 723.8,169.1 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,170.8 724.3,170.4 723.8,170.6 723.8,171 							"
                          />
                          <polygon
                            class="st14"
                            points="723.8,167.9 724.3,167.7 724.3,167.3 723.8,167.5 							"
                          />
                          <polygon
                            class="st14"
                            points="724.3,171.4 724.3,171 723.8,171.2 723.8,171.6 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st1"
                        points="800.2,169.6 787.4,163.6 787.4,144.7 800.2,150.6 					"
                      />
                      <polygon
                        class="st15"
                        points="828.4,125.8 787.4,144.7 800.2,150.6 841.2,131.7 					"
                      />
                      <polygon
                        class="st10"
                        points="841.2,131.7 841.2,150.6 800.2,169.6 800.2,150.6 					"
                      />
                      <polygon
                        class="st183"
                        points="838.6,135.2 833.5,137.6 833.5,151.8 838.6,149.4 					"
                      />
                      <polygon
                        class="st183"
                        points="831,138.8 825.8,141.1 825.8,155.4 831,153 					"
                      />
                      <polygon
                        class="st183"
                        points="823.3,142.3 818.1,144.7 818.1,158.9 823.3,156.5 					"
                      />
                      <polygon
                        class="st183"
                        points="815.6,145.9 810.4,148.2 810.4,162.5 815.6,160.1 					"
                      />
                      <polygon
                        class="st183"
                        points="807.9,149.4 802.8,151.8 802.8,166 807.9,163.6 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="838.6,148.6 838.6,135.2 837.6,135.7 837.6,149.1 838.6,149.4 						"
                        />
                        <polygon
                          class="st1"
                          points="837.6,149.1 837.6,149.1 833.5,151 833.5,151.8 838.6,149.4 838.6,149.4 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M833.9,137.9l3.1-1.4v0.4l-3.1,1.4V137.9z M833.9,138.9l3.1-1.4v-0.4l-3.1,1.4V138.9z M833.9,139.6
            l3.1-1.4v-0.4l-3.1,1.4V139.6z M833.9,140.2l3.1-1.4v-0.4l-3.1,1.4V140.2z M833.9,140.8l3.1-1.4V139l-3.1,1.4V140.8z
             M833.9,141.4l3.1-1.4v-0.4l-3.1,1.4V141.4z M833.9,142.1l3.1-1.4v-0.4l-3.1,1.4V142.1z"
                        />
                        <polygon
                          class="st1"
                          points="833.9,143.9 837.1,142.5 837.1,142.1 833.9,143.5 						"
                        />
                        <polygon
                          class="st1"
                          points="833.9,144.5 837.1,143.1 837.1,142.7 833.9,144.2 						"
                        />
                        <polygon
                          class="st1"
                          points="833.9,145.2 837.1,143.7 837.1,143.3 833.9,144.8 						"
                        />
                        <polygon
                          class="st1"
                          points="833.9,145.8 837.1,144.3 837.1,144 833.9,145.4 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="837.1,138.7 837.1,138.4 836.6,138.6 836.6,138.9 							"
                          />
                          <polygon
                            class="st14"
                            points="837.1,139.4 837.1,139 836.6,139.2 836.6,139.6 							"
                          />
                          <polygon
                            class="st14"
                            points="837.1,137.1 836.6,137.3 836.6,137.7 837.1,137.5 							"
                          />
                          <polygon
                            class="st14"
                            points="837.1,138.1 837.1,137.7 836.6,137.9 836.6,138.3 							"
                          />
                          <polygon
                            class="st14"
                            points="837.1,140 837.1,139.6 836.6,139.8 836.6,140.2 							"
                          />
                          <polygon
                            class="st14"
                            points="836.6,137.1 837.1,136.9 837.1,136.5 836.6,136.7 							"
                          />
                          <polygon
                            class="st14"
                            points="837.1,140.6 837.1,140.2 836.6,140.4 836.6,140.8 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="831,152.2 831,138.8 829.9,139.3 829.9,152.7 831,153 						"
                        />
                        <polygon
                          class="st1"
                          points="829.9,152.7 829.9,152.7 825.8,154.6 825.8,155.4 831,153 831,153 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M826.2,141.5l3.1-1.4v0.4l-3.1,1.4V141.5z M826.2,142.5l3.1-1.4v-0.4l-3.1,1.4V142.5z M826.2,143.1
            l3.1-1.4v-0.4l-3.1,1.4V143.1z M826.2,143.7l3.1-1.4v-0.4l-3.1,1.4V143.7z M826.2,144.4l3.1-1.4v-0.4l-3.1,1.4V144.4z
             M826.2,145l3.1-1.4v-0.4l-3.1,1.4V145z M826.2,145.6l3.1-1.4v-0.4l-3.1,1.4V145.6z"
                        />
                        <polygon
                          class="st1"
                          points="826.2,147.5 829.4,146 829.4,145.6 826.2,147.1 						"
                        />
                        <polygon
                          class="st1"
                          points="826.2,148.1 829.4,146.6 829.4,146.3 826.2,147.7 						"
                        />
                        <polygon
                          class="st1"
                          points="826.2,148.7 829.4,147.3 829.4,146.9 826.2,148.3 						"
                        />
                        <polygon
                          class="st1"
                          points="826.2,149.3 829.4,147.9 829.4,147.5 826.2,149 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="829.4,142.3 829.4,141.9 828.9,142.1 828.9,142.5 							"
                          />
                          <polygon
                            class="st14"
                            points="829.4,142.9 829.4,142.5 828.9,142.7 828.9,143.1 							"
                          />
                          <polygon
                            class="st14"
                            points="829.4,140.7 828.9,140.9 828.9,141.3 829.4,141 							"
                          />
                          <polygon
                            class="st14"
                            points="829.4,141.7 829.4,141.3 828.9,141.5 828.9,141.9 							"
                          />
                          <polygon
                            class="st14"
                            points="829.4,143.5 829.4,143.2 828.9,143.4 828.9,143.7 							"
                          />
                          <polygon
                            class="st14"
                            points="828.9,140.6 829.4,140.4 829.4,140 828.9,140.3 							"
                          />
                          <polygon
                            class="st14"
                            points="829.4,144.2 829.4,143.8 828.9,144 828.9,144.4 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="823.3,155.7 823.3,142.3 822.2,142.8 822.2,156.2 823.3,156.5 						"
                        />
                        <polygon
                          class="st1"
                          points="822.2,156.2 822.2,156.2 818.1,158.1 818.1,158.9 823.3,156.5 823.3,156.5 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M818.5,145l3.1-1.4v0.4l-3.1,1.4V145z M818.5,146l3.1-1.4v-0.4l-3.1,1.4V146z M818.5,146.7l3.1-1.4v-0.4
            l-3.1,1.4V146.7z M818.5,147.3l3.1-1.4v-0.4l-3.1,1.4V147.3z M818.5,147.9l3.1-1.4v-0.4l-3.1,1.4V147.9z M818.5,148.5l3.1-1.4
            v-0.4l-3.1,1.4V148.5z M818.5,149.2l3.1-1.4v-0.4l-3.1,1.4V149.2z"
                        />
                        <polygon
                          class="st1"
                          points="818.5,151 821.7,149.6 821.7,149.2 818.5,150.6 						"
                        />
                        <polygon
                          class="st1"
                          points="818.5,151.6 821.7,150.2 821.7,149.8 818.5,151.3 						"
                        />
                        <polygon
                          class="st1"
                          points="818.5,152.3 821.7,150.8 821.7,150.4 818.5,151.9 						"
                        />
                        <polygon
                          class="st1"
                          points="818.5,152.9 821.7,151.4 821.7,151.1 818.5,152.5 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="821.7,145.8 821.7,145.5 821.2,145.7 821.2,146 							"
                          />
                          <polygon
                            class="st14"
                            points="821.7,146.5 821.7,146.1 821.2,146.3 821.2,146.7 							"
                          />
                          <polygon
                            class="st14"
                            points="821.7,144.2 821.2,144.4 821.2,144.8 821.7,144.6 							"
                          />
                          <polygon
                            class="st14"
                            points="821.7,145.2 821.7,144.8 821.2,145.1 821.2,145.4 							"
                          />
                          <polygon
                            class="st14"
                            points="821.7,147.1 821.7,146.7 821.2,146.9 821.2,147.3 							"
                          />
                          <polygon
                            class="st14"
                            points="821.2,144.2 821.7,144 821.7,143.6 821.2,143.8 							"
                          />
                          <polygon
                            class="st14"
                            points="821.7,147.7 821.7,147.3 821.2,147.5 821.2,147.9 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="815.6,159.3 815.6,145.9 814.5,146.4 814.5,159.8 815.6,160.1 						"
                        />
                        <polygon
                          class="st1"
                          points="814.5,159.8 814.5,159.8 810.4,161.7 810.4,162.5 815.6,160.1 815.6,160.1 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M810.9,148.6l3.1-1.4v0.4l-3.1,1.4V148.6z M810.9,149.6l3.1-1.4v-0.4l-3.1,1.4V149.6z M810.9,150.2
            l3.1-1.4v-0.4l-3.1,1.4V150.2z M810.9,150.8l3.1-1.4V149l-3.1,1.4V150.8z M810.9,151.5l3.1-1.4v-0.4l-3.1,1.4V151.5z
             M810.9,152.1l3.1-1.4v-0.4l-3.1,1.4V152.1z M810.9,152.7l3.1-1.4v-0.4l-3.1,1.4V152.7z"
                        />
                        <polygon
                          class="st1"
                          points="810.9,154.6 814,153.1 814,152.8 810.9,154.2 						"
                        />
                        <polygon
                          class="st1"
                          points="810.9,155.2 814,153.7 814,153.4 810.9,154.8 						"
                        />
                        <polygon
                          class="st1"
                          points="810.9,155.8 814,154.4 814,154 810.9,155.4 						"
                        />
                        <polygon
                          class="st1"
                          points="810.9,156.4 814,155 814,154.6 810.9,156.1 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="814,149.4 814,149 813.5,149.2 813.5,149.6 							"
                          />
                          <polygon
                            class="st14"
                            points="814,150 814,149.6 813.5,149.8 813.5,150.2 							"
                          />
                          <polygon
                            class="st14"
                            points="814,147.8 813.5,148 813.5,148.4 814,148.1 							"
                          />
                          <polygon
                            class="st14"
                            points="814,148.8 814,148.4 813.5,148.6 813.5,149 							"
                          />
                          <polygon
                            class="st14"
                            points="814,150.6 814,150.3 813.5,150.5 813.5,150.8 							"
                          />
                          <polygon
                            class="st14"
                            points="813.5,147.7 814,147.5 814,147.2 813.5,147.4 							"
                          />
                          <polygon
                            class="st14"
                            points="814,151.3 814,150.9 813.5,151.1 813.5,151.5 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="807.9,162.8 807.9,149.4 806.8,149.9 806.8,163.3 807.9,163.6 						"
                        />
                        <polygon
                          class="st1"
                          points="806.8,163.3 806.8,163.3 802.8,165.2 802.8,166 807.9,163.6 807.9,163.6 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M803.2,152.1l3.1-1.4v0.4l-3.1,1.4V152.1z M803.2,153.1l3.1-1.4v-0.4l-3.1,1.4V153.1z M803.2,153.8
            l3.1-1.4v-0.4l-3.1,1.4V153.8z M803.2,154.4l3.1-1.4v-0.4l-3.1,1.4V154.4z M803.2,155l3.1-1.4v-0.4l-3.1,1.4V155z
             M803.2,155.6l3.1-1.4v-0.4l-3.1,1.4V155.6z M803.2,156.3l3.1-1.4v-0.4l-3.1,1.4V156.3z"
                        />
                        <polygon
                          class="st1"
                          points="803.2,158.1 806.3,156.7 806.3,156.3 803.2,157.8 						"
                        />
                        <polygon
                          class="st1"
                          points="803.2,158.7 806.3,157.3 806.3,156.9 803.2,158.4 						"
                        />
                        <polygon
                          class="st1"
                          points="803.2,159.4 806.3,157.9 806.3,157.5 803.2,159 						"
                        />
                        <polygon
                          class="st1"
                          points="803.2,160 806.3,158.5 806.3,158.2 803.2,159.6 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="806.3,152.9 806.3,152.6 805.9,152.8 805.9,153.2 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,153.6 806.3,153.2 805.9,153.4 805.9,153.8 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,151.3 805.9,151.5 805.9,151.9 806.3,151.7 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,152.3 806.3,151.9 805.9,152.2 805.9,152.5 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,154.2 806.3,153.8 805.9,154 805.9,154.4 							"
                          />
                          <polygon
                            class="st14"
                            points="805.9,151.3 806.3,151.1 806.3,150.7 805.9,150.9 							"
                          />
                          <polygon
                            class="st14"
                            points="806.3,154.8 806.3,154.4 805.9,154.6 805.9,155 							"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <polygon
                        class="st1"
                        points="741.2,196.7 728.4,190.8 728.4,171.9 741.2,177.8 					"
                      />
                      <polygon
                        class="st15"
                        points="769.4,152.9 728.4,171.9 741.2,177.8 782.3,158.8 					"
                      />
                      <polygon
                        class="st10"
                        points="782.3,158.8 782.3,177.8 741.2,196.7 741.2,177.8 					"
                      />
                      <polygon
                        class="st183"
                        points="779.7,162.4 774.6,164.8 774.6,179 779.7,176.6 					"
                      />
                      <polygon
                        class="st183"
                        points="772,165.9 766.9,168.3 766.9,182.5 772,180.2 					"
                      />
                      <polygon
                        class="st183"
                        points="764.3,169.5 759.2,171.9 759.2,186.1 764.3,183.7 					"
                      />
                      <polygon
                        class="st183"
                        points="756.6,173 751.5,175.4 751.5,189.6 756.6,187.3 					"
                      />
                      <polygon
                        class="st183"
                        points="748.9,176.6 743.8,179 743.8,193.2 748.9,190.8 					"
                      />
                      <g>
                        <polygon
                          class="st361"
                          points="779.7,175.8 779.7,162.4 778.6,162.9 778.6,176.3 779.7,176.6 						"
                        />
                        <polygon
                          class="st1"
                          points="778.6,176.3 778.6,176.3 774.6,178.2 774.6,179 779.7,176.6 779.7,176.6 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M775,165.1l3.1-1.4v0.4l-3.1,1.4V165.1z M775,166.1l3.1-1.4v-0.4l-3.1,1.4V166.1z M775,166.7l3.1-1.4
            v-0.4l-3.1,1.4V166.7z M775,167.4l3.1-1.4v-0.4L775,167V167.4z M775,168l3.1-1.4v-0.4l-3.1,1.4V168z M775,168.6l3.1-1.4v-0.4
            l-3.1,1.4V168.6z M775,169.2l3.1-1.4v-0.4l-3.1,1.4V169.2z"
                        />
                        <polygon
                          class="st1"
                          points="775,171.1 778.1,169.6 778.1,169.3 775,170.7 						"
                        />
                        <polygon
                          class="st1"
                          points="775,171.7 778.1,170.3 778.1,169.9 775,171.3 						"
                        />
                        <polygon
                          class="st1"
                          points="775,172.3 778.1,170.9 778.1,170.5 775,172 						"
                        />
                        <polygon
                          class="st1"
                          points="775,173 778.1,171.5 778.1,171.1 775,172.6 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="778.1,165.9 778.1,165.5 777.7,165.7 777.7,166.1 							"
                          />
                          <polygon
                            class="st14"
                            points="778.1,166.5 778.1,166.2 777.7,166.4 777.7,166.7 							"
                          />
                          <polygon
                            class="st14"
                            points="778.1,164.3 777.7,164.5 777.7,164.9 778.1,164.7 							"
                          />
                          <polygon
                            class="st14"
                            points="778.1,165.3 778.1,164.9 777.7,165.1 777.7,165.5 							"
                          />
                          <polygon
                            class="st14"
                            points="778.1,167.2 778.1,166.8 777.7,167 777.7,167.4 							"
                          />
                          <polygon
                            class="st14"
                            points="777.7,164.2 778.1,164 778.1,163.7 777.7,163.9 							"
                          />
                          <polygon
                            class="st14"
                            points="778.1,167.8 778.1,167.4 777.7,167.6 777.7,168 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="772,179.4 772,165.9 771,166.4 771,179.8 772,180.2 						"
                        />
                        <polygon
                          class="st1"
                          points="771,179.8 771,179.8 766.9,181.7 766.9,182.5 772,180.2 772,180.2 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M767.3,168.7l3.1-1.4v0.4l-3.1,1.4V168.7z M767.3,169.7l3.1-1.4v-0.4l-3.1,1.4V169.7z M767.3,170.3
            l3.1-1.4v-0.4l-3.1,1.4V170.3z M767.3,170.9l3.1-1.4v-0.4l-3.1,1.4V170.9z M767.3,171.5l3.1-1.4v-0.4l-3.1,1.4V171.5z
             M767.3,172.1l3.1-1.4v-0.4l-3.1,1.4V172.1z M767.3,172.8l3.1-1.4V171l-3.1,1.4V172.8z"
                        />
                        <polygon
                          class="st1"
                          points="767.3,174.6 770.4,173.2 770.4,172.8 767.3,174.3 						"
                        />
                        <polygon
                          class="st1"
                          points="767.3,175.3 770.4,173.8 770.4,173.4 767.3,174.9 						"
                        />
                        <polygon
                          class="st1"
                          points="767.3,175.9 770.4,174.4 770.4,174.1 767.3,175.5 						"
                        />
                        <polygon
                          class="st1"
                          points="767.3,176.5 770.4,175.1 770.4,174.7 767.3,176.1 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="770.4,169.5 770.4,169.1 770,169.3 770,169.7 							"
                          />
                          <polygon
                            class="st14"
                            points="770.4,170.1 770.4,169.7 770,169.9 770,170.3 							"
                          />
                          <polygon
                            class="st14"
                            points="770.4,167.8 770,168 770,168.4 770.4,168.2 							"
                          />
                          <polygon
                            class="st14"
                            points="770.4,168.8 770.4,168.5 770,168.7 770,169 							"
                          />
                          <polygon
                            class="st14"
                            points="770.4,170.7 770.4,170.3 770,170.5 770,170.9 							"
                          />
                          <polygon
                            class="st14"
                            points="770,167.8 770.4,167.6 770.4,167.2 770,167.4 							"
                          />
                          <polygon
                            class="st14"
                            points="770.4,171.3 770.4,171 770,171.2 770,171.5 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="764.3,182.9 764.3,169.5 763.3,170 763.3,183.4 764.3,183.7 						"
                        />
                        <polygon
                          class="st1"
                          points="763.3,183.4 763.3,183.4 759.2,185.3 759.2,186.1 764.3,183.7 764.3,183.7 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M759.6,172.2l3.1-1.4v0.4l-3.1,1.4V172.2z M759.6,173.2l3.1-1.4v-0.4l-3.1,1.4V173.2z M759.6,173.8
            l3.1-1.4V172l-3.1,1.4V173.8z M759.6,174.5l3.1-1.4v-0.4l-3.1,1.4V174.5z M759.6,175.1l3.1-1.4v-0.4l-3.1,1.4V175.1z
             M759.6,175.7l3.1-1.4v-0.4l-3.1,1.4V175.7z M759.6,176.3l3.1-1.4v-0.4l-3.1,1.4V176.3z"
                        />
                        <polygon
                          class="st1"
                          points="759.6,178.2 762.7,176.7 762.7,176.4 759.6,177.8 						"
                        />
                        <polygon
                          class="st1"
                          points="759.6,178.8 762.7,177.4 762.7,177 759.6,178.4 						"
                        />
                        <polygon
                          class="st1"
                          points="759.6,179.4 762.7,178 762.7,177.6 759.6,179.1 						"
                        />
                        <polygon
                          class="st1"
                          points="759.6,180.1 762.7,178.6 762.7,178.2 759.6,179.7 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="762.7,173 762.7,172.6 762.3,172.8 762.3,173.2 							"
                          />
                          <polygon
                            class="st14"
                            points="762.7,173.6 762.7,173.3 762.3,173.5 762.3,173.8 							"
                          />
                          <polygon
                            class="st14"
                            points="762.7,171.4 762.3,171.6 762.3,172 762.7,171.8 							"
                          />
                          <polygon
                            class="st14"
                            points="762.7,172.4 762.7,172 762.3,172.2 762.3,172.6 							"
                          />
                          <polygon
                            class="st14"
                            points="762.7,174.3 762.7,173.9 762.3,174.1 762.3,174.5 							"
                          />
                          <polygon
                            class="st14"
                            points="762.3,171.4 762.7,171.1 762.7,170.8 762.3,171 							"
                          />
                          <polygon
                            class="st14"
                            points="762.7,174.9 762.7,174.5 762.3,174.7 762.3,175.1 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="756.6,186.5 756.6,173 755.6,173.5 755.6,186.9 756.6,187.3 						"
                        />
                        <polygon
                          class="st1"
                          points="755.6,186.9 755.6,186.9 751.5,188.8 751.5,189.6 756.6,187.3 756.6,187.3 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M751.9,175.8l3.1-1.4v0.4l-3.1,1.4V175.8z M751.9,176.8l3.1-1.4v-0.4l-3.1,1.4V176.8z M751.9,177.4
            l3.1-1.4v-0.4l-3.1,1.4V177.4z M751.9,178l3.1-1.4v-0.4l-3.1,1.4V178z M751.9,178.6l3.1-1.4v-0.4l-3.1,1.4V178.6z
             M751.9,179.3l3.1-1.4v-0.4l-3.1,1.4V179.3z M751.9,179.9l3.1-1.4v-0.4l-3.1,1.4V179.9z"
                        />
                        <polygon
                          class="st1"
                          points="751.9,181.7 755,180.3 755,179.9 751.9,181.4 						"
                        />
                        <polygon
                          class="st1"
                          points="751.9,182.4 755,180.9 755,180.5 751.9,182 						"
                        />
                        <polygon
                          class="st1"
                          points="751.9,183 755,181.5 755,181.2 751.9,182.6 						"
                        />
                        <polygon
                          class="st1"
                          points="751.9,183.6 755,182.2 755,181.8 751.9,183.2 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="755,176.6 755,176.2 754.6,176.4 754.6,176.8 							"
                          />
                          <polygon
                            class="st14"
                            points="755,177.2 755,176.8 754.6,177 754.6,177.4 							"
                          />
                          <polygon
                            class="st14"
                            points="755,174.9 754.6,175.1 754.6,175.5 755,175.3 							"
                          />
                          <polygon
                            class="st14"
                            points="755,175.9 755,175.6 754.6,175.8 754.6,176.1 							"
                          />
                          <polygon
                            class="st14"
                            points="755,177.8 755,177.4 754.6,177.6 754.6,178 							"
                          />
                          <polygon
                            class="st14"
                            points="754.6,174.9 755,174.7 755,174.3 754.6,174.5 							"
                          />
                          <polygon
                            class="st14"
                            points="755,178.4 755,178.1 754.6,178.3 754.6,178.6 							"
                          />
                        </g>
                      </g>
                      <g>
                        <polygon
                          class="st361"
                          points="748.9,190 748.9,176.6 747.9,177.1 747.9,190.5 748.9,190.8 						"
                        />
                        <polygon
                          class="st1"
                          points="747.9,190.5 747.9,190.5 743.8,192.4 743.8,193.2 748.9,190.8 748.9,190.8 						"
                        />
                      </g>
                      <g>
                        <path
                          class="st1"
                          d="M744.2,179.3l3.1-1.4v0.4l-3.1,1.4V179.3z M744.2,180.3l3.1-1.4v-0.4l-3.1,1.4V180.3z M744.2,180.9
            l3.1-1.4v-0.4l-3.1,1.4V180.9z M744.2,181.6l3.1-1.4v-0.4l-3.1,1.4V181.6z M744.2,182.2l3.1-1.4v-0.4l-3.1,1.4V182.2z
             M744.2,182.8l3.1-1.4V181l-3.1,1.4V182.8z M744.2,183.4l3.1-1.4v-0.4l-3.1,1.4V183.4z"
                        />
                        <polygon
                          class="st1"
                          points="744.2,185.3 747.4,183.8 747.4,183.5 744.2,184.9 						"
                        />
                        <polygon
                          class="st1"
                          points="744.2,185.9 747.4,184.5 747.4,184.1 744.2,185.5 						"
                        />
                        <polygon
                          class="st1"
                          points="744.2,186.5 747.4,185.1 747.4,184.7 744.2,186.2 						"
                        />
                        <polygon
                          class="st1"
                          points="744.2,187.2 747.4,185.7 747.4,185.3 744.2,186.8 						"
                        />
                        <g>
                          <polygon
                            class="st14"
                            points="747.4,180.1 747.4,179.7 746.9,179.9 746.9,180.3 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,180.7 747.4,180.4 746.9,180.6 746.9,180.9 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,178.5 746.9,178.7 746.9,179.1 747.4,178.9 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,179.5 747.4,179.1 746.9,179.3 746.9,179.7 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,181.4 747.4,181 746.9,181.2 746.9,181.6 							"
                          />
                          <polygon
                            class="st14"
                            points="746.9,178.5 747.4,178.2 747.4,177.9 746.9,178.1 							"
                          />
                          <polygon
                            class="st14"
                            points="747.4,182 747.4,181.6 746.9,181.8 746.9,182.2 							"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g className="hexagon-from-top-4">
              <defs>
                <polygon
                  id="SVGID_00000116924488430617335520000003423224284281913730_"
                  points="1042.7,173.1 1042.7,105.2 983.9,71.2 
    925.1,105.2 925.1,173.1 983.9,207 		"
                />
              </defs>
              <clipPath id="SVGID_00000116921870632696876790000002602316530554608801_">
                <use
                  xlinkHref="#SVGID_00000116924488430617335520000003423224284281913730_"
                  style={{ overflow: "visible" }}
                />
              </clipPath>
              <g
                style={{
                  clipPath:
                    "url(#SVGID_00000116921870632696876790000002602316530554608801_)",
                }}
              >
                <circle class="st0" cx="983.9" cy="147" r="91.3" />
                <g>
                  <polygon
                    class="st372"
                    points="997.8,227.3 886.9,212 886.9,142.3 997.8,157.6 			"
                  />
                  <polygon
                    class="st1"
                    points="1033,212 997.8,227.3 997.8,157.6 1033,142.3 			"
                  />
                  <polygon
                    class="st361"
                    points="997.8,157.6 886.9,142.3 922,127.1 1033,142.3 			"
                  />
                  <polygon
                    class="st373"
                    points="997.8,227.3 886.9,212 886.9,142.3 997.8,157.6 			"
                  />
                  <polygon
                    class="st374"
                    points="891,147 891,151.7 993.7,165.8 993.7,161.1 			"
                  />
                  <polygon
                    class="st374"
                    points="891,154.2 891,158.9 993.7,173 993.7,168.3 			"
                  />
                  <polygon
                    class="st374"
                    points="891,161.3 891,166 993.7,180.1 993.7,175.4 			"
                  />
                  <polygon
                    class="st374"
                    points="891,168.4 891,173.1 993.7,187.2 993.7,182.5 			"
                  />
                  <polygon
                    class="st374"
                    points="891,175.6 891,180.3 993.7,194.4 993.7,189.7 			"
                  />
                  <polygon
                    class="st374"
                    points="891,182.7 891,187.4 993.7,201.5 993.7,196.8 			"
                  />
                  <polygon
                    class="st374"
                    points="891,189.9 891,194.6 993.7,208.7 993.7,204 			"
                  />
                  <polygon
                    class="st374"
                    points="891,197 891,201.7 993.7,215.8 993.7,211.1 			"
                  />
                  <polygon
                    class="st374"
                    points="891,204.1 891,208.8 993.7,222.9 993.7,218.2 			"
                  />
                  <g>
                    <polygon
                      class="st361"
                      points="908.9,192.3 902.8,191.5 902.8,196.2 908.9,197 				"
                    />
                    <polygon
                      class="st361"
                      points="941.9,196.9 935.8,196 935.8,200.7 941.9,201.5 				"
                    />
                    <polygon
                      class="st361"
                      points="902.8,167.6 908.9,168.5 908.9,163.8 902.8,162.9 				"
                    />
                    <polygon
                      class="st361"
                      points="915.5,193.2 909.4,192.4 909.4,197.1 915.5,197.9 				"
                    />
                    <polygon
                      class="st361"
                      points="928.7,195 922.6,194.2 922.6,198.9 928.7,199.7 				"
                    />
                    <polygon
                      class="st361"
                      points="922.1,194.1 916,193.3 916,198 922.1,198.8 				"
                    />
                    <polygon
                      class="st361"
                      points="935.3,195.9 929.2,195.1 929.2,199.8 935.3,200.6 				"
                    />
                    <polygon
                      class="st361"
                      points="975.5,172.9 975.5,177.6 981.6,178.4 981.6,173.7 				"
                    />
                    <polygon
                      class="st361"
                      points="909.4,168.5 915.5,169.4 915.5,164.7 909.4,163.8 				"
                    />
                    <polygon
                      class="st361"
                      points="949,174 955.2,174.8 955.2,170.1 949,169.3 				"
                    />
                    <polygon
                      class="st361"
                      points="962.2,175.8 968.4,176.6 968.4,171.9 962.2,171.1 				"
                    />
                    <polygon
                      class="st361"
                      points="922.6,170.3 928.7,171.2 928.7,166.5 922.6,165.6 				"
                    />
                    <polygon
                      class="st361"
                      points="968.9,176.7 975,177.5 975,172.8 968.9,172 				"
                    />
                    <polygon
                      class="st361"
                      points="955.6,174.9 961.8,175.7 961.8,171 955.6,170.2 				"
                    />
                    <polygon
                      class="st361"
                      points="929.2,171.2 935.3,172.1 935.3,167.4 929.2,166.5 				"
                    />
                    <polygon
                      class="st361"
                      points="935.8,172.1 941.9,173 941.9,168.3 935.8,167.5 				"
                    />
                    <polygon
                      class="st361"
                      points="942.4,173.1 948.5,173.9 948.5,169.2 942.4,168.4 				"
                    />
                    <polygon
                      class="st361"
                      points="916,169.4 922.1,170.3 922.1,165.6 916,164.7 				"
                    />
                    <polygon
                      class="st361"
                      points="948.5,197.8 942.4,196.9 942.4,201.6 948.5,202.5 				"
                    />
                    <polygon
                      class="st361"
                      points="942.4,165.9 948.5,166.8 948.5,162.1 942.4,161.2 				"
                    />
                    <polygon
                      class="st361"
                      points="929.2,164.1 935.3,164.9 935.3,160.3 929.2,159.4 				"
                    />
                    <polygon
                      class="st361"
                      points="949,166.8 955.2,167.7 955.2,163 949,162.1 				"
                    />
                    <polygon
                      class="st361"
                      points="909.4,161.4 915.5,162.2 915.5,157.5 909.4,156.7 				"
                    />
                    <polygon
                      class="st361"
                      points="922.6,163.2 928.7,164 928.7,159.3 922.6,158.5 				"
                    />
                    <polygon
                      class="st361"
                      points="955.6,167.7 961.8,168.6 961.8,163.9 955.6,163 				"
                    />
                    <polygon
                      class="st361"
                      points="916,162.3 922.1,163.1 922.1,158.4 916,157.6 				"
                    />
                    <polygon
                      class="st361"
                      points="935.8,165 941.9,165.9 941.9,161.2 935.8,160.3 				"
                    />
                    <polygon
                      class="st361"
                      points="975,201.4 968.9,200.5 968.9,205.2 975,206.1 				"
                    />
                    <polygon
                      class="st361"
                      points="961.8,199.6 955.6,198.7 955.6,203.4 961.8,204.3 				"
                    />
                    <polygon
                      class="st361"
                      points="962.2,168.6 968.4,169.5 968.4,164.8 962.2,163.9 				"
                    />
                    <polygon
                      class="st361"
                      points="955.2,198.7 949,197.8 949,202.5 955.2,203.4 				"
                    />
                    <polygon
                      class="st361"
                      points="968.4,200.5 962.2,199.6 962.2,204.3 968.4,205.2 				"
                    />
                    <polygon
                      class="st361"
                      points="968.9,169.5 975,170.4 975,165.7 968.9,164.9 				"
                    />
                    <polygon
                      class="st361"
                      points="975.5,170.5 981.6,171.3 981.6,166.6 975.5,165.8 				"
                    />
                    <polygon
                      class="st361"
                      points="981.6,202.3 975.5,201.5 975.5,206.1 981.6,207 				"
                    />
                    <polygon
                      class="st361"
                      points="922.1,187 916,186.2 916,190.8 922.1,191.7 				"
                    />
                    <polygon
                      class="st361"
                      points="968.9,183.8 975,184.7 975,180 968.9,179.1 				"
                    />
                    <polygon
                      class="st361"
                      points="962.2,182.9 968.4,183.8 968.4,179.1 962.2,178.2 				"
                    />
                    <polygon
                      class="st361"
                      points="955.6,182 961.8,182.9 961.8,178.2 955.6,177.3 				"
                    />
                    <polygon
                      class="st361"
                      points="975,187.1 968.9,186.3 968.9,191 975,191.8 				"
                    />
                    <polygon
                      class="st361"
                      points="929.2,178.4 935.3,179.2 935.3,174.5 929.2,173.7 				"
                    />
                    <polygon
                      class="st361"
                      points="968.4,186.2 962.2,185.4 962.2,190.1 968.4,190.9 				"
                    />
                    <polygon
                      class="st361"
                      points="935.8,179.3 941.9,180.1 941.9,175.4 935.8,174.6 				"
                    />
                    <polygon
                      class="st361"
                      points="942.4,180.2 948.5,181 948.5,176.3 942.4,175.5 				"
                    />
                    <polygon
                      class="st361"
                      points="949,181.1 955.2,181.9 955.2,177.3 949,176.4 				"
                    />
                    <polygon
                      class="st361"
                      points="975.5,180 975.5,184.7 981.6,185.6 981.6,180.9 				"
                    />
                    <polygon
                      class="st361"
                      points="935.3,181.7 929.2,180.8 929.2,185.5 935.3,186.4 				"
                    />
                    <polygon
                      class="st361"
                      points="928.7,180.8 922.6,179.9 922.6,184.6 928.7,185.5 				"
                    />
                    <polygon
                      class="st361"
                      points="915.5,178.9 909.4,178.1 909.4,182.8 915.5,183.6 				"
                    />
                    <polygon
                      class="st361"
                      points="941.9,182.6 935.8,181.7 935.8,186.4 941.9,187.3 				"
                    />
                    <polygon
                      class="st361"
                      points="961.8,185.3 955.6,184.5 955.6,189.1 961.8,190 				"
                    />
                    <polygon
                      class="st361"
                      points="955.2,184.4 949,183.5 949,188.2 955.2,189.1 				"
                    />
                    <polygon
                      class="st361"
                      points="948.5,183.5 942.4,182.6 942.4,187.3 948.5,188.2 				"
                    />
                    <polygon
                      class="st361"
                      points="922.1,179.9 916,179 916,183.7 922.1,184.6 				"
                    />
                    <polygon
                      class="st361"
                      points="955.2,191.5 949,190.7 949,195.4 955.2,196.2 				"
                    />
                    <polygon
                      class="st361"
                      points="961.8,192.4 955.6,191.6 955.6,196.3 961.8,197.1 				"
                    />
                    <polygon
                      class="st361"
                      points="948.5,190.6 942.4,189.8 942.4,194.5 948.5,195.3 				"
                    />
                    <polygon
                      class="st361"
                      points="968.4,193.3 962.2,192.5 962.2,197.2 968.4,198 				"
                    />
                    <polygon
                      class="st361"
                      points="975,194.2 968.9,193.4 968.9,198.1 975,198.9 				"
                    />
                    <polygon
                      class="st361"
                      points="941.9,189.7 935.8,188.9 935.8,193.6 941.9,194.4 				"
                    />
                    <polygon
                      class="st361"
                      points="922.6,177.5 928.7,178.3 928.7,173.6 922.6,172.8 				"
                    />
                    <polygon
                      class="st361"
                      points="981.6,195.2 975.5,194.3 975.5,199 981.6,199.8 				"
                    />
                    <polygon
                      class="st361"
                      points="975.5,187.2 975.5,191.9 981.6,192.7 981.6,188 				"
                    />
                    <polygon
                      class="st361"
                      points="909.4,175.7 915.5,176.5 915.5,171.8 909.4,171 				"
                    />
                    <polygon
                      class="st361"
                      points="902.8,174.8 908.9,175.6 908.9,170.9 902.8,170.1 				"
                    />
                    <polygon
                      class="st361"
                      points="916,176.6 922.1,177.4 922.1,172.7 916,171.9 				"
                    />
                    <polygon
                      class="st361"
                      points="908.9,189.9 908.9,185.2 902.8,184.3 902.8,189 				"
                    />
                    <polygon
                      class="st361"
                      points="935.3,188.8 929.2,188 929.2,192.7 935.3,193.5 				"
                    />
                    <polygon
                      class="st361"
                      points="915.5,186.1 909.4,185.2 909.4,189.9 915.5,190.8 				"
                    />
                    <polygon
                      class="st361"
                      points="928.7,187.9 922.6,187.1 922.6,191.8 928.7,192.6 				"
                    />
                    <polygon
                      class="st361"
                      points="902.8,160.5 908.9,161.3 908.9,156.6 902.8,155.8 				"
                    />
                    <polygon
                      class="st361"
                      points="908.9,182.7 908.9,178 902.8,177.2 902.8,181.9 				"
                    />
                    <polygon
                      class="st361"
                      points="961.8,213.9 955.6,213 955.6,217.7 961.8,218.5 				"
                    />
                    <polygon
                      class="st361"
                      points="955.2,212.9 949,212.1 949,216.8 955.2,217.6 				"
                    />
                    <polygon
                      class="st361"
                      points="948.5,212 942.4,211.2 942.4,215.9 948.5,216.7 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,147.7 891,147 891,151.7 895.7,152.4 				"
                    />
                    <polygon
                      class="st361"
                      points="941.9,211.1 935.8,210.3 935.8,215 941.9,215.8 				"
                    />
                    <polygon
                      class="st361"
                      points="981.6,216.6 975.5,215.7 975.5,220.4 981.6,221.3 				"
                    />
                    <polygon
                      class="st361"
                      points="988.2,217.5 982.1,216.6 982.1,221.3 988.2,222.2 				"
                    />
                    <polygon
                      class="st361"
                      points="968.4,214.8 962.2,213.9 962.2,218.6 968.4,219.5 				"
                    />
                    <polygon
                      class="st361"
                      points="975,215.7 968.9,214.8 968.9,219.5 975,220.4 				"
                    />
                    <polygon
                      class="st361"
                      points="935.3,210.2 929.2,209.4 929.2,214.1 935.3,214.9 				"
                    />
                    <polygon
                      class="st361"
                      points="902.8,153.3 908.9,154.2 908.9,149.5 902.8,148.6 				"
                    />
                    <polygon
                      class="st361"
                      points="902.3,205.7 896.1,204.9 896.1,209.5 902.3,210.4 				"
                    />
                    <polygon
                      class="st361"
                      points="896.1,152.4 902.3,153.3 902.3,148.6 896.1,147.7 				"
                    />
                    <polygon
                      class="st361"
                      points="916,155.2 922.1,156 922.1,151.3 916,150.5 				"
                    />
                    <polygon
                      class="st361"
                      points="908.9,206.6 902.8,205.8 902.8,210.5 908.9,211.3 				"
                    />
                    <polygon
                      class="st361"
                      points="922.1,208.4 916,207.6 916,212.3 922.1,213.1 				"
                    />
                    <polygon
                      class="st361"
                      points="915.5,207.5 909.4,206.7 909.4,211.4 915.5,212.2 				"
                    />
                    <polygon
                      class="st361"
                      points="928.7,209.3 922.6,208.5 922.6,213.2 928.7,214 				"
                    />
                    <polygon
                      class="st361"
                      points="909.4,154.2 915.5,155.1 915.5,150.4 909.4,149.6 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,186.5 993.7,187.2 993.7,182.5 988.7,181.8 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,154.8 891,154.2 891,158.9 895.7,159.5 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,193.7 993.7,194.4 993.7,189.7 988.7,189 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,208 993.7,208.7 993.7,204 988.7,203.3 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,200.8 993.7,201.5 993.7,196.8 988.7,196.1 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,160.4 988.7,165.1 993.7,165.8 993.7,161.1 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,172.3 993.7,173 993.7,168.3 988.7,167.6 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,179.4 993.7,180.1 993.7,175.4 988.7,174.7 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,215.1 993.7,215.8 993.7,211.1 988.7,210.4 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,183.4 891,182.7 891,187.4 895.7,188.1 				"
                    />
                    <polygon
                      class="st361"
                      points="988.7,222.2 993.7,222.9 993.7,218.2 988.7,217.5 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,176.2 891,175.6 891,180.3 895.7,180.9 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,162 891,161.3 891,166 895.7,166.6 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,169.1 891,168.4 891,173.1 895.7,173.8 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,204.8 891,204.1 891,208.8 895.7,209.5 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,190.5 891,189.9 891,194.6 895.7,195.2 				"
                    />
                    <polygon
                      class="st361"
                      points="895.7,197.6 891,197 891,201.7 895.7,202.3 				"
                    />
                    <polygon
                      class="st361"
                      points="982.1,159.5 982.1,164.2 988.2,165.1 988.2,160.4 				"
                    />
                    <polygon
                      class="st361"
                      points="941.9,204 935.8,203.2 935.8,207.8 941.9,208.7 				"
                    />
                    <polygon
                      class="st361"
                      points="935.3,203.1 929.2,202.2 929.2,206.9 935.3,207.8 				"
                    />
                    <polygon
                      class="st361"
                      points="928.7,202.2 922.6,201.3 922.6,206 928.7,206.9 				"
                    />
                    <polygon
                      class="st361"
                      points="948.5,204.9 942.4,204.1 942.4,208.8 948.5,209.6 				"
                    />
                    <polygon
                      class="st361"
                      points="961.8,206.7 955.6,205.9 955.6,210.6 961.8,211.4 				"
                    />
                    <polygon
                      class="st361"
                      points="955.2,205.8 949,205 949,209.7 955.2,210.5 				"
                    />
                    <polygon
                      class="st361"
                      points="968.4,207.6 962.2,206.8 962.2,211.5 968.4,212.3 				"
                    />
                    <polygon
                      class="st361"
                      points="975,208.5 968.9,207.7 968.9,212.4 975,213.2 				"
                    />
                    <polygon
                      class="st361"
                      points="922.1,201.3 916,200.4 916,205.1 922.1,206 				"
                    />
                    <polygon
                      class="st361"
                      points="902.3,189 902.3,184.3 896.1,183.4 896.1,188.1 				"
                    />
                    <polygon
                      class="st361"
                      points="915.5,200.4 909.4,199.5 909.4,204.2 915.5,205.1 				"
                    />
                    <polygon
                      class="st361"
                      points="902.3,174.7 902.3,170 896.1,169.2 896.1,173.8 				"
                    />
                    <polygon
                      class="st361"
                      points="902.3,167.6 902.3,162.9 896.1,162 896.1,166.7 				"
                    />
                    <polygon
                      class="st361"
                      points="902.3,181.8 902.3,177.1 896.1,176.3 896.1,181 				"
                    />
                    <polygon
                      class="st361"
                      points="908.9,199.5 902.8,198.6 902.8,203.3 908.9,204.2 				"
                    />
                    <polygon
                      class="st361"
                      points="902.3,203.2 902.3,198.6 896.1,197.7 896.1,202.4 				"
                    />
                    <polygon
                      class="st361"
                      points="922.6,156.1 928.7,156.9 928.7,152.2 922.6,151.4 				"
                    />
                    <polygon
                      class="st361"
                      points="902.3,196.1 902.3,191.4 896.1,190.6 896.1,195.3 				"
                    />
                    <polygon
                      class="st361"
                      points="949,159.7 955.2,160.5 955.2,155.8 949,155 				"
                    />
                    <polygon
                      class="st361"
                      points="955.6,160.6 961.8,161.4 961.8,156.7 955.6,155.9 				"
                    />
                    <polygon
                      class="st361"
                      points="962.2,161.5 968.4,162.3 968.4,157.6 962.2,156.8 				"
                    />
                    <polygon
                      class="st361"
                      points="968.9,162.4 975,163.2 975,158.6 968.9,157.7 				"
                    />
                    <polygon
                      class="st361"
                      points="975.5,163.3 981.6,164.2 981.6,159.5 975.5,158.6 				"
                    />
                    <polygon
                      class="st361"
                      points="929.2,157 935.3,157.8 935.3,153.1 929.2,152.3 				"
                    />
                    <polygon
                      class="st361"
                      points="935.8,157.9 941.9,158.7 941.9,154 935.8,153.2 				"
                    />
                    <polygon
                      class="st361"
                      points="942.4,158.8 948.5,159.6 948.5,154.9 942.4,154.1 				"
                    />
                    <polygon
                      class="st361"
                      points="981.6,209.4 975.5,208.6 975.5,213.3 981.6,214.1 				"
                    />
                    <polygon
                      class="st361"
                      points="982.1,195.2 982.1,199.9 988.2,200.8 988.2,196.1 				"
                    />
                    <polygon
                      class="st361"
                      points="896.1,159.6 902.3,160.4 902.3,155.7 896.1,154.9 				"
                    />
                    <polygon
                      class="st361"
                      points="982.1,188.1 982.1,192.8 988.2,193.6 988.2,188.9 				"
                    />
                    <polygon
                      class="st361"
                      points="988.2,210.3 982.1,209.5 982.1,214.2 988.2,215 				"
                    />
                    <polygon
                      class="st361"
                      points="982.1,202.4 982.1,207.1 988.2,207.9 988.2,203.2 				"
                    />
                    <polygon
                      class="st361"
                      points="982.1,166.7 982.1,171.4 988.2,172.2 988.2,167.5 				"
                    />
                    <polygon
                      class="st361"
                      points="982.1,173.8 982.1,178.5 988.2,179.3 988.2,174.6 				"
                    />
                    <polygon
                      class="st361"
                      points="982.1,180.9 982.1,185.6 988.2,186.5 988.2,181.8 				"
                    />
                  </g>
                  <g>
                    <g>
                      <polyline
                        class="st375"
                        points="960.1,152.4 959.1,152.2 960,151.8 					"
                      />
                      <polyline
                        class="st376"
                        points="961.8,151 994.2,137 1031,142.1 					"
                      />
                      <polyline
                        class="st375"
                        points="1032,142.2 1033,142.3 1032.1,142.7 					"
                      />
                      <polyline
                        class="st376"
                        points="1030.2,143.5 997.8,157.6 961.1,152.5 					"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <ellipse
                        class="st224"
                        cx="996.8"
                        cy="147.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st226"
                        cx="996.8"
                        cy="147"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st377"
                        cx="996.8"
                        cy="147"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st228"
                        cx="996.8"
                        cy="146.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st378"
                        cx="996.8"
                        cy="146.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st231"
                        cx="996.8"
                        cy="146.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st233"
                        cx="996.8"
                        cy="146.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st234"
                        cx="996.8"
                        cy="146.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st279"
                        cx="996.8"
                        cy="146.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st237"
                        cx="996.8"
                        cy="146.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st379"
                        cx="996.8"
                        cy="146.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st239"
                        cx="996.8"
                        cy="146.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st380"
                        cx="996.8"
                        cy="146.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st243"
                        cx="996.8"
                        cy="146.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st284"
                        cx="996.8"
                        cy="146.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st245"
                        cx="996.8"
                        cy="146.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st381"
                        cx="996.8"
                        cy="146.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st249"
                        cx="996.8"
                        cy="146.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st382"
                        cx="996.8"
                        cy="146.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st288"
                        cx="996.8"
                        cy="146.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st383"
                        cx="996.8"
                        cy="146.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st384"
                        cx="996.8"
                        cy="146.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st385"
                        cx="996.8"
                        cy="146.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st386"
                        cx="996.8"
                        cy="146.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st387"
                        cx="996.8"
                        cy="146.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st388"
                        cx="996.8"
                        cy="146.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st389"
                        cx="996.8"
                        cy="146"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st390"
                        cx="996.8"
                        cy="146"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st391"
                        cx="996.8"
                        cy="146"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st392"
                        cx="996.8"
                        cy="145.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st298"
                        cx="996.8"
                        cy="145.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st393"
                        cx="996.8"
                        cy="145.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st394"
                        cx="996.8"
                        cy="145.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st395"
                        cx="996.8"
                        cy="145.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st396"
                        cx="996.8"
                        cy="145.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st302"
                        cx="996.8"
                        cy="145.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st303"
                        cx="996.8"
                        cy="145.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st304"
                        cx="996.8"
                        cy="145.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st305"
                        cx="996.8"
                        cy="145.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st397"
                        cx="996.8"
                        cy="145.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st306"
                        cx="996.8"
                        cy="145.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st307"
                        cx="996.8"
                        cy="145.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st308"
                        cx="996.8"
                        cy="145.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st398"
                        cx="996.8"
                        cy="145.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st399"
                        cx="996.8"
                        cy="145.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st400"
                        cx="996.8"
                        cy="145.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st401"
                        cx="996.8"
                        cy="145.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st402"
                        cx="996.8"
                        cy="145.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st403"
                        cx="996.8"
                        cy="145.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st404"
                        cx="996.8"
                        cy="145.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st405"
                        cx="996.8"
                        cy="145.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st316"
                        cx="996.8"
                        cy="145"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st317"
                        cx="996.8"
                        cy="145"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st318"
                        cx="996.8"
                        cy="145"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st406"
                        cx="996.8"
                        cy="144.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st407"
                        cx="996.8"
                        cy="144.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st320"
                        cx="996.8"
                        cy="144.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st321"
                        cx="996.8"
                        cy="144.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st408"
                        cx="996.8"
                        cy="144.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st323"
                        cx="996.8"
                        cy="144.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st324"
                        cx="996.8"
                        cy="144.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st409"
                        cx="996.8"
                        cy="144.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st410"
                        cx="996.8"
                        cy="144.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st326"
                        cx="996.8"
                        cy="144.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st327"
                        cx="996.8"
                        cy="144.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st328"
                        cx="996.8"
                        cy="144.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st411"
                        cx="996.8"
                        cy="144.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st330"
                        cx="996.8"
                        cy="144.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st331"
                        cx="996.8"
                        cy="144.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st412"
                        cx="996.8"
                        cy="144.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st413"
                        cx="996.8"
                        cy="144.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st414"
                        cx="996.8"
                        cy="144.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st334"
                        cx="996.8"
                        cy="144.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st415"
                        cx="996.8"
                        cy="144.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st336"
                        cx="996.8"
                        cy="144.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st337"
                        cx="996.8"
                        cy="144.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st416"
                        cx="996.8"
                        cy="144.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st417"
                        cx="996.8"
                        cy="144"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st339"
                        cx="996.8"
                        cy="144"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st340"
                        cx="996.8"
                        cy="143.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st341"
                        cx="996.8"
                        cy="143.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st418"
                        cx="996.8"
                        cy="143.9"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st343"
                        cx="996.8"
                        cy="143.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st419"
                        cx="996.8"
                        cy="143.8"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st420"
                        cx="996.8"
                        cy="143.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st345"
                        cx="996.8"
                        cy="143.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st346"
                        cx="996.8"
                        cy="143.7"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st347"
                        cx="996.8"
                        cy="143.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st421"
                        cx="996.8"
                        cy="143.6"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st348"
                        cx="996.8"
                        cy="143.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st350"
                        cx="996.8"
                        cy="143.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st422"
                        cx="996.8"
                        cy="143.5"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st423"
                        cx="996.8"
                        cy="143.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st424"
                        cx="996.8"
                        cy="143.4"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st353"
                        cx="996.8"
                        cy="143.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st354"
                        cx="996.8"
                        cy="143.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st425"
                        cx="996.8"
                        cy="143.3"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st366"
                        cx="996.8"
                        cy="143.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st357"
                        cx="996.8"
                        cy="143.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st426"
                        cx="996.8"
                        cy="143.2"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st427"
                        cx="996.8"
                        cy="143.1"
                        rx="6"
                        ry="2.2"
                      />
                      <ellipse
                        class="st184"
                        cx="996.8"
                        cy="143.1"
                        rx="6"
                        ry="2.2"
                      />
                    </g>
                    <ellipse
                      class="st184"
                      cx="996.8"
                      cy="143.1"
                      rx="6"
                      ry="2.2"
                    />
                    <line
                      class="st428"
                      x1="993.4"
                      y1="116.4"
                      x2="990.8"
                      y2="143.3"
                    />
                    <line
                      class="st428"
                      x1="996.8"
                      y1="145.3"
                      x2="996.8"
                      y2="117.6"
                    />
                    <line
                      class="st428"
                      x1="1002.8"
                      y1="143.3"
                      x2="1000.3"
                      y2="116.4"
                    />
                    <g>
                      <ellipse
                        class="st326"
                        cx="996.8"
                        cy="117.3"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st326"
                        cx="996.8"
                        cy="117.3"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st429"
                        cx="996.8"
                        cy="117.3"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st327"
                        cx="996.8"
                        cy="117.3"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st430"
                        cx="996.8"
                        cy="117.3"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st328"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st431"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st431"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st432"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st433"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st433"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st330"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st434"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st435"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st331"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st436"
                        cx="996.8"
                        cy="117.2"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st412"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st412"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st437"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st413"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st333"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st333"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st414"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st438"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st334"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st415"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st415"
                        cx="996.8"
                        cy="117.1"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st415"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st439"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st439"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st336"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st440"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st337"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st337"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st337"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st416"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st416"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st338"
                        cx="996.8"
                        cy="117"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st417"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st441"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st339"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st442"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st340"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st340"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st443"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st443"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st444"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st444"
                        cx="996.8"
                        cy="116.9"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st418"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st342"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st342"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st343"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st343"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st419"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st344"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st344"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st420"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st420"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st345"
                        cx="996.8"
                        cy="116.8"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st345"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st445"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st446"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st346"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st447"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st347"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st448"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st448"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st348"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st348"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st348"
                        cx="996.8"
                        cy="116.7"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st349"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st449"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st350"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st350"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st422"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st422"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st422"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st450"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st423"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st352"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st424"
                        cx="996.8"
                        cy="116.6"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st424"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st451"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st353"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st354"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st354"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st452"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st453"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st425"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st355"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st366"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st356"
                        cx="996.8"
                        cy="116.5"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st356"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st454"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st357"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st357"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st426"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st455"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st358"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st427"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st184"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                      <ellipse
                        class="st184"
                        cx="996.8"
                        cy="116.4"
                        rx="3.4"
                        ry="1.3"
                      />
                    </g>
                    <ellipse
                      class="st184"
                      cx="996.8"
                      cy="116.4"
                      rx="3.4"
                      ry="1.3"
                    />
                    <polygon
                      class="st428"
                      points="996.8,141.3 991.2,138.8 996.8,136.4 1002.4,138.8 				"
                    />
                    <polygon
                      class="st428"
                      points="996.8,136.8 991.6,134.6 996.8,132.3 1002,134.6 				"
                    />
                    <polygon
                      class="st428"
                      points="996.8,132.4 992,130.3 996.8,128.2 1001.6,130.3 				"
                    />
                    <polygon
                      class="st428"
                      points="996.8,127.9 992.5,126 996.8,124.1 1001.2,126 				"
                    />
                    <polygon
                      class="st428"
                      points="996.8,123.5 992.9,121.8 996.8,120 1000.8,121.8 				"
                    />
                    <line
                      class="st456"
                      x1="996.8"
                      y1="116.4"
                      x2="996.8"
                      y2="111.2"
                    />
                    <circle class="st10" cx="996.8" cy="111" r="0.8" />
                    <g id="uZYL1A_3_">
                      <g>
                        <path
                          class="st1"
                          d="M988.1,116.2C988.1,116.2,988.1,116.2,988.1,116.2c-0.1,0.1-0.3,0.1-0.4,0c-2.6-2.7-2.8-7.4,0-10.3
            c0.1-0.1,0.3-0.1,0.4,0l0,0c0.1,0.1,0.1,0.3,0,0.4c-1.2,1.3-1.9,2.9-1.9,4.8c0,1.8,0.6,3.4,1.9,4.8
            C988.2,115.9,988.2,116.1,988.1,116.2z"
                        />
                        <path
                          class="st1"
                          d="M1005.5,116.2C1005.5,116.2,1005.5,116.2,1005.5,116.2c-0.1-0.1-0.1-0.3,0-0.4c1.2-1.3,1.9-2.9,1.9-4.8
            c0-1.8-0.6-3.4-1.9-4.8c-0.1-0.1-0.1-0.3,0-0.4c0,0,0,0,0,0c0.1-0.1,0.3-0.1,0.4,0c2.6,2.8,2.8,7.4,0,10.3
            C1005.8,116.3,1005.6,116.3,1005.5,116.2z"
                        />
                        <path
                          class="st1"
                          d="M989.4,107.1C989.4,107.1,989.4,107.1,989.4,107.1c0.1,0.1,0.1,0.3,0,0.4c-0.9,1-1.3,2.2-1.3,3.5
            c0,1.3,0.5,2.5,1.3,3.5c0.1,0.1,0.1,0.3,0,0.4c0,0,0,0,0,0c-0.1,0.1-0.3,0.1-0.4,0c-2-2.1-2-5.6,0-7.8
            C989.1,107,989.3,107,989.4,107.1z"
                        />
                        <path
                          class="st1"
                          d="M1004.2,114.9C1004.2,114.9,1004.2,114.9,1004.2,114.9c-0.1-0.1-0.1-0.3,0-0.4c1.8-2,1.7-5.1,0-7
            c-0.1-0.1-0.1-0.3,0-0.4c0,0,0,0,0,0c0.1-0.1,0.3-0.1,0.4,0c1.9,1.9,2.1,5.5,0,7.8C1004.5,115,1004.3,115,1004.2,114.9z"
                        />
                        <path
                          class="st1"
                          d="M1003,113.7C1003,113.7,1003,113.7,1003,113.7c-0.1-0.1-0.1-0.3,0-0.4c0.5-0.7,0.8-1.4,0.8-2.3
            c0-0.9-0.3-1.6-0.8-2.3c-0.1-0.1-0.1-0.3,0-0.4c0,0,0,0,0,0c0.1-0.1,0.3-0.1,0.4,0c1.3,1.3,1.4,3.8,0,5.3
            C1003.3,113.8,1003.1,113.8,1003,113.7z"
                        />
                        <path
                          class="st1"
                          d="M990.6,108.3C990.6,108.3,990.6,108.3,990.6,108.3c0.1,0.1,0.1,0.3,0,0.4c-1.2,1.5-1.2,3.1,0,4.6
            c0.1,0.1,0.1,0.3,0,0.4c0,0,0,0,0,0c-0.1,0.1-0.3,0.1-0.4,0c-1.3-1.4-1.4-3.8,0-5.3C990.3,108.2,990.5,108.2,990.6,108.3z"
                        />
                      </g>
                    </g>
                  </g>
                </g>
                <circle class="st181" cx="983.9" cy="147" r="58.8" />
              </g>
            </g>
          </svg>
        </div>
      ) : null}
    </section>
  );
};

export default CoreNetworkSVG;
